/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 255);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "appendParamObjectToURL", function() { return appendParamObjectToURL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "appendQueryStringToURL", function() { return appendQueryStringToURL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "assignWithDefaults", function() { return assignWithDefaults; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "binaryFind", function() { return binaryFind; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "camelCase", function() { return camelCase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "capitalize", function() { return capitalize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clamp", function() { return clamp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clone", function() { return clone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "compareNumbers", function() { return compareNumbers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "compareStrings", function() { return compareStrings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "composeAsync", function() { return composeAsync; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "smartCompare", function() { return smartCompare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deepEqual", function() { return deepEqual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deepInclude", function() { return deepInclude; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deepUnique", function() { return deepUnique; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "diffObjects", function() { return diffObjects; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "escapeRegExp", function() { return escapeRegExp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "flatten", function() { return flatten; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "formatConjunction", function() { return formatConjunction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "formatFileSize", function() { return formatFileSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "formatUSD", function() { return formatUSD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLocale", function() { return getLocale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "numberToLocaleString", function() { return numberToLocaleString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getIn", function() { return getIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "kebabCase", function() { return kebabCase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isPromise", function() { return isPromise; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isEmpty", function() { return isEmpty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadImage", function() { return loadImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadImages", function() { return loadImages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapByID", function() { return mapByID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapcat", function() { return mapcat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mergePropertiesWithDefaults", function() { return mergePropertiesWithDefaults; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "objFromQueryString", function() { return objFromQueryString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "objToQueryString", function() { return objToQueryString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "errorSensitiveFetch", function() { return errorSensitiveFetch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "postJSON", function() { return postJSON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "patchJSON", function() { return patchJSON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ping", function() { return ping; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "poll", function() { return poll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "precisionRound", function() { return precisionRound; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "randomInt", function() { return randomInt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "range", function() { return range; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "request", function() { return request; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "runAsync", function() { return runAsync; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeKeys", function() { return removeKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeEmptyKeys", function() { return removeEmptyKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectKeys", function() { return selectKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "shuffle", function() { return shuffle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "stableSort", function() { return stableSort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "timeDifference", function() { return timeDifference; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "type", function() { return type; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "wait", function() { return wait; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "timeout", function() { return timeout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unique", function() { return unique; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isFunction", function() { return isFunction; });
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var appendParamObjectToURL = function appendParamObjectToURL(url, params) {
  return appendQueryStringToURL(url, objToQueryString(params));
};

var appendQueryStringToURL = function appendQueryStringToURL(url, queryString) {
  if (queryString === "") return url;

  var separator = url.includes("?") ? "&" : "?";

  return "" + url + separator + queryString;
};

// If any key in the `defaults` object doesn't exist in `target`, the key is
// merged. Additional `sources` object arguments are merged into `target`, but
// only the keys that exist in `defaults`.
var assignWithDefaults = function assignWithDefaults(target, defaults) {
  for (var _len = arguments.length, sources = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    sources[_key - 2] = arguments[_key];
  }

  Object.keys(defaults).forEach(function (key) {
    if (!target.hasOwnProperty(key) || target[key] === undefined) {
      target[key] = defaults[key];
    }

    sources.filter(function (source) {
      return source != null && source.hasOwnProperty(key) && source[key] !== undefined;
    }).forEach(function (source) {
      return target[key] = source[key];
    });
  });

  return target;
};

/**
 * Takes an ordered array and returns the first value where fn(value) returns true.
 */
var binaryFind = function binaryFind(arr, fn) {
  var high = arr.length + 1;
  var low = 0;
  while (low + 1 < high) {
    var mid = low + (high - low >> 1);
    if (fn(arr[mid])) {
      high = mid;
    } else {
      low = mid;
    }
  }

  return arr[high];
};

var camelCase = function camelCase(str) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$isSuffix = _ref.isSuffix,
      isSuffix = _ref$isSuffix === undefined ? false : _ref$isSuffix;

  return str.split(/[-_]/g).map(function (part, i) {
    return i === 0 && !isSuffix ? part.toLowerCase() : capitalize(part.toLowerCase());
  }).join("");
};

var capitalize = function capitalize(str) {
  if (str === "") return str;

  return "" + str[0].toUpperCase() + str.slice(1);
};

var clamp = function clamp(x, a, b) {
  if (a > b) {
    return clamp(x, b, a);
  }

  if (x < a) {
    return a;
  }

  if (x > b) {
    return b;
  }

  return x;
};

var clone = function clone(obj) {
  if (obj === undefined) return undefined;

  return JSON.parse(JSON.stringify(obj));
};

var compareNumbers = function compareNumbers(a, b) {
  if (a == null && b == null) return 0;else if (a == null) return -1;else if (b == null) return 1;

  return a - b;
};

var compareStrings = function compareStrings(a, b) {
  return (a || "").trim().toLowerCase().localeCompare((b || "").trim().toLowerCase());
};

/**
 * Composes functions such that any returned Promise is resolved before the next invocation.
 * @param  {Function[]} funcs - A list of potentially async functions that each take a single param. Any null/
 * undefined values are ignored.
 */
var composeAsync = function composeAsync() {
  for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    funcs[_key2] = arguments[_key2];
  }

  return function (arg) {
    var res = Promise.resolve(arg);

    var _loop = function _loop(i) {
      var f = funcs[i];
      if (f == null) {
        return "continue";
      }
      res = res.then(function (arg) {
        return f(arg);
      });
    };

    for (var i = funcs.length - 1; i >= 0; i--) {
      var _ret = _loop(i);

      if (_ret === "continue") continue;
    }
    return res;
  };
};

var smartCompare = function smartCompare(a, b) {
  var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref2$reverse = _ref2.reverse,
      reverse = _ref2$reverse === undefined ? false : _ref2$reverse;

  if (a === b) return 0;
  if (type(a) !== type(b) && b != null && a != null) {
    throw new Error("Don't know how to compare type " + type(a) + " with type " + type(b) + "!");
  }
  var compareType = a != null ? type(a) : type(b);

  var _ref3 = reverse ? [b, a] : [a, b],
      _ref4 = _slicedToArray(_ref3, 2),
      valueA = _ref4[0],
      valueB = _ref4[1];

  switch (compareType) {
    case "string":
      return compareStrings(valueA, valueB);
    case "number":
      return compareNumbers(valueA, valueB);
    default:
      // TODO(oscar): Add more types for comparison such as Dates.
      throw new Error("Missing method for comparing type " + compareType);
  }
};

/**
 * Recursively compares 2 JS objects.
 * @param {any} a
 * @param {any} b
 * @param {Object} options
 * @param {boolean} options.toJSON - Uses clone() in order to compare objects as
 * their JSON representations.
 * Useful when comparing plain objects to class instances.
 */
var deepEqual = function deepEqual(a, b) {
  var _ref5 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref5$toJSON = _ref5.toJSON,
      toJSON = _ref5$toJSON === undefined ? false : _ref5$toJSON;

  if (a === b) {
    return true;
  }

  var compareA = toJSON ? clone(a) : a;
  var compareB = toJSON ? clone(b) : b;
  var tA = type(compareA);
  var tB = type(compareB);

  if (tA === "array" && tB === "array") {
    if (compareA.length !== compareB.length) return false;

    for (var i = 0; i < compareA.length; i++) {
      if (!deepEqual(compareA[i], compareB[i])) return false;
    }

    return true;
  }

  if (tA === "set" && tB === "set") {
    if (compareA.size !== compareB.size) return false;

    var bShallowCopy = new Set(compareB);
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      aLoop: for (var _iterator = compareA[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var aElement = _step.value;

        // First check if there's an equivalent reference in the two sets before checking for deep equality,
        // since the latter is very inefficient.
        if (bShallowCopy.has(aElement)) {
          bShallowCopy.delete(aElement);
          continue;
        }

        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = bShallowCopy[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var bElement = _step2.value;

            if (deepEqual(aElement, bElement)) {
              bShallowCopy.delete(bElement);
              continue aLoop;
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        return false;
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return true;
  }

  if (tA === "object" && tB === "object") {
    for (var k in compareA) {
      if (!(k in compareB)) return false;
    }

    for (var _k in compareB) {
      if (!(_k in compareA) || !deepEqual(compareA[_k], compareB[_k])) return false;
    }

    return true;
  }

  return compareA === compareB;
};

var deepInclude = function deepInclude(parent, child) {
  if (type(parent.some) === "function") {
    return parent.some(function (obj) {
      return deepEqual(obj, child);
    });
  } else if (type(parent) === "object") {
    return Object.values(parent).some(function (obj) {
      return deepEqual(obj, child);
    });
  }
  return false;
};

var deepUnique = function deepUnique(arr) {
  var index = 0;

  var _loop2 = function _loop2() {
    var item = arr[index];
    arr = arr.slice(0, index + 1).concat(arr.slice(index).filter(function (currItem) {
      return !deepEqual(item, currItem);
    }));
    index += 1;
  };

  while (index < arr.length) {
    _loop2();
  }

  return arr;
};

/**
 * @param {Object} a
 * @param {Object} b
 * @param {boolean} includeAKeys
 * @returns {Object} - An object containing keys in `b` if the values differ
 * from those in `a`. If `includeAKeys` is true, the keys in `a` that are NOT in
 * `b` are also included.
 */
var diffObjects = function diffObjects(a, b) {
  var includeAKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var result = {};
  for (var k in b) {
    if (!deepEqual(a[k], b[k])) {
      result[k] = b[k];
    }
  }
  if (includeAKeys) {
    for (var _k2 in a) {
      if (!(_k2 in b)) {
        result[_k2] = null;
      }
    }
  }

  return result;
};

// https://stackoverflow.com/questions/3446170/escape-string-for-use-in-javascript-regex
var escapeRegExp = function escapeRegExp(str) {
  return str.replace(/[-[\]/{}()*+?.\\^$|]/g, "\\$&");
};

var flatten = function flatten(arr) {
  return [].concat.apply([], arr);
};

/**
 * Takes a list of words and joins them via coordinating conjunction grammar rules. Oxford comma is mandatory.
 * @param {String[]} words
 */
var formatConjunction = function formatConjunction(words) {
  var conjunction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "and";

  var wc = words.length;
  if (wc <= 2) {
    return words.join(" " + conjunction + " ");
  } else {
    return [].concat(_toConsumableArray(words.slice(0, wc - 1)), [conjunction + " " + words[wc - 1]]).join(", ");
  }
};

var formatFileSize = function formatFileSize(size) {
  // NOTE: Math.log10 is not available in every browser and Math.log / Math.LN10
  // is unreliable.
  var thousands = Math.floor((("" + size).length - 1) / 3);
  return "" + Math.round(size / Math.pow(10, 3 * thousands)) + "BKMGTP"[thousands];
};

var formatUSD = function formatUSD(val) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  options = Object.assign({
    style: "currency",
    currency: "USD"
  }, options);

  return type(val) !== "number" ? null : val.toLocaleString("en", options);
};

var getLocale = function getLocale() {
  var _window = window,
      navigator = _window.navigator;

  if (navigator == null) return null;
  return navigator.languages && navigator.languages.length ? navigator.languages[0] : navigator.language;
};

/**
 * This function is a wrapper for Number.toLocalString() however it tries to use
 * the device's language. If all else fails, it uses "en".
 *
 * TODO(oscar): Fix the Intl polyfill we use, so there's no issue using
 * `undefined` as the locale.
 */
var numberToLocaleString = function numberToLocaleString(n, options, locale) {
  var f = function f(locale) {
    try {
      return Number(n).toLocaleString(locale, options);
    } catch (e) {}
  };
  return f(locale) || f() || f(getLocale()) || f("en");
};

var getIn = function getIn(m, ks, d) {
  if (m == null) return d;
  if (ks.length === 1) {
    return m[ks[0]];
  }

  return getIn(m[ks[0]], ks.slice(1));
};

var kebabCase = function kebabCase(str) {
  // A "-" will be inserted before every capital letter, so make sure the first
  // character isn't capitalized.
  str = str.charAt(0).toLowerCase() + str.slice(1);
  // Convert camel case to kebab case.
  str = str.replace(/[A-Z]/g, "-$&").toLowerCase();
  // Convert snake case to kebab case.
  str = str.replace(/_/g, "-");

  return str;
};

var isPromise = function isPromise(obj) {
  return Promise.resolve(obj) === obj;
};

var isEmpty = function isEmpty(obj) {
  return obj == null || Object.keys(obj).length === 0 &&
  // Needed for iterables like `Set`.
  Array.from(obj).length === 0 && (obj.size || 0) === 0;
};

var loadImage = function loadImage(url) {
  var crossOrigin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!url) return Promise.reject(new Error("No image URL provided"));

  return new Promise(function (resolve, reject) {
    var img = new Image();
    img.crossOrigin = crossOrigin;
    img.addEventListener("load", function () {
      return resolve(img);
    });
    img.addEventListener("error", reject);
    img.src = url;
    if (img.complete) {
      resolve(img);
    }
  });
};

var loadImages = function loadImages(urls) {
  var crossOrigin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return Promise.all(urls.filter(function (url) {
    return url != null;
  }).map(function (url) {
    return loadImage(url, crossOrigin);
  }));
};

var mapByID = function mapByID(arr) {
  var fn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  return arr.reduce(function (map, item) {
    map[item.id] = fn != null ? fn(item) : item;
    return map;
  }, {});
};

var mapcat = function mapcat(arr, fn) {
  return [].concat.apply([], arr.map(fn));
};

// Like `Object.assign`, merges subsequent object arguments into the first
// object argument `defaults`, but only keys that exist in `defaults`.
// Unlike `Object.assign`, does not modify the first argument, but returns a
// shallow clone instead.
var mergePropertiesWithDefaults = function mergePropertiesWithDefaults(defaults) {
  for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    args[_key3 - 1] = arguments[_key3];
  }

  if (args.length === 0) return defaults;

  var target = Object.assign(defaults);
  var keys = Object.keys(target);

  args.forEach(function (source) {
    if (source == null) return;

    keys.forEach(function (key) {
      if (source.hasOwnProperty(key) && source[key] !== undefined) {
        target[key] = source[key];
      }
    });
  });

  return target;
};

var objFromQueryString = function objFromQueryString() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : location.search.slice(1);

  return str.split("&").reduce(function (acc, part) {
    var _part$split$map = part.split("=", 2).map(decodeURIComponent),
        _part$split$map2 = _slicedToArray(_part$split$map, 2),
        key = _part$split$map2[0],
        value = _part$split$map2[1];

    if (key != null && value != null) {
      acc[key] = value;
    }

    return acc;
  }, {});
};

var objToQueryString = function objToQueryString(obj) {
  return Object.keys(obj).filter(function (key) {
    return obj[key] != null;
  }).map(function (key) {
    return encodeURIComponent(key) + "=" + encodeURIComponent(obj[key]);
  }).join("&");
};

/**
 * Given a `Promise` that should resolve with a `Response` (e.g. a `Promise` returned by `fetch`), returns
 * a new Promise that will reject if 1) the original `Promise` rejects, 2) the original `Promise` resolves
 * with something that's not a `Response`, or 3) the original response had an error status.
 */
var wrapResponsePromise = function wrapResponsePromise(responsePromise) {
  return new Promise(function (resolve, reject) {
    return responsePromise.then(function (response) {
      if (!(response instanceof Response && response.ok)) {
        reject(response);
        return;
      }

      resolve(response);
    }).catch(reject);
  });
};

/**
 * Like `fetch` but returns a `Promise` that rejects if `!response.ok`. This allows calling code to handle
 * non-ok responses (e.g. 404s and 500s) using `Promise.catch`.
 */
var errorSensitiveFetch = function errorSensitiveFetch() {
  return wrapResponsePromise(fetch.apply(undefined, arguments));
};

var postJSON = function postJSON(url, json, options) {
  return makeJSONRequest(url, json, "POST", options);
};

var patchJSON = function patchJSON(url, json, options) {
  return makeJSONRequest(url, json, "PATCH", options);
};

/**
 * Sends a `fetch` request to `url` using the given `method` (e.g. "GET", "POST", "PATCH") and returns a
 * `Promise` that resolves with a `Response`. If `options.rejectOnErrorResponse === true`, the returned
 * `Promise` will reject if the sever returns an error response.
 */
function makeJSONRequest(url, json, method) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var _options$rejectOnErro = options.rejectOnErrorResponse,
      rejectOnErrorResponse = _options$rejectOnErro === undefined ? false : _options$rejectOnErro;

  var fetchPromise = fetch(url, {
    body: JSON.stringify(json),
    credentials: "same-origin",
    headers: { "Content-Type": "application/json; charset=utf-8" },
    method: method
  });
  if (!rejectOnErrorResponse) {
    return fetchPromise;
  }
  return wrapResponsePromise(fetchPromise);
}

var ping = function ping(url) {
  var img = new Image();
  img.src = url;
};

// Polls a `url` for up to `timeoutMS`. Assumes the response is a JSON object
// with keys { state, value } where the values for `state` are one of
// ["success", "failed", "timeout"].
var poll = function poll(url, timeoutMS) {
  var timedOut = false;
  setTimeout(function () {
    return timedOut = true;
  }, timeoutMS);

  var request = function request() {
    if (timedOut) {
      return Promise.reject(new Error("poll exceeded timeout duration"));
    }

    return fetch(url, { credentials: "same-origin" }).then(function (response) {
      return response.json();
    }).then(function (_ref6) {
      var state = _ref6.state,
          value = _ref6.value;

      switch (state) {
        case "success":
          return value;
        case "failed":
          throw new Error("poll received failed response with value: " + value);
        case "timeout":
          return request();
        default:
          throw new Error("poll received response with unknown state: " + state);
      }
    });
  };

  return request();
};

var precisionRound = function precisionRound(number, precision) {
  var factor = Math.pow(10, precision);

  return Math.round(number * factor) / factor;
};

var randomInt = function randomInt(low, high) {
  return low + Math.floor(Math.random() * (high - low));
};

// Returns an array of integers from [start, stop) (i.e. exclusive of stop).
// Special case: if start === stop, return array with start as the only
// element.
var range = function range(start, stop) {
  var step = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

  if (start === stop) return [start];

  if (stop - start < 0 !== step < 0) {
    throw new Error("Invalid call to range: range(" + start + ", " + stop + ", " + step + ")");
  }

  return Array((stop - start) / step | 0).fill(null).map(function (_, i) {
    return start + i * step;
  });
};

var request = function request(method, url) {
  var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var body = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  return new Promise(function (resolve, reject) {
    var req = new XMLHttpRequest();
    req.onreadystatechange = function () {
      if (req.readyState === 4 && req.status === 200) {
        resolve(req);
      }
    };
    req.addEventListener("load", resolve.bind(null, req));
    req.addEventListener("error", reject.bind(null, req));
    req.open(method.toUpperCase(), url);
    Object.keys(headers).forEach(function (key) {
      req.setRequestHeader(key, headers[key]);
    });
    req.send(body);
  });
};

var runAsync = function runAsync(fn) {
  setTimeout(fn, 0);
};

var removeKeys = function removeKeys(source, keys) {
  if (source == null) return {};

  return Object.keys(source).filter(function (key) {
    return !keys.includes(key);
  }).reduce(function (target, key) {
    target[key] = source[key];

    return target;
  }, {});
};

/** Remove keys if their value is empty.  */
var removeEmptyKeys = function removeEmptyKeys(source) {
  return selectKeys(source, function (_, val) {
    return !isEmpty(val);
  });
};

var selectKeys = function selectKeys(source, keys) {
  if (source == null) return {};

  switch (type(keys)) {
    case "array":
      return keys.reduce(function (target, key) {
        if (source.hasOwnProperty(key)) {
          target[key] = source[key];
        }

        return target;
      }, {});
    case "function":
      return Object.keys(source).reduce(function (target, key) {
        if (keys(key, source[key])) {
          target[key] = source[key];
        }

        return target;
      }, {});
  }
};

/**
 * Reorders items randomly into a new Array.
 * @param {Iterable} arr
 * @returns {Array}
 */
var shuffle = function shuffle(arr) {
  var result = [].concat(_toConsumableArray(arr));
  for (var i = result.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    var _ref7 = [result[j], result[i]];
    result[i] = _ref7[0];
    result[j] = _ref7[1];
  }
  return result;
};

// Like `Array.sort()`, but maintains the relative order of array items with
// equal sort values and does not mutate the original array.
var stableSort = function stableSort(arr, sortFn) {
  var index = arr.reduce(function (agg, item, i) {
    agg.set(item, i);

    return agg;
  }, new Map());

  return arr.slice().sort(function (a, b) {
    return sortFn(a, b) || index.get(a) - index.get(b);
  });
};

var timeDifference = function timeDifference(a, b) {
  var msPerSecond = 1000,
      msPerMinute = msPerSecond * 60,
      msPerHour = msPerMinute * 60,
      msPerDay = msPerHour * 24,
      msPerWeek = msPerDay * 7,
      msPerMonth = msPerWeek * 4,
      msPerYear = msPerMonth * 13,
      elapsed = Math.abs(a - b);
  if (a <= b && elapsed < 1000 * 10) {
    return "just now";
  } else {
    var val = void 0,
        units = void 0;
    if (elapsed < msPerMinute) {
      val = Math.round(elapsed / msPerSecond);
      units = "second";
    } else if (elapsed < msPerHour) {
      val = Math.round(elapsed / msPerMinute);
      units = "minute";
    } else if (elapsed < msPerDay) {
      val = Math.round(elapsed / msPerHour);
      units = "hour";
    } else if (elapsed < msPerWeek) {
      val = Math.round(elapsed / msPerDay);
      units = "day";
    } else if (elapsed < msPerMonth) {
      val = Math.round(elapsed / msPerWeek);
      units = "week";
    } else if (elapsed < msPerYear) {
      val = Math.round(elapsed / msPerMonth);
      units = "month";
    } else {
      val = Math.round(elapsed / msPerYear);
      units = "year";
    }

    return [val, "" + units + (val === 1 ? "" : "s"), a < b ? "ago" : "from now"].join(" ");
  }
};

var type = function type(object) {
  return {}.toString.call(object).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
};

/** Returns a Promise that resolves after `ms` ms. */
var wait = function wait(ms) {
  return new Promise(function (resolve) {
    setTimeout(resolve, ms);
  });
};

/** Returns a Promise that rejects after `ms` ms. */
var timeout = function timeout(ms) {
  return new Promise(function (_, reject) {
    setTimeout(function () {
      return reject(new Error("Promise timed out after " + ms + "ms"));
    }, ms);
  });
};

var unique = function unique(arr) {
  return arr.filter(function (el, i) {
    return arr.indexOf(el) === i;
  });
};

var isFunction = function isFunction(object) {
  return type(object) === "function";
};

/***/ }),

/***/ 1:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addOneTimeListener", function() { return addOneTimeListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "animationEndPromise", function() { return animationEndPromise; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "transitionEndPromise", function() { return transitionEndPromise; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "runTransitionSequence", function() { return runTransitionSequence; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "appendChildren", function() { return appendChildren; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "copyToClipboard", function() { return copyToClipboard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createElement", function() { return createElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "empty", function() { return empty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchHTML", function() { return fetchHTML; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "firstAncestor", function() { return firstAncestor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fragmentFromString", function() { return fragmentFromString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "forceReflow", function() { return forceReflow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "generateSnippetMap", function() { return generateSnippetMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCSSProperty", function() { return getCSSProperty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getElementsByClass", function() { return getElementsByClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getRelativeBoundingClientRect", function() { return getRelativeBoundingClientRect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAggregateBoundingClientRect", function() { return getAggregateBoundingClientRect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFontSizeToFit", function() { return getFontSizeToFit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFontSizeToFitLines", function() { return getFontSizeToFitLines; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "indexOf", function() { return indexOf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "imageIsRendered", function() { return imageIsRendered; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "off", function() { return off; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "on", function() { return on; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onAnimationsComplete", function() { return onAnimationsComplete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseCSSLength", function() { return parseCSSLength; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "prependChild", function() { return prependChild; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "replaceStyle", function() { return replaceStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "scrollIntoView", function() { return scrollIntoView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "strToElement", function() { return strToElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "strToStyle", function() { return strToStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "writeToIframe", function() { return writeToIframe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "preparetagHTML", function() { return preparetagHTML; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "appendImpressionTags", function() { return appendImpressionTags; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var addOneTimeListener = function addOneTimeListener(el, eventName, fn) {
  var ignoreBubbling = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  var listener = function listener(event) {
    if (ignoreBubbling && event.target !== el) return;

    el.removeEventListener(eventName, listener);
    fn(event);
  };
  el.addEventListener(eventName, listener);
};

/** Responds to the first event triggered. Useful for polyfilling webkit prefixed events. */
var eventRacePromise = function eventRacePromise(el, events) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      timeout = _ref.timeout,
      _ref$matchTarget = _ref.matchTarget,
      matchTarget = _ref$matchTarget === undefined ? false : _ref$matchTarget;

  var eventsString = [].concat(events).join(" ");
  return new Promise(function (resolve) {
    var callbackRun = false;
    var callback = function callback() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (callbackRun || matchTarget && el !== args[0].target) return;
      callbackRun = true;
      resolve.apply(undefined, args);
      off(el, _defineProperty({}, eventsString, callback));
    };

    on(el, _defineProperty({}, eventsString, callback));
    if (timeout != null) {
      setTimeout(function () {
        return callback({ message: "Promise timed out." });
      }, timeout);
    }
  });
};

var animationEndPromise = function animationEndPromise(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return eventRacePromise(el, "animationend webkitAnimationEnd", options);
};

var transitionEndPromise = function transitionEndPromise(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return eventRacePromise(el, "transitionend webkitTransitionEnd", options);
};

/**
 * Given:
 *   - `el` - a DOM node
 *   - `transitions` - an array where each element is either 1) a function, or 2) an object of style property
 *     names to values
 * this sequentially 1) runs the function and waits for the Promise returned by the function to resolve (if
 * the function returns a Promise) before moving onto the next step, or 2) applies the styles to `el` and
 * waits for a `transitionend` event before moving onto the next step. Returns a Promise. `timeoutMS` is
 * an optional duration (in ms) after which the next transition should be run even if the previous transition
 * has not completed or if the previous function's returned promise has not resolved.
 */
var runTransitionSequence = function runTransitionSequence(el, transitions) {
  var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref2$timeoutMS = _ref2.timeoutMS,
      timeoutMS = _ref2$timeoutMS === undefined ? null : _ref2$timeoutMS,
      _ref2$continueFn = _ref2.continueFn,
      continueFn = _ref2$continueFn === undefined ? function () {
    return true;
  } : _ref2$continueFn;

  return transitions.reduce(function (prevTransitionEndPromise, thisTransition) {
    return prevTransitionEndPromise.finally(function () {
      if (!continueFn()) {
        return Promise.resolve();
      }

      var currentTransitionEndPromise = void 0;
      if (Object(__WEBPACK_IMPORTED_MODULE_0__utils__["isFunction"])(thisTransition)) {
        currentTransitionEndPromise = thisTransition();
      } else {
        currentTransitionEndPromise = transitionEndPromise(el);
        Object.assign(el.style, thisTransition);
      }

      if (timeoutMS == null) {
        return currentTransitionEndPromise;
      }

      return Promise.race([Object(__WEBPACK_IMPORTED_MODULE_0__utils__["timeout"])(timeoutMS), currentTransitionEndPromise]);
    });
  }, Promise.resolve());
};

var appendChildren = function appendChildren(node, children) {
  var fragment = document.createDocumentFragment();

  children.forEach(function (child) {
    if (!child) return;

    fragment.appendChild(child instanceof Node ? child : createElement(child));
  });

  node.appendChild(fragment);
};

var copyToClipboard = function copyToClipboard(text, multiline) {
  var elemType = multiline ? "textarea" : "input";
  var el = document.createElement(elemType);
  document.body.appendChild(el);
  el.value = text;
  el.select();
  document.execCommand("copy");
  el.remove();
};

/**
 * @param {Object} elementConfig A map of options specifying a new Element.
 * @param {String} [elementConfig.namespace = null] A namespace URI to associate with the new element.
 * See https://developer.mozilla.org/en-US/docs/Web/API/Document/createElementNS for details.
 * @param {String} [elementConfig.tagName = "div"] The tag name determining the result
 * Element's type. Defaults to "div".
 * @param {String[]} [elementConfig.classList = []] A list of classes. Falsy values
 * are ignored. Defaults to [].
 * @param {{}} [elementConfig.style = {}] A map of style settings to merge into the result
 * Element's style. Defaults to {}.
 * @param {{}} [elementConfig.attributes = {}] A map of attributes to set on the result
 * Element. Defaults to {}.
 * @param {{}} [elementConfig.data = {}] A map of data to merge into the result Element's
 * dataset. Defaults to {}.
 * @param {({}|Element)[]} [elementConfig.children = []] An array of Elements or
 * elementConfigs to append as children. Falsy values are ignored. Defaults to [].
 * @param {{}} [elementConfig.eventHandlers = {}] A map from event names to handlers,
 * which will all be assigned to listen on the result Element. Defaults to {}.
 * @returns {HTMLElement} An Element object with properties corresponding to the parameters.
 */
var createElement = function createElement(elementConfig) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__utils__["type"])(elementConfig) === "string" || Object(__WEBPACK_IMPORTED_MODULE_0__utils__["type"])(elementConfig) === "number") {
    return document.createTextNode(elementConfig);
  }

  var _elementConfig$namesp = elementConfig.namespace,
      namespace = _elementConfig$namesp === undefined ? null : _elementConfig$namesp,
      _elementConfig$tagNam = elementConfig.tagName,
      tagName = _elementConfig$tagNam === undefined ? "div" : _elementConfig$tagNam,
      _elementConfig$classL = elementConfig.classList,
      classList = _elementConfig$classL === undefined ? [] : _elementConfig$classL,
      _elementConfig$style = elementConfig.style,
      style = _elementConfig$style === undefined ? {} : _elementConfig$style,
      _elementConfig$attrib = elementConfig.attributes,
      attributes = _elementConfig$attrib === undefined ? {} : _elementConfig$attrib,
      _elementConfig$data = elementConfig.data,
      data = _elementConfig$data === undefined ? {} : _elementConfig$data,
      _elementConfig$childr = elementConfig.children,
      children = _elementConfig$childr === undefined ? [] : _elementConfig$childr,
      _elementConfig$eventH = elementConfig.eventHandlers,
      eventHandlers = _elementConfig$eventH === undefined ? {} : _elementConfig$eventH,
      unintendedProps = _objectWithoutProperties(elementConfig, ["namespace", "tagName", "classList", "style", "attributes", "data", "children", "eventHandlers"]);

  var unintendedKeys = Object.keys(unintendedProps);
  if (unintendedKeys.length > 0) {
    throw new Error("`createElement` must not receive unintended keys: " + JSON.stringify(unintendedKeys));
  }

  var element = namespace == null ? document.createElement(tagName) : document.createElementNS(namespace, tagName);
  var filteredClassList = (classList || []).filter(function (className) {
    return className;
  });
  if (filteredClassList.length > 0) {
    var _element$classList;

    (_element$classList = element.classList).add.apply(_element$classList, _toConsumableArray(filteredClassList));
  }
  Object.assign(element.style, style);

  Object.entries(attributes).forEach(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        name = _ref4[0],
        value = _ref4[1];

    element.setAttribute(name, value);
  });
  Object.assign(element.dataset, data);

  if (children.length > 0) {
    appendChildren(element, children);
  }

  on(element, eventHandlers);

  return element;
};


var empty = function empty(node) {
  while (node.firstChild) {
    node.removeChild(node.firstChild);
  }

  return node;
};

var fetchHTML = function fetchHTML(url) {
  return fetch(url).then(function (response) {
    return response.text();
  }).then(strToElement);
};

var firstAncestor = function firstAncestor(node, selector) {
  var halt = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "body";

  while (node != null && !node.matches(selector)) {
    if (node.matches(halt)) return null;

    node = node.parentNode;
  }

  return node;
};

/**
 * Returns a DocumentFragment containing the given HTML string, or null if
 * the string is empty or falsey.
 */
var fragmentFromString = function fragmentFromString(strHTML) {
  if (!strHTML) {
    return null;
  }

  var templateEl = document.createElement("template");
  templateEl.innerHTML = strHTML;
  return templateEl.content;
};

// Forces a reflow of the element so that cached styles are recomputed. This is
// important for ensuring that animations are used when changing styles or CSS
// classes via JS. See http://stackoverflow.com/q/11131875.
var forceReflow = function forceReflow(el) {
  el.offsetHeight;
};

var generateSnippetMap = function generateSnippetMap(html) {
  var wrapper = document.createElement("div");
  wrapper.innerHTML = html;
  var snippets = [].concat(_toConsumableArray(wrapper.querySelectorAll("[data-snippet]"))).reduce(function (coll, node) {
    var name = node.dataset.snippet;
    coll[name] = node;
    node.removeAttribute("data-snippet");
    node.remove();

    return coll;
  }, {});

  return function (name) {
    if (snippets[name] == null) return;

    return snippets[name].cloneNode(true);
  };
};

var getCSSProperty = function getCSSProperty(node, property) {
  return window.getComputedStyle(node).getPropertyValue(property);
};

var getElementsByClass = function getElementsByClass(parent, classNames) {
  return classNames.reduce(function (elements, name) {
    elements[Object(__WEBPACK_IMPORTED_MODULE_0__utils__["camelCase"])(name)] = parent.querySelector("." + name);

    return elements;
  }, {});
};

// A version of `getBoundingClientRect` relative to a reference node instead
// of the window.
var getRelativeBoundingClientRect = function getRelativeBoundingClientRect(node) {
  var reference = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (reference == null) {
    reference = node.parentNode;
  }

  var rect = node.getBoundingClientRect();
  var refRect = reference.getBoundingClientRect();
  return {
    top: rect.top - refRect.top,
    bottom: rect.bottom - refRect.bottom,
    left: rect.left - refRect.left,
    right: rect.right - refRect.right,
    width: rect.width,
    height: rect.height
  };
};

// Determines a bounding rectangle that encompasses all given nodes.
var getAggregateBoundingClientRect = function getAggregateBoundingClientRect(nodes) {
  return [].concat(_toConsumableArray(nodes)).reduce(function (agg, node) {
    var rect = node.getBoundingClientRect();
    agg.top = Math.min(agg.top, rect.top);
    agg.bottom = Math.max(agg.bottom, rect.bottom);
    agg.left = Math.min(agg.left, rect.left);
    agg.right = Math.max(agg.right, rect.right);
    agg.width = Math.max(agg.width, rect.left - agg.left + rect.width);
    agg.height = Math.max(agg.height, rect.top - agg.top + rect.height);
    return agg;
  }, {
    top: Infinity,
    bottom: 0,
    left: Infinity,
    right: 0,
    width: 0,
    height: 0
  });
};

// Given an element, this will return an integer that is the maximum font size (in px) that allows all the
// text to fit without overflow.
var getFontSizeToFit = function getFontSizeToFit(el) {
  var maxFontSizePx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 24;

  var startingFontSize = el.style.fontSize;
  var startingOverflow = el.style.overflow;
  el.style.overflow = "hidden";
  var high = maxFontSizePx + 1;
  var low = 0;
  el.style.fontSize = high + "px";
  while (low + 1 < high) {
    var mid = low + (high - low >> 1);
    el.style.fontSize = mid + "px";
    if (el.clientHeight < el.scrollHeight || el.clientWidth < el.scrollWidth) {
      high = mid;
    } else {
      low = mid;
    }
  }

  el.style.fontSize = startingFontSize;
  el.style.overflow = startingOverflow;
  return low;
};

/**
 * Attempt to calculate the `font-size` needed to have the text of `el` fit within the given number of lines.
 *
 * This is far from a perfect solution as there are several factors that determine line count not to mention
 * occasional ambiguity of what constitutes a "line" when there's `innerHTML` to contend with.
 *
 * @param {HTMLElement} el - Element with text to fit `maxLines`.
 * @param {number} maxLines - Max line count to calculate for.
 * @param {number} [precision] - The amount in px to incrementally adjust `font-size` by to determine changes.
 * @return {number} - In px.
 */
var getFontSizeToFitLines = function getFontSizeToFitLines(el, maxLines) {
  var precision = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0.5;

  /**
   * NOTE(oscar): The computed style of certain "older" properties should always be in px regardless of
   * applied style.
   * @see https://developer.mozilla.org/en-US/docs/Web/API/Window/getComputedStyle
   */
  var fontSize = parseFloat(getCSSProperty(el, "font-size"));

  var prevFontSizeStyle = el.style.fontSize;
  var prevHeight = el.style.height;
  var prevLineHeight = el.style.lineHeight;
  el.style.height = "unset";

  // NOTE(oscar): Ensures line-height is sensitive to changes in font-size.
  el.style.lineHeight = "10em";

  var computedFontSize = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["binaryFind"])(Object(__WEBPACK_IMPORTED_MODULE_0__utils__["range"])(precision, fontSize, precision), function (value) {
    el.style.fontSize = value + precision + "px";
    var lineHeight = parseFloat(getCSSProperty(el, "line-height"));
    var paddingTop = parseFloat(getCSSProperty(el, "padding-top"));
    var paddingBottom = parseFloat(getCSSProperty(el, "padding-bottom"));
    var textHeight = el.getBoundingClientRect().height - paddingTop - paddingBottom;
    return textHeight > lineHeight * maxLines;
  }) || fontSize;

  el.style.height = prevHeight;
  el.style.fontSize = prevFontSizeStyle;
  el.style.lineHeight = prevLineHeight;
  return computedFontSize;
};

var indexOf = function indexOf(node) {
  return [].indexOf.call(node.parentNode.children, node);
};

// Returns a Promise that resolves when the passed Image is rendered (determined by polling for a non-zero
// clientWidth and clientHeight).
var imageIsRendered = function imageIsRendered(img) {
  var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10000;

  var start = Date.now();
  return new Promise(function (resolve, reject) {
    var checkRendered = function checkRendered() {
      if (Date.now() - start >= timeout) {
        reject(new Error("Timeout loading image \"" + img.src + "\""));
      } else if (img.clientWidth === 0 || img.clientHeight === 0) {
        requestAnimationFrame(checkRendered);
      } else {
        resolve();
      }
    };

    requestAnimationFrame(checkRendered);
  });
};

var off = function off(node, events) {
  Object.keys(events).forEach(function (names) {
    var listener = events[names];

    names.trim().split(/\s+/).forEach(function (name) {
      node.removeEventListener(name, listener);
    });
  });
};

var on = function on(node, events) {
  Object.keys(events).forEach(function (names) {
    var listener = events[names];

    names.trim().split(/\s+/).forEach(function (name) {
      node.addEventListener(name, listener);
    });
  });
};

var onAnimationsComplete = function onAnimationsComplete(els, callback) {
  var animationsLeft = els.length;
  els.forEach(function (el) {
    addOneTimeListener(el, "webkitAnimationEnd", function () {
      animationsLeft -= 1;
      if (animationsLeft === 0) {
        callback();
      }
    });
  });
};

// Returns a map of { units, value } for a CSS length property.
// The length must be a string with "px" or "%" units or a value of 0.
var parseCSSLength = function parseCSSLength(length) {
  if (length === 0 || length === "0") return { value: 0, units: "px" };

  var match = /(.+)(px|%)/.exec(length);
  if (!match) return null;

  var _match = _slicedToArray(match, 3),
      _ = _match[0],
      value = _match[1],
      units = _match[2];

  if (value == null || units == null) return null;

  return { units: units, value: Number(value) };
};

var prependChild = function prependChild(parentNode, node) {
  parentNode.insertBefore(node, parentNode.children[0]);

  return parentNode;
};

var replaceStyle = function replaceStyle(element) {
  for (var _len2 = arguments.length, newStyles = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    newStyles[_key2 - 1] = arguments[_key2];
  }

  element.removeAttribute("style");
  Object.assign.apply(Object, [element.style].concat(newStyles));
};

var scrollIntoView = function scrollIntoView(node) {
  var rect = node.getBoundingClientRect();
  var pRect = node.parentNode.getBoundingClientRect();
  var topDiff = rect.top - pRect.top;
  var botDiff = rect.bottom - pRect.bottom;

  if (topDiff < 0 && botDiff > 0) {
    node.parentNode.scrollTop += (topDiff + botDiff) / 2;
  } else if (topDiff < 0) {
    node.parentNode.scrollTop += topDiff;
  } else if (botDiff > 0) {
    node.parentNode.scrollTop += botDiff;
  }
};

var strToElement = function strToElement(str) {
  var div = document.createElement("div");
  div.innerHTML = str.replace(/\n\s*/g, "");

  return div.firstChild;
};

var strToStyle = function strToStyle(str) {
  var style = document.createElement("style");
  style.innerHTML = str;

  return style;
};

/** Writes `contentHTML` into `iframeEl`. */
var writeToIframe = function writeToIframe(iframeEl, contentHTML) {
  iframeEl.contentWindow.document.open();
  iframeEl.contentWindow.document.write(contentHTML);
  iframeEl.contentWindow.document.close();
};

var preparetagHTML = function preparetagHTML(tagHTML) {
  var wrapperEl = document.createElement("div");
  wrapperEl.innerHTML = tagHTML;

  // Script tags must be reattached in order to run.
  [].concat(_toConsumableArray(wrapperEl.querySelectorAll("script"))).forEach(function (originalScriptTag) {
    var replacementScriptTag = document.createElement("script");
    [].concat(_toConsumableArray(originalScriptTag.attributes)).forEach(function (_ref5) {
      var name = _ref5.nodeName,
          value = _ref5.nodeValue;

      replacementScriptTag.setAttribute(name, value);
    });
    replacementScriptTag.innerHTML = originalScriptTag.innerHTML;
    originalScriptTag.parentNode.replaceChild(replacementScriptTag, originalScriptTag);
  });

  return wrapperEl;
};

var appendImpressionTags = function appendImpressionTags(containerEl, impressionTags) {
  impressionTags.forEach(function (tagHTML) {
    var wrapper = preparetagHTML(tagHTML);
    containerEl.append(wrapper);
  });
};

/***/ }),

/***/ 10:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isTestError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Warning; });
/* unused harmony export tryParseStackInfo */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return normalizeError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return normalizeErrorEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return normalizePromiseRejectionEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return shouldIgnoreError; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__frontendlib_utils__ = __webpack_require__(0);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



// if process.env.NODE_ENV === "test"
var isTestError = function isTestError(error) {
  // NOTE(Austin): Annoyingly, assertion errors will loop back here in
  // tests, so we have to ignore these.
  return error != null && error.constructor.name === "AssertionError";
};
// #endif

var Warning = function (_Error) {
  _inherits(Warning, _Error);

  function Warning() {
    var _ref;

    _classCallCheck(this, Warning);

    for (var _len = arguments.length, params = Array(_len), _key = 0; _key < _len; _key++) {
      params[_key] = arguments[_key];
    }

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    var _this = _possibleConstructorReturn(this, (_ref = Warning.__proto__ || Object.getPrototypeOf(Warning)).call.apply(_ref, [this].concat(params)));

    if (Error.captureStackTrace) {
      Error.captureStackTrace(_this, Warning);
    }
    _this.severity = "warning";
    return _this;
  }

  return Warning;
}(Error);

var tryConvertStringToNumber = function tryConvertStringToNumber(str) {
  if (str == null) {
    return 0;
  }

  var parsed = parseInt(str);
  if (Number.isNaN(parsed)) {
    return 0;
  }

  return parsed;
};

var tryParseStackInfo = function tryParseStackInfo(stack) {
  if (stack == null) {
    return null;
  }

  var match = String(stack).match(
  // NOTE(Austin): We include about:srcdoc for inner_env errors.
  /(\b(?:[^ ]*\.js.*?)|(?:about:srcdoc)):(\d+)?:?(\d+)?/);

  if (match == null) {
    return null;
  }

  // Line and column need to be integers. We have them in our adexp
  // protobuf this way, so if they aren't we'll get a malformed message.
  return {
    sourceURL: match[1],
    line: tryConvertStringToNumber(match[2]),
    column: tryConvertStringToNumber(match[3])
  };
};

/**
 * Converts an Error or string into a map like
 * { message, stack, sourceURL, line, column }
 */
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/Error
var normalizeError = function normalizeError(obj) {
  if (obj == null) {
    return null;
  }

  if (typeof obj === "string") {
    return {
      message: obj
    };
  }

  var errorProps = Object(__WEBPACK_IMPORTED_MODULE_0__frontendlib_utils__["selectKeys"])(obj, Object.getOwnPropertyNames(obj));

  return Object.assign({}, tryParseStackInfo(errorProps.stack), errorProps);
};

/**
 * Converts an ErrorEvent object to a map like:
 * { message, line, column, sourceURL }
 * plus any additional information the error object contains.
 */
var normalizeErrorEvent = function normalizeErrorEvent(_ref2) {
  var message = _ref2.message,
      filename = _ref2.filename,
      lineno = _ref2.lineno,
      colno = _ref2.colno,
      error = _ref2.error;

  try {
    // Possible keys in an ErrorEvent:
    // [stack, name, fileName, lineNumber, columnNumber]
    var errorProps = error != null ? Object(__WEBPACK_IMPORTED_MODULE_0__frontendlib_utils__["selectKeys"])(error, Object.getOwnPropertyNames(error)) : {};

    var errorObj = Object.assign({
      message: message,
      severity: error && error.severity ? error.severity : "error",
      line: lineno,
      column: colno,
      sourceURL: filename
    }, errorProps);

    if (error == null) {
      return errorObj;
    }

    var parsedInfo = tryParseStackInfo(error.stack);
    return Object(__WEBPACK_IMPORTED_MODULE_0__frontendlib_utils__["mergePropertiesWithDefaults"])(errorObj, parsedInfo);
  } catch (e) {
    console.error("Error in normalizeErrorEvent: " + e.stack);
    return null;
  }
};

/**
 * Converts an PromiseRejectionEvent object to a map like
 * { message, line, column, sourceURL }
 * plus any additional information the error object contains.
 */
var normalizePromiseRejectionEvent = function normalizePromiseRejectionEvent(_ref3) {
  var reason = _ref3.reason;

  try {
    var reasonIsError = reason instanceof Error;
    var reasonIsString = typeof reason === "string";

    var errorMessage = reasonIsString ? reason : reason.message;

    // Possible keys in object (* are non-standard):
    // [message, stack*, name, fileName*, lineNumber*, columnNumber*]
    var errorProps = reasonIsError ? Object(__WEBPACK_IMPORTED_MODULE_0__frontendlib_utils__["selectKeys"])(reason, Object.getOwnPropertyNames(reason)) : {};

    var errorObj = Object.assign({
      message: errorMessage
    }, errorProps);

    return Object(__WEBPACK_IMPORTED_MODULE_0__frontendlib_utils__["mergePropertiesWithDefaults"])(errorObj, tryParseStackInfo(reason.stack));
  } catch (e) {
    console.error("Error in normalizePromiseRejectionEvent: " + e.stack);
    return null;
  }
};

/**
 * Normalizes the error and returns true if the error should be ingored;
 * otherwise, returns false.
 */
var shouldIgnoreError = function shouldIgnoreError(errorObj) {
  // Report only errors with non-malformed sourceURL.
  if (errorObj == null || errorObj.sourceURL === "undefined") {
    return true;
  }

  // mraid.js from adverty.com is a buggy implemenation. SMAATO and PUBMATIC are
  // the exchanges using such version and we see strange errors from the most.
  // While we are working with them to get a good MRAID implementation we filter
  // the noisy error messages by checking where the mraid.js is from.
  var stackFilter = new RegExp("adverty\\.com/.*mraid\\.js");

  // We see these errors quite often, and they are not related to our code.
  var regexFilters = ["Cannot read properties of undefined \\(reading 'fireEvent'\\)", "Cannot read property 'fireEvent' of undefined", "showInterstitial", "al_onPoststitialDismiss", "AFMA_ReceiveMessage", "webviewDidAppear", "AFMA_updateActiveView is not a function", "al_onAdViewRendered", "mraidbridge", "MoatMAK", "$adgIOS", "googqscp", "inmobi", "Script error", "avidbridge"];
  var messageFilter = new RegExp(regexFilters.join("|"));
  var errorStr = errorObj.message || errorObj.toString();
  if (messageFilter.test(errorStr) || stackFilter.test(errorObj.stack)) {
    return true;
  }

  var normalized = Object(__WEBPACK_IMPORTED_MODULE_0__frontendlib_utils__["selectKeys"])(errorObj, ["message", "line", "column", "stack", "sourceURL"]);

  var nKeys = Object.keys(normalized).length;
  var onlyMessage = "message" in errorObj && nKeys === 1 && errorObj.message === "undefined is not a function";

  var onlyMessageStack = "stack" in errorObj && "message" in errorObj && nKeys === 2 && errorObj.stack === "" && errorObj.message === "undefined is not a function";

  var noSourceURL = errorObj.sourceURL == null && nKeys === 5;
  return onlyMessage || onlyMessageStack || noSourceURL;
};

/***/ }),

/***/ 11:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var EventListener = function () {
  _createClass(EventListener, null, [{
    key: "pubsubify",
    value: function pubsubify(object) {
      var methods = Object.getOwnPropertyNames(EventListener.prototype).filter(function (name) {
        return name !== "constructor";
      });
      Object.assign(object, new EventListener());
      Object.assign(object, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["selectKeys"])(EventListener.prototype, methods));
    }
  }]);

  function EventListener() {
    _classCallCheck(this, EventListener);

    this.events = {};
  }

  _createClass(EventListener, [{
    key: "on",
    value: function on(map, callback) {
      var _this = this;

      if (Object(__WEBPACK_IMPORTED_MODULE_0__utils__["type"])(map) !== "object") {
        map = _defineProperty({}, map, callback);
      }

      Object.keys(map).forEach(function (name) {
        if (_this.events[name] == null) {
          _this.events[name] = [];
        }

        _this.events[name].push(map[name]);
      });
    }
  }, {
    key: "once",
    value: function once(name, callback) {
      var _this2 = this;

      var single = function single() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this2.off(name, single);
        callback.apply(null, args);
      };

      this.on(name, single);
    }
  }, {
    key: "off",
    value: function off(map, callback) {
      var _this3 = this;

      if (Object(__WEBPACK_IMPORTED_MODULE_0__utils__["type"])(map) !== "object") {
        map = _defineProperty({}, map, callback);
      }

      Object.keys(map).forEach(function (name) {
        if (_this3.events[name] == null) return;

        var callback = map[name];
        if (callback == null) return delete _this3.events[name];

        _this3.events[name] = _this3.events[name].filter(function (cb) {
          return cb !== callback;
        });
        if (_this3.events[name].length === 0) {
          delete _this3.events[name];
        }
      });
    }
  }, {
    key: "emit",
    value: function emit(name) {
      for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      if (this.events[name] == null) return;

      return Promise.all(this.events[name].map(function (cb) {
        return cb.apply(null, args);
      }));
    }
  }, {
    key: "relay",
    value: function relay(listener, onEvent) {
      var emitEvent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : onEvent;

      this.on(onEvent, listener.emit.bind(listener, emitEvent));
    }
  }]);

  return EventListener;
}();

/* harmony default export */ __webpack_exports__["a"] = (EventListener);

/***/ }),

/***/ 12:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__frontendlib_event_listener__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__frontendlib_utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__logger__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__error_handling__ = __webpack_require__(10);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }







/**
 * This interval is the time between attempts to open a URL via different
 * methods (see `LiftoffMRAID.open`).
 */
var CLICK_RETRY_INTERVAL_MS = 1000;

var mraidOpenOnlyExchanges = new Set([__WEBPACK_IMPORTED_MODULE_2__constants__["z" /* EXCHANGE_INNERACTIVE */], __WEBPACK_IMPORTED_MODULE_2__constants__["A" /* EXCHANGE_IRONSOURCE */], __WEBPACK_IMPORTED_MODULE_2__constants__["B" /* EXCHANGE_MINTEGRAL */], __WEBPACK_IMPORTED_MODULE_2__constants__["E" /* EXCHANGE_VERVE */], __WEBPACK_IMPORTED_MODULE_2__constants__["F" /* EXCHANGE_VUNGLE */]]);

var mraidOpenUncertainExchanges = new Set([__WEBPACK_IMPORTED_MODULE_2__constants__["w" /* EXCHANGE_ADPOPCORN */], __WEBPACK_IMPORTED_MODULE_2__constants__["x" /* EXCHANGE_CONNATIX */], __WEBPACK_IMPORTED_MODULE_2__constants__["C" /* EXCHANGE_MOMENTO */], __WEBPACK_IMPORTED_MODULE_2__constants__["D" /* EXCHANGE_PANGLE */], __WEBPACK_IMPORTED_MODULE_2__constants__["G" /* EXCHANGE_XIAOMI */]]);

/**
 * This is a low-level wrapper around mraid that should be usable generally
 * (i.e. in any HTML ad environment). It's used by both madlib and third-party
 * creatives.
 */

var LiftoffMRAID = function () {
  function LiftoffMRAID() {
    _classCallCheck(this, LiftoffMRAID);
  }

  _createClass(LiftoffMRAID, null, [{
    key: "init",

    /**
     * Among other things, this function attaches event listeners to the
     * window.mraid object. It should be called as soon as possible after
     * window.mraid is defined. Because of this side-effect, it should also only
     * be called once.
     */
    value: function init() {
      this.liftoffMraidInitTimestamp = Date.now();

      __WEBPACK_IMPORTED_MODULE_0__frontendlib_event_listener__["a" /* default */].pubsubify(this);
      this.on = this.on.bind(this);
      this.once = this.once.bind(this);
      this._addMraidEventListener = this._addMraidEventListener.bind(this);

      this.viewableDurationMS = null;
      this.lastViewableTS = null;
      this.clickRetryTimeout = null;
      this.lastOpenedURL = null;
      this.isOrientationLocked = false;
      this.orientationToLock = null;
      this.viewable = null;
      this.isViewableByEvent = null;

      /** Keeps track of each version of window.mraid loaded. */
      this.mraids = [];
      /** This index of this.mraids that is currently loaded on window.mraid. */
      this.mraidIndex = null;

      /**
       * This object keeps track of what the current mraid object supports at the
       * moment support was checked.
       */
      this.supported = {
        methods: {},
        /**
         * NOTE(oscar): Unlike MRAID methods, we log mraid events that we listen
         * to as they occur.
         */
        events: {}
      };

      this._setInitialState();
      this._addEventListeners();
    }

    /** Returns time since LiftoffMRAID has been initialized in milliseconds. */

  }, {
    key: "sinceInit",
    value: function sinceInit() {
      return Date.now() - this.liftoffMraidInitTimestamp;
    }
  }, {
    key: "getSupportedLog",
    value: function getSupportedLog() {
      return Object.assign({
        "document.hidden": document.hidden,
        "document.visibilityState": document.visibilityState,
        "LiftoffMRAID.viewable": LiftoffMRAID.viewable,
        MRAID_ENV: window.MRAID_ENV
      }, this.supported);
    }
  }, {
    key: "_setInitialState",
    value: function _setInitialState() {
      var _this = this;

      var mraid = this.getMRAID();
      this.ready = this._mraidTry(function () {
        return _this.hasSupport("getState") && mraid.getState() === "default";
      }, { tag: "getState", fallback: false });

      this.isViewableByEvent = this.hasSupport("isViewable") ? this._mraidTry(function () {
        return mraid.isViewable();
      }, {
        tag: "isViewable",
        // NOTE(oscar): If isViewable() still fails, we fall back to
        // document.visibilityState.
        fallback: document.visibilityState !== "hidden"
      }) : document.visibilityState !== "hidden";
      this.processViewableChange(this.isViewableByEvent && this.isViewportShown());
      this.viewableDurationMS = 0;
    }

    /** TODO(oscar): Don't append to log if it won't be sent to Adexp. */

  }, {
    key: "_appendEventLog",
    value: function _appendEventLog(eventName, mraidIndex, args) {
      if (this.supported.events[eventName] == null) {
        this.supported.events[eventName] = [];
      }
      this.supported.events[eventName].push({
        sinceInitMs: this.sinceInit(),
        args: args,
        mraidIndex: mraidIndex,
        version: this.getMRAIDVersion()
      });
    }

    /**
     * This function is used to wrap calls to mraid methods in a try/catch block.
     * Any error gets logged in this.supported.errors.
     *
     * In general, this.hasSupport() is used to check for support. This function
     * serves as a further safeguard against errors due to faulty mraid
     * implementations.
     */

  }, {
    key: "_mraidTry",
    value: function _mraidTry(func, _ref) {
      var _ref$tag = _ref.tag,
          tag = _ref$tag === undefined ? "other" : _ref$tag,
          _ref$fallback = _ref.fallback,
          fallback = _ref$fallback === undefined ? undefined : _ref$fallback,
          _ref$logError = _ref.logError,
          logError = _ref$logError === undefined ? true : _ref$logError;

      try {
        return func();
      } catch (e) {
        if (logError) {
          // Record the error.
          this.supported.errors = this.supported.errors || [];
          var version = void 0;
          try {
            version = this.getMRAID().getVersion();
          } catch (ee) {
            console.error("Failed to get MRAID version", ee);
          }
          this.supported.errors.push({
            tag: tag,
            sinceInitMs: this.sinceInit(),
            message: e != null ? e.message : null,
            mraidIndex: this.mraidIndex,
            version: version
          });
        }
        return fallback;
      }
    }
  }, {
    key: "_addMraidEventListener",
    value: function _addMraidEventListener(eventName, callback) {
      var _this2 = this;

      if (!this.hasSupport("addEventListener")) return;

      var mraid = this.getMRAID();
      var mraidIndex = this.mraidIndex;

      this._mraidTry(function () {
        mraid.addEventListener(eventName, function () {
          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          _this2._appendEventLog(eventName, mraidIndex, args);

          callback.apply(undefined, args);
        });
      }, { tag: eventName });
    }
  }, {
    key: "_addEventListeners",
    value: function _addEventListeners() {
      var _this3 = this;

      // "error" events include 2 arguments: a message and an action. The action
      // is the MRAID API call that caused the error.
      this._addMraidEventListener("error", function () {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        var e = new Error("MRAID error: " + args);
        _this3.emit("error", e);
      });
      this._addMraidEventListener("ready", function () {
        if (_this3.ready) return;
        _this3.ready = true;
        _this3.emit("ready");
      });
      this._addMraidEventListener("viewableChange", function (viewable) {
        _this3.isViewableByEvent = viewable;
        _this3.processViewableChange(_this3.isViewableByEvent && _this3.isViewportShown());
      });

      // NOTE(oscar): We're using _addMraidEventListener to log this event.
      this._addMraidEventListener("exposureChange", function () {});

      /**
       * The following is a fallback in case mraid's viewableChange is not
       * supported.
       */
      document.addEventListener("visibilitychange", function () {
        for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          args[_key3] = arguments[_key3];
        }

        _this3._appendEventLog("document.visibilitychange", _this3.mraidIndex, args);

        /**
         * We delay the following by an event cycle to allow mraid's
         * viewableChange event to occur first.
         */
        Object(__WEBPACK_IMPORTED_MODULE_1__frontendlib_utils__["runAsync"])(function () {
          if (_this3.supported.events.viewableChange == null) {
            _this3.isViewableByEvent = document.visibilityState !== "hidden";
            _this3.processViewableChange(_this3.isViewableByEvent && _this3.isViewportShown());
          }
        });
      });
    }
  }, {
    key: "processViewableChange",
    value: function processViewableChange(isViewable) {
      /**
       * NOTE(oscar): On the off chance the mraid implementation gives us
       * truthy/falsey values instead.
       */
      var normalizedIsViewable = !!isViewable;
      if (normalizedIsViewable === this.viewable) return;
      this.viewable = normalizedIsViewable;

      if (this.viewable) {
        this.lastViewableTS = Date.now();
        if (!this.isOrientationLocked && this.orientationToLock != null) {
          // NOTE(oscar): We won't lock the orientation until after the ad is
          // viewable.
          this.lockOrientation(this.orientationToLock);
        }
      } else {
        this.viewableDurationMS += this.lastViewableTS == null ? 0 : Date.now() - this.lastViewableTS;
        this.lastOpenedURL = null;
        clearTimeout(this.clickRetryTimeout);
      }

      if (this.viewable) {
        this.emit("viewable");
      }
      this.emit("viewableChange", this.viewable);
    }
  }, {
    key: "onReady",
    value: function onReady(fn) {
      if (this.ready) {
        Object(__WEBPACK_IMPORTED_MODULE_1__frontendlib_utils__["runAsync"])(fn);
        return;
      }
      this.once("ready", fn);
    }

    /**
     * Adds a listener to the "viewable" event. The "viewable" event fires
     * whenever we believe the ad has become visible to the user. If the ad was
     * already visible, then it fires the listener immediately.
     * @param {Function} callback
     * @param {boolean} continuous – Whether to listen to all viewable events.
     * Defaults to false, meaning it will only trigger the callback once.
     * @returns
     */

  }, {
    key: "onViewable",
    value: function onViewable(callback) {
      var continuous = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (this.viewable) {
        Object(__WEBPACK_IMPORTED_MODULE_1__frontendlib_utils__["runAsync"])(callback);
        if (!continuous) return;
      }
      var deferrer = continuous ? this.on : this.once;
      deferrer("viewable", callback);
    }

    /** Runs fn now with current viewable value and on "viewableChange" event. */

  }, {
    key: "nowAndOnViewableChange",
    value: function nowAndOnViewableChange(fn) {
      var _this4 = this;

      Object(__WEBPACK_IMPORTED_MODULE_1__frontendlib_utils__["runAsync"])(function () {
        return fn(_this4.viewable);
      });

      this.on("viewableChange", fn);
    }

    // TODO(oscar): Replace with nowAndOnViewableChange once v2 productionizes.

  }, {
    key: "onViewableChange",
    value: function onViewableChange(fn) {
      this.nowAndOnViewableChange(fn);
    }

    // IMPORTANT: This method MUST be called synchronously with a user action.

  }, {
    key: "open",
    value: function open(url, _ref2) {
      var _this5 = this;

      var exchange = _ref2.exchange,
          platform = _ref2.platform,
          _ref2$abTests = _ref2.abTests,
          abTests = _ref2$abTests === undefined ? [] : _ref2$abTests,
          _ref2$isLiftoffURL = _ref2.isLiftoffURL,
          isLiftoffURL = _ref2$isLiftoffURL === undefined ? false : _ref2$isLiftoffURL,
          _ref2$isAutoclick = _ref2.isAutoclick,
          isAutoclick = _ref2$isAutoclick === undefined ? false : _ref2$isAutoclick;

      // To prevent the click waterfall from resetting if the user clicks twice in
      // rapid succession, don't restart the waterfall unless the URL being opened
      // is different.
      if (this.lastOpenedURL === url) return;

      this.lastOpenedURL = url;
      clearTimeout(this.clickRetryTimeout);

      var mraidOpenIsSupported = this.hasSupport("open");
      var isMRAIDOnlyExchange = mraidOpenOnlyExchanges.has(exchange);
      var requireMRAID = mraidOpenIsSupported && (isAutoclick || isMRAIDOnlyExchange);

      var getFinalClickURL = function getFinalClickURL(openMethod) {
        return isLiftoffURL ? Object(__WEBPACK_IMPORTED_MODULE_1__frontendlib_utils__["appendParamObjectToURL"])(url, {
          open_method: openMethod,
          tracking_method: __WEBPACK_IMPORTED_MODULE_2__constants__["N" /* TRACKING_METHOD_OPEN_METHOD */]
        }) : url;
      };
      var mraidOpen = function mraidOpen(url) {
        if (!_this5.ready) {
          _this5.emit("error", new Error("Called mraid.open before mraid was ready"));
        }
        _this5.getMRAID().open(url);
      };
      var anchorOpen = function anchorOpen(url) {
        var a = document.createElement("a");
        a.href = url;
        a.target = "_blank";
        a.click();
      };
      var locationOpen = function locationOpen(url) {
        window.location = url;
      };

      // To ensure that the user can click through, attempt multiple methods of
      // navigating to the URL. In order, they are:
      // 1. `mraid.open`, if mraid is available
      // 2. A fake anchor element
      // 3. `window.location`
      var openMethods = [{
        type: __WEBPACK_IMPORTED_MODULE_2__constants__["t" /* CLICK_OPEN_METHOD_MRAID */],
        enabled: mraidOpenIsSupported,
        fn: mraidOpen
      }, {
        type: __WEBPACK_IMPORTED_MODULE_2__constants__["r" /* CLICK_OPEN_METHOD_ANCHOR */],
        enabled: !requireMRAID,
        fn: anchorOpen
      }, {
        type: __WEBPACK_IMPORTED_MODULE_2__constants__["s" /* CLICK_OPEN_METHOD_LOCATION */],
        enabled: !requireMRAID,
        fn: locationOpen
      }].filter(function (_ref3) {
        var enabled = _ref3.enabled;
        return enabled;
      });

      /**
       * Checks if we expect for the SKProductView will open. If so, then it's
       * likely for no visibility event to occur.
       * TODO(oscar/cwu): Replace url check with other `skproductview` indicating
       * boolean that should be populated from h2go.
       */
      var isOpenSKProductView = function isOpenSKProductView(openMethod, url) {
        var appleStoreUrlPrefix = new RegExp("^(https?://)?apps\\.apple\\.com");
        return openMethod.type === __WEBPACK_IMPORTED_MODULE_2__constants__["t" /* CLICK_OPEN_METHOD_MRAID */] && appleStoreUrlPrefix.test(url);
      };

      var tryOpen = function tryOpen() {
        var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

        // We don't emit any error if we're in the waterfall experiment
        // because this is guaranteed to happen if the user clicks more than
        // once (whereas in the original this will only happen if it thinks a
        // click failed).
        if (index > 0) {
          var methodType = openMethods[index - 1].type;
          _this5.emit("error", new __WEBPACK_IMPORTED_MODULE_4__error_handling__["a" /* Warning */]("Failed to open " + url + " using " + methodType));
        }
        if (index === openMethods.length - 1) {
          _this5.lastOpenedURL = null;
        }
        if (index >= openMethods.length && !(index === 1 && isOpenSKProductView(openMethods[0], url))) {
          _this5.emit("error", new Error("Failed to open " + url + " by any methods. Tried " + openMethods.length + " method(s)"));
          return;
        }

        var openMethod = openMethods[index];
        var finalClickURL = getFinalClickURL(openMethod.type);
        openMethod.fn(finalClickURL);
        _this5.emit("clickMethodTried", {
          clickOpenMethod: openMethod.type,
          isAutoclick: isAutoclick
        });
        __WEBPACK_IMPORTED_MODULE_3__logger__["a" /* default */].recordMetricV2("click_url_open", {
          method: openMethod.type,
          index: index,
          total: openMethods.length,
          is_mraid_ready: _this5.ready
        });

        _this5.clickRetryTimeout = setTimeout(tryOpen.bind(_this5, index + 1), CLICK_RETRY_INTERVAL_MS);
      };

      if (isMRAIDOnlyExchange) {
        mraidOpen(getFinalClickURL(__WEBPACK_IMPORTED_MODULE_2__constants__["t" /* CLICK_OPEN_METHOD_MRAID */]));
        __WEBPACK_IMPORTED_MODULE_3__logger__["a" /* default */].recordMetricV2("click_url_open", {
          method: __WEBPACK_IMPORTED_MODULE_2__constants__["t" /* CLICK_OPEN_METHOD_MRAID */],
          index: 0,
          total: 1,
          is_mraid_ready: this.ready
        });
      } else if (mraidOpenUncertainExchanges.has(exchange)) {
        // Keep these exchanges still in the click waterfall for now.
        tryOpen();
      } else if (abTests.includes("click-waterfall-removal-experiment")) {
        mraidOpen(getFinalClickURL(__WEBPACK_IMPORTED_MODULE_2__constants__["t" /* CLICK_OPEN_METHOD_MRAID */]));
        __WEBPACK_IMPORTED_MODULE_3__logger__["a" /* default */].recordMetricV2("click_url_open", {
          method: __WEBPACK_IMPORTED_MODULE_2__constants__["t" /* CLICK_OPEN_METHOD_MRAID */],
          index: 0,
          total: 1,
          is_mraid_ready: this.ready
        });
      } else {
        tryOpen();
      }
    }
  }, {
    key: "close",
    value: function close() {
      var _this6 = this;

      this.onReady(function () {
        __WEBPACK_IMPORTED_MODULE_3__logger__["a" /* default */].recordMetricV2("close_count", 1);

        if (!_this6.hasSupport("close")) {
          _this6.emit("error", new __WEBPACK_IMPORTED_MODULE_4__error_handling__["a" /* Warning */]("Attempted to call 'MRAID.close' when it is not supported."));
          return;
        }

        _this6.getMRAID().close();
      });
    }

    // NOTE(brian): The `useCustomClose` method is deprecated (read: ignored) in
    // MRAID 3.0.
    // NOTE(Casey): Unity's `useCustomClose` throws an error. Although we handle
    // this case by not trying custom custom close on Unity, this implementation
    // handles that scenario in case other exchanges are (unknowingly) similar.
    /**
     * Returns a `Promise` that resolves with `false` if custom close was not set
     * or to `true` if custom close was set successfully. The `Promise` rejects
     * if an error was thrown.
     */

  }, {
    key: "useCustomClose",
    value: function useCustomClose(use) {
      var _this7 = this;

      return new Promise(function (resolve, reject) {
        try {
          _this7.onReady(function () {
            if (!(_this7.hasSupport("useCustomClose") && _this7.hasSupport("close") && use)) {
              return resolve(false);
            }
            var mraid = _this7.getMRAID();
            mraid.useCustomClose(use);
            resolve(use);
          });
        } catch (e) {
          reject(e);
        }
      });
    }
  }, {
    key: "getViewableDurationMS",
    value: function getViewableDurationMS() {
      if (!this.viewable) return this.viewableDurationMS;
      if (this.lastViewableTS == null) {
        console.error("Internal LiftoffMRAID error: this.lastViewableTS should be set.");
        return this.viewableDurationMS;
      }
      return this.viewableDurationMS + (Date.now() - this.lastViewableTS);
    }
  }, {
    key: "lockOrientation",
    value: function lockOrientation(orientation) {
      if (!this.ready || !this.viewable || !this.hasSupport("setOrientationProperties")) {
        return;
      }

      this.orientationToLock = orientation;
      var mraid = this.getMRAID();
      this._mraidTry(function () {
        mraid.setOrientationProperties({
          allowOrientationChange: false,
          forceOrientation: orientation
        });
      }, { tag: "setOrientationProperties" });
      this.isOrientationLocked = true;
    }
  }, {
    key: "getMRAID",
    value: function getMRAID() {
      var windowMraid = window.mraid;
      if (windowMraid != null) {
        // NOTE(oscar): There are some sdks that will delete window.mraid after it
        // was initialized. In some cases at least, this is done to replace the
        // mraid object with a new one, but it's unclear why this is done in an
        // asynchronous way. In order not to race with the SDK's implementation of
        // MRAID, we will use the last mraid object loaded as a fallback.
        // Related test: https://docs.google.com/document/d/1TWLnTFlTGFc6ZJB_UXfR8QvmEa8x_d3k532fmX-13Fs
        // Related test 2: https://docs.google.com/document/d/1iChTG_zLZvQzI5Opw-6kpHqRCXRYklTPpbNB7TPBFdQ
        this.mraidIndex = this.mraids.indexOf(windowMraid);
        if (this.mraidIndex === -1) {
          this.mraidIndex = this.mraids.length;
          this.mraids.push(windowMraid);
        }
      }

      return this.mraids[this.mraidIndex];
    }
  }, {
    key: "logMethodSupport",
    value: function logMethodSupport(methodName, isSupported) {
      if (this.supported.methods[methodName] == null) {
        this.supported.methods[methodName] = {};
      }
      if (this.supported.methods[methodName][this.mraidIndex] == null) {
        this.supported.methods[methodName][this.mraidIndex] = [];
      }
      // NOTE(oscar): The MRAID spec allows for a method to go from no support to
      // support when the mraid's "ready" event triggers.
      this.supported.methods[methodName][this.mraidIndex].push({
        sinceInitMs: this.sinceInit(),
        ready: this.ready,
        support: isSupported,
        /** Logging is disabled here to prevent an infinite loop. */
        version: this.getMRAIDVersion({ log: false })
      });
    }

    /**
     * Checks to see if the MRAID implementation supports the given method.
     * More specifically, this checks to see if the method is a function on the
     * window.mraid object. It does not actually call the method to see if it
     * works and any caller should be prepared to handle errors.
     *
     * @param {string} prop - The name of the method to check.
     * @param {Object} options
     * @param {boolean} options.log - Whether to log the result of the check.
     */

  }, {
    key: "hasSupport",
    value: function hasSupport(prop) {
      var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref4$log = _ref4.log,
          log = _ref4$log === undefined ? true : _ref4$log;

      var mraid = this.getMRAID();
      if (mraid == null) {
        return false;
      }

      if (prop === "mraid") {
        return true;
      }

      var support = Object(__WEBPACK_IMPORTED_MODULE_1__frontendlib_utils__["type"])(mraid[prop]) === "function";

      if (log) {
        this.logMethodSupport(prop, support);
      }

      return support;
    }

    /** Returns the currently loaded MRAID version. */

  }, {
    key: "getMRAIDVersion",
    value: function getMRAIDVersion() {
      var _this8 = this;

      var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref5$log = _ref5.log,
          log = _ref5$log === undefined ? true : _ref5$log;

      return this._mraidTry(function () {
        return _this8.hasSupport("getVersion", { log: log }) ? _this8.getMRAID().getVersion() : null;
      }, { tag: "getVersion", logError: log });
    }
  }, {
    key: "isViewportShown",
    value: function isViewportShown() {
      return window.innerHeight > 0 && window.innerWidth > 0;
    }
  }]);

  return LiftoffMRAID;
}();

if (window._LiftoffMRAID == null) {
  LiftoffMRAID.init();
  /**
   * NOTE(oscar): Global state is needed in order to only call .init() once and
   * to ensure that the same LiftoffMRAID is exported.
   */
  window._LiftoffMRAID = LiftoffMRAID;
}

/* harmony default export */ __webpack_exports__["a"] = (window._LiftoffMRAID);

/***/ }),

/***/ 13:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return AdexpMetricV2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AdexpJavaScriptError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AdexpLog; });
/* unused harmony export AdexpContext */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AdexpMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getAdexpContextSnapshotFn; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Wrappers around adexp objects contained in adexpjson.go

var AdexpMetricV2 = function AdexpMetricV2(name, value) {
  _classCallCheck(this, AdexpMetricV2);

  this.name = name;
  this.value = value;
};

var AdexpJavaScriptError = function AdexpJavaScriptError() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      message = _ref.message,
      _ref$severity = _ref.severity,
      severity = _ref$severity === undefined ? "error" : _ref$severity,
      sourceURL = _ref.sourceURL,
      line = _ref.line,
      column = _ref.column,
      stack = _ref.stack;

  _classCallCheck(this, AdexpJavaScriptError);

  this.error = {
    message: message,
    severity: severity,
    sourceURL: sourceURL,
    line: line,
    column: column,
    stack: stack
  };
};

var AdexpLog = function AdexpLog(tag, message, data) {
  _classCallCheck(this, AdexpLog);

  this.tag = tag;
  this.message = message;
  Object.assign(this, data);
};

var AdexpContext = function AdexpContext() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      viewportWidth = _ref2.viewportWidth,
      viewportHeight = _ref2.viewportHeight,
      adLanguage = _ref2.adLanguage,
      mraid = _ref2.mraid;

  _classCallCheck(this, AdexpContext);

  this.ad_language = adLanguage;
  this.mraid = mraid;
  this.viewport_height = viewportHeight;
  this.viewport_width = viewportWidth;
};

var AdexpMessage = function AdexpMessage() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      context = _ref3.context,
      metric = _ref3.metric,
      log = _ref3.log;

  _classCallCheck(this, AdexpMessage);

  Object.assign(this, context);
  // NOTE(Austin): metrics_v2 must be an array. For now
  // we don't log more than one metric at a time though.
  this.metrics_v2 = metric != null ? [metric] : undefined;
  this.log = log;
};

// TODO(Austin): Consolidate ClickMetric here.

/**
 * Returns a function that takes a snapshot of the current environment
 * and returns a `AdexpContext`.
 */
var getAdexpContextSnapshotFn = function getAdexpContextSnapshotFn(viewportEl, hasMraidFn) {
  return function () {
    var _ref4 = viewportEl != null ? viewportEl.getBoundingClientRect() : {},
        width = _ref4.width,
        height = _ref4.height;

    return new AdexpContext({
      viewportWidth: width != null ? Math.round(width) : undefined,
      viewportHeight: height != null ? Math.round(height) : undefined,
      adLanguage: navigator.language,
      mraid: hasMraidFn()
    });
  };
};

/***/ }),

/***/ 2:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return PLATFORM_ANDROID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return PLATFORM_IOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AUDIO_POLICY_ALWAYS_MUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AUDIO_POLICY_ON_INTERACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AUDIO_POLICY_NO_RESTRICTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return EXCHANGE_ADPOPCORN; });
/* unused harmony export EXCHANGE_APPLOVIN */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return EXCHANGE_CONNATIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return EXCHANGE_DOUBLECLICK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return EXCHANGE_INNERACTIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return EXCHANGE_IRONSOURCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return EXCHANGE_MINTEGRAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return EXCHANGE_MOMENTO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return EXCHANGE_PANGLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return EXCHANGE_VERVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return EXCHANGE_VUNGLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return EXCHANGE_XIAOMI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return ORIENTATION_PORTRAIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return ORIENTATION_LANDSCAPE; });
/* unused harmony export CONNECTION_TYPE_WIFI */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return CLICK_AREA_TYPE_OTHER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CLICK_AREA_TYPE_CTA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return CLICK_METRIC_TYPE_CLOSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return CLICK_METRIC_TYPE_CTA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return CLICK_METRIC_TYPE_DEADZONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return CLICK_METRIC_TYPE_UNKNOWN; });
/* unused harmony export CLICK_REJECTION_REASON_UNKNOWN */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return CLICK_REJECTION_REASON_NO_INTERACTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CLICKTHROUGH_URL_TYPE_LIFTOFF_ENDPOINT; });
/* unused harmony export CLICKTHROUGH_URL_TYPE_APP_STORE */
/* unused harmony export CLICK_TRACKING_URL_TYPE_UNKNOWN */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return CLICK_TRACKING_URL_TYPE_LIFTOFF_ENDPOINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return TRACKING_METHOD_OPEN_METHOD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return TRACKING_METHOD_IMAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return TRACKING_METHOD_BEACON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return AUTOCLICK_TYPE_LAST_INTERACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return AUTOCLICK_TYPE_INTERACTION_COUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return AUTOCLICK_TYPE_LAST_INTERACTION_AND_INTERACTION_COUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return AUTOCLICK_TYPE_COMPLETED_DELAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return AUTOCLICK_TYPE_LOAD_DELAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return AUTOCLICK_TYPE_VIEWABLE_DELAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return AUTOCLICK_TYPE_VIEWABLE_DELAY_WITH_RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return CLICK_OPEN_METHOD_MRAID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return CLICK_OPEN_METHOD_ANCHOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return CLICK_OPEN_METHOD_LOCATION; });
var PLATFORM_ANDROID = "android";
var PLATFORM_IOS = "ios";

var AUDIO_POLICY_ALWAYS_MUTE = "always-mute";
var AUDIO_POLICY_ON_INTERACTION = "on-interaction";
var AUDIO_POLICY_NO_RESTRICTIONS = "no-restrictions";

// TODO(Casey): Use constants instead of string literals for all exchanges
// throughout.
var EXCHANGE_ADPOPCORN = "adpopcorn";
var EXCHANGE_APPLOVIN = "applovin";
var EXCHANGE_CONNATIX = "connatix";
var EXCHANGE_DOUBLECLICK = "doubleclick";
var EXCHANGE_INNERACTIVE = "inneractive-direct";
var EXCHANGE_IRONSOURCE = "ironsource";
var EXCHANGE_MINTEGRAL = "mintegral";
var EXCHANGE_MOMENTO = "momento";
var EXCHANGE_PANGLE = "pangle";
var EXCHANGE_VERVE = "verve";
var EXCHANGE_VUNGLE = "vungle";
var EXCHANGE_XIAOMI = "xiaomi";

var ORIENTATION_PORTRAIT = "portrait";
var ORIENTATION_LANDSCAPE = "landscape";

// These must correspond to the rtb.proto ConnectionType enum definition.
var CONNECTION_TYPE_WIFI = 2;

// These must correspond to the rtb.proto ClickAreaType enum definition.
var CLICK_AREA_TYPE_OTHER = 1;
var CLICK_AREA_TYPE_CTA = 3;

var CLICK_METRIC_TYPE_CLOSE = "CLOSE";
var CLICK_METRIC_TYPE_CTA = "CTA";
var CLICK_METRIC_TYPE_DEADZONE = "DEADZONE";
var CLICK_METRIC_TYPE_UNKNOWN = "UNKNOWN_CLICK_TYPE";

// This must correspond to the rtb.proto ClickRejectionReason enum definition.
var CLICK_REJECTION_REASON_UNKNOWN = 0;
var CLICK_REJECTION_REASON_NO_INTERACTIONS = 1;

// This must correspond to the auction.proto ClickthroughURLType.
var CLICKTHROUGH_URL_TYPE_LIFTOFF_ENDPOINT = 1;
var CLICKTHROUGH_URL_TYPE_APP_STORE = 2;

// This must correspond to the auction.proto ClickTrackingURLType.
var CLICK_TRACKING_URL_TYPE_UNKNOWN = 0;
var CLICK_TRACKING_URL_TYPE_LIFTOFF_ENDPOINT = 1;

// This must correspond to the rtb.proto TrackingMethod enum definition.
var TRACKING_METHOD_OPEN_METHOD = 1;
var TRACKING_METHOD_IMAGE = 2;
var TRACKING_METHOD_BEACON = 3;

var AUTOCLICK_TYPE_LAST_INTERACTION = "lastInteraction";
var AUTOCLICK_TYPE_INTERACTION_COUNT = "interactionCount";
var AUTOCLICK_TYPE_LAST_INTERACTION_AND_INTERACTION_COUNT = "lastInteractionAndInteractionCount";
var AUTOCLICK_TYPE_COMPLETED_DELAY = "completedDelay";
var AUTOCLICK_TYPE_LOAD_DELAY = "loadDelay";
var AUTOCLICK_TYPE_VIEWABLE_DELAY = "viewableDelay";
var AUTOCLICK_TYPE_VIEWABLE_DELAY_WITH_RESET = "viewableDelayWithReset";

var CLICK_OPEN_METHOD_MRAID = "mraid";
var CLICK_OPEN_METHOD_ANCHOR = "anchor";
var CLICK_OPEN_METHOD_LOCATION = "location";

/***/ }),

/***/ 20:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var patchedObjects = [];

var MonkeyPatch = function () {
  function MonkeyPatch() {
    _classCallCheck(this, MonkeyPatch);
  }

  _createClass(MonkeyPatch, null, [{
    key: "_applyPatch",

    // #if process.env.NODE_ENV === "test"
    //   static resetAll() {
    //     patchedObjects.forEach(({ obj, propertyName, dataKey, value }) => {
    //       MonkeyPatch._applyPatch(obj, propertyName, { [dataKey]: value });
    //     });
    // 
    //     // Clear the array.
    //     patchedObjects.splice(0, patchedObjects.length);
    //   }
    // #endif

    value: function _applyPatch(obj, propertyName, protoMap) {
      if (obj.propertyName !== undefined) {
        delete obj[propertyName];
      }

      try {
        // See
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/defineProperty#Description
        Object.defineProperty(obj, propertyName, protoMap);
      } catch (e) {
        // TODO(Austin): Delete added patchedObject entry?
        throw new Error("Cannot monkey patch " + obj.constructor.name + "[" + propertyName + "], because: '" + e + "'.");
      }
    }
  }, {
    key: "_patch",
    value: function _patch(obj, propertyName, dataKey, value) {
      var originalValue = Object.getOwnPropertyDescriptor(obj, propertyName)[dataKey];

      patchedObjects.push({
        obj: obj,
        propertyName: propertyName,
        dataKey: dataKey,
        value: originalValue
      });

      MonkeyPatch._applyPatch(obj, propertyName, _defineProperty({}, dataKey, value));
    }
  }, {
    key: "patchFunction",
    value: function patchFunction(obj, propertyName, fn) {
      // "value" is the property value. See doc in _applyPatch.
      MonkeyPatch._patch(obj, propertyName, "value", fn);
    }
  }, {
    key: "patchSetter",
    value: function patchSetter(obj, propertyName, fn) {
      // "set" is the property setter. See doc in _applyPatch.
      MonkeyPatch._patch(obj, propertyName, "set", fn);
    }
  }, {
    key: "patchGetter",
    value: function patchGetter(obj, propertyName, fn) {
      // "get" is the property getter. See doc in _applyPatch.
      MonkeyPatch._patch(obj, propertyName, "get", fn);
    }
  }]);

  return MonkeyPatch;
}();

/* harmony default export */ __webpack_exports__["a"] = (MonkeyPatch);

/***/ }),

/***/ 21:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return pointInCTA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return clickAreaTypeFromEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isDeadzoneCoord; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(2);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * Contains logic to determine whether cta was clicked. This is not the optimal
 * way to do it - a better way would be to include CTA location as part of the
 * creative's concept rendering configuration and to set it explicitly.
 */



var pointInEl = function pointInEl(el, x, y) {
  var _el$getBoundingClient = el.getBoundingClientRect(),
      elTop = _el$getBoundingClient.top,
      elRight = _el$getBoundingClient.right,
      elBottom = _el$getBoundingClient.bottom,
      elLeft = _el$getBoundingClient.left;

  return x >= elLeft && x <= elRight && y >= elTop && y <= elBottom;
};

/**
 * Returns true iff (x, y) is within the bounds of a CTA. We
 * consider an element to be a "CTA element" if it's part of the generic-cta or
 * custom-cta components or is in a container that has 'cta' in the id. This can
 * give both false positives (e.g. if a non-CTA image is placed in a CTA
 * container) and false negatives (e.g. if a CTA is embedded in a larger image
 * in one of the "fill" templates), but it's probably close to the best we can
 * do without manual tagging. We include all descendants of cta
 * containers/components, because sometimes their children overflow.
 */
var pointInCTA = function pointInCTA(x, y) {
  return [].concat(_toConsumableArray(document.querySelectorAll([".generic-cta", ".generic-cta *", ".custom-cta", ".custom-cta *", ".cta-container", ".cta-container *", ".liftoff-cta", ".liftoff-cta *", ".product-view-cta .light", ".last-chance-endscreen-container"].join(", ")))).some(function (ctaEl) {
    return pointInEl(ctaEl, x, y);
  });
};

/**
 * Returns true iff e is a MouseEvent that occurred over a CTA.
 */
var clickAreaTypeFromEvent = function clickAreaTypeFromEvent(e) {
  return pointInCTA(e.clientX, e.clientY) ? __WEBPACK_IMPORTED_MODULE_0__constants__["l" /* CLICK_AREA_TYPE_CTA */] : __WEBPACK_IMPORTED_MODULE_0__constants__["m" /* CLICK_AREA_TYPE_OTHER */];
};

var isDeadzoneCoord = function isDeadzoneCoord(_ref) {
  var x = _ref.x,
      y = _ref.y;

  if (!Number.isFinite(x) || !Number.isFinite(y)) {
    console.warn("Unexpected coords", { x: x, y: y });
    return;
  }
  return [].concat(_toConsumableArray(document.body.querySelectorAll(".liftoff-deadzone"))).some(function (el) {
    return pointInEl(el, x, y);
  });
};

/***/ }),

/***/ 22:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MESSAGE_CREATIVE_MADE_SOUND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return MESSAGE_TOGGLE_MUTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return MESSAGE_INTERACTION_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MESSAGE_CLICKTHROUGH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return MESSAGE_MRAID_EVENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return MESSAGE_MRAID_CALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return MESSAGE_UPDATED_MRAID_PROPERTIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return MESSAGE_INNER_ENV_INIT_COMPLETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return MESSAGE_OUTER_ENV_INIT_COMPLETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return MESSAGE_REQUEST_DOM_SNAPSHOT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MESSAGE_DOM_SNAPSHOT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MESSAGE_INNER_ENV_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return MESSAGE_RESIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return MESSAGE_VUNGLE_CLICKTHROUGH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return MESSAGE_TRESENSA_INTERACTION; });
var MESSAGE_CREATIVE_MADE_SOUND = "CREATIVE_MADE_SOUND";
var MESSAGE_TOGGLE_MUTED = "TOGGLE_MUTED";
var MESSAGE_INTERACTION_CHANGE = "INTERACTION_CHANGE";
var MESSAGE_CLICKTHROUGH = "CLICKTHROUGH";
var MESSAGE_MRAID_EVENT = "MRAID_EVENT";
var MESSAGE_MRAID_CALL = "MRAID_CALL";
var MESSAGE_UPDATED_MRAID_PROPERTIES = "UPDATED_MRAID_PROPERTIES";
var MESSAGE_INNER_ENV_INIT_COMPLETE = "INNER_ENV_INIT_COMPLETE";
var MESSAGE_OUTER_ENV_INIT_COMPLETE = "OUTER_ENV_INIT_COMPLETE";
var MESSAGE_REQUEST_DOM_SNAPSHOT = "REQUEST_DOM_SNAPSHOT";
var MESSAGE_DOM_SNAPSHOT = "DOM_SNAPSHOT";
var MESSAGE_INNER_ENV_ERROR = "INNER_ENV_ERROR";
var MESSAGE_RESIZE = "RESIZE";

// External Messages from Vungle.
var MESSAGE_VUNGLE_CLICKTHROUGH = "download";

// External Messages from Tresensa creatives.
var MESSAGE_TRESENSA_INTERACTION = "tre_interaction";

/***/ }),

/***/ 255:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_audio_toggle_icon__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__error_handling__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__creative_utils__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__click_handling__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__content_frame__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__env_data__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__outer_mraid__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__liftoff_mraid__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__logger__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__adexp__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__frontendlib_dom_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__autoclick_Autoclick__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__addDeadzones__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lib_last_chance_endscreen_last_chance_endscreen__ = __webpack_require__(68);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }


















// #if process.env.NODE_ENV === "test"
// const testResetFunctions = [];
// const resetForTests = () => {
//   testResetFunctions.forEach((fn) => fn());
//   testResetFunctions.splice(0, testResetFunctions.length);
// };
// #endif

var createGlobalAudioToggle = function createGlobalAudioToggle(contentFrame) {
  var el = document.createElement("div");
  el.classList.add("liftoff-global-audio-toggle");
  Object.assign(el.style, {
    opacity: "0.5",
    display: "none",
    "pointer-events": "all",
    right: "0",
    bottom: "0",
    position: "absolute"
  });
  var icon = new __WEBPACK_IMPORTED_MODULE_0__lib_audio_toggle_icon__["a" /* default */]();
  var iconEl = icon.getElement();
  el.appendChild(iconEl);

  var isCurrentlyMuted = false;
  var setMuted = function setMuted(shouldMute) {
    if (shouldMute === isCurrentlyMuted) {
      return;
    }
    isCurrentlyMuted = shouldMute;
    contentFrame.setMuted(shouldMute);
    icon.setMuted(shouldMute);
  };

  var firstInteractionOccurred = false;

  contentFrame.onInteractionChange(function () {
    if (firstInteractionOccurred) {
      return;
    }

    firstInteractionOccurred = true;
    setMuted(false);
  });

  iconEl.addEventListener("click", function () {
    setMuted(!isCurrentlyMuted);
  });

  contentFrame.onMadeSound(function () {
    el.style.display = "inline-block";
  });

  setMuted(true);
  return el;
};

var applyDocumentElStyles = function applyDocumentElStyles(docEl) {
  Object.assign(docEl.style, {
    width: "100%",
    height: "100%"
  });
  Object.assign(docEl.querySelector("body").style, {
    width: "100%",
    height: "100%",
    margin: 0,
    overflow: "hidden"
  });
};

var initContainerEl = function initContainerEl(containerEl, platform) {
  // NOTE(Austin): In my testing, only the body style mattered. But the html
  // style shouldn't hurt. We might want to also investigate only setting the
  // width and height to the creative's size.
  applyDocumentElStyles(document.documentElement);

  Object.assign(containerEl.style, {
    position: "absolute",
    // NOTE(Casey): In testing, we've observed exchange elements overlaying our
    // content and preventing clickthroughs. Setting a z-index can prevent this
    // in some cases, though it's not clear we want to put our content over all
    // exchange elements in every case.
    // TODO(Casey): Reconsider this after
    // testing.
    zIndex: "1",
    top: "0",
    left: "0",
    width: "100%",
    height: "100%",
    fontSize: "14px",
    lineHeight: "1.5",
    fontFamily: platform === "ios" ? "Helvetica Neue,Helvetica,Arial,sans-serif" : "Roboto,Helvetica,Arial,sans-serif"
  });
};

var makeScriptEl = function makeScriptEl(_ref) {
  var srcURL = _ref.srcURL,
      content = _ref.content;

  if (srcURL != null && content != null) {
    console.warn("Creating a script element with a src and content will result" + " in only src being set!");
  }
  var scriptEl = document.createElement("script");
  scriptEl.type = "application/javascript";
  if (srcURL != null) {
    scriptEl.src = srcURL;
  } else if (content != null) {
    scriptEl.innerText = content;
  }

  return scriptEl;
};

var makeBaseEl = function makeBaseEl(baseURL) {
  if (baseURL == null || baseURL.length === 0) {
    return null;
  }

  var baseEl = document.createElement("base");
  baseEl.href = baseURL;
  return baseEl;
};

var prependToDocumentHeader = function prependToDocumentHeader(documentEl, elsToPrepend) {
  elsToPrepend.reverse().forEach(function (el) {
    if (el == null) {
      return;
    }
    documentEl.insertBefore(el, documentEl.children[0]);
  });
};

var htmlStringToDocumentElement = function htmlStringToDocumentElement(htmlString) {
  var doc = document.implementation.createHTMLDocument("");
  // NOTE(Casey): We previously tried inserting the third-party HTML into the
  // document using document.write, but this failed on some exchanges in
  // testing. We've also tried inserting it by setting innerHTML of the document
  // body, but this removes body attributes set in third-party HTML that are
  // required by some creatives. The current approach of setting innerHTML of
  // the html element will prevent html element attributes specified in the
  // third-party HTML from being copied over, so we may need to find a
  // work-around in the future if this breaks any creatives.
  doc.querySelector("html").innerHTML = htmlString;
  return doc.documentElement;
};

var processHTML = function processHTML(_ref2) {
  var rawHTML = _ref2.rawHTML,
      rootURL = _ref2.rootURL,
      scriptSrcURLs = _ref2.scriptSrcURLs,
      envData = _ref2.envData,
      inProd = _ref2.inProd;

  var processedHTML = rawHTML.replace(/\$\{CLICK_URL\}|\$\{CLICKTHROUGH_URL\}/g, envData.getClickthroughURL());

  // Replace the liftoff_api.js v1 script with the liftoff.js v2 script in the
  // DB.
  // TODO(Casey): Remove this when we're fully transitioned to v2.
  var cdnUrl = envData.getCDNUrl();

  var liftoffJSv2Location = inProd ? cdnUrl + "/api/v2/adcreative/liftoff.js?v=2" : window.location.origin + "/dev/madlib_ad_markup/main/v2/liftoff.js";
  processedHTML = processedHTML.replace("https://cdn.liftoff.io/api/v1/adcreative/liftoff_api.js", liftoffJSv2Location);

  // NOTE(Austin): This is done to make sure any leftover hard-coded URLs are
  // replaced with china-friendly URLs (so we can spend in China).
  processedHTML = processedHTML.replace(/http[s]*:\/\/cdn\.liftoff\.io/, cdnUrl);

  var docEl = htmlStringToDocumentElement(processedHTML);
  applyDocumentElStyles(docEl);

  // NOTE(Casey): Developers may include <script src="mraid.js"></script> in
  // their markup. Since we provide mraid in the iframe rather than loading it
  // from an external source we remove this tag here. If we find that some
  // developers load this script asynchronously, we may in the future provide an
  // empty "mraid.js" in the creative's root folder at ingestion-time.
  docEl.querySelectorAll("script[src='mraid.js']").forEach(function (mraidScriptEl) {
    mraidScriptEl.remove();
  });

  var liftoffJSScriptNodes = docEl.querySelectorAll("script[src='" + liftoffJSv2Location + "']");
  if (liftoffJSScriptNodes.length === 0) {
    // Add the liftoff.js v2 source if they didn't add it, just in case they
    // need it (and forgot to include it).
    prependToDocumentHeader(docEl, [makeScriptEl({
      srcURL: liftoffJSv2Location
    })]);
  }

  var encodedJSON = encodeURIComponent(envData.asJSON());
  prependToDocumentHeader(docEl, [
  // If rootURL is null or "", makeBaseEl will return null. Null values aren't
  // prepended.
  makeBaseEl(rootURL)].concat(_toConsumableArray(scriptSrcURLs.map(function (srcURL) {
    return makeScriptEl({ srcURL: srcURL });
  })), [makeScriptEl({
    content: "LiftoffInnerEnv.init(JSON.parse(decodeURIComponent(\"" + encodedJSON + "\")), \"" + rootURL + "\");"
  }),
  // For Playrix
  makeScriptEl({
    content: ["window.addEventListener(\"load\", function () {", "  window.clickInstall = typeof Liftoff !== \"undefined\" ? Liftoff.open : window.open;", "});"].join(" ")
  })]));

  return docEl.outerHTML;
};

var applyLiftoffPolicy = function applyLiftoffPolicy(envData, containerEl, contentFrame) {
  __WEBPACK_IMPORTED_MODULE_2__creative_utils__["a" /* applyLiftoffPolicy */](containerEl, {
    addBorder: envData.getAddBorder(),
    removeAdWrapper: envData.getRemoveAdWrapper(),
    showAdChoices: envData.getShowAdChoices(),
    russianAgeRating: envData.getRussianAgeRating(),
    showChineseWatermark: envData.getShowChineseWatermark(),
    useCustomClose: envData.getUseCustomClose(),
    closeDelay: envData.getCloseDelay(),
    // NOTE(Casey): We allow the outer/inner envs to coordinate control of the
    // audio policy, so we set it to NO_RESTRICTIONS here to ensure
    // CreativeUtils is not applying audio policy control.
    // TODO(Casey):
    // Deprecate this functionality in CreativeUtils.applyLiftoffPolicy when
    // fully transitioned to v2.
    audioPolicy: __WEBPACK_IMPORTED_MODULE_5__constants__["b" /* AUDIO_POLICY_NO_RESTRICTIONS */]
  }, {
    creativeID: envData.getCreativeID(),
    platform: envData.getDevicePlatform(),
    exchange: envData.getExchange(),
    sourceAppName: envData.getSourceAppName(),
    sourceAppID: envData.getSourceAppID(),
    cdnURL: envData.getCDNUrl()
  });

  // TODO(Casey): Remove handling of audio policy in CreativeUtils when CSP v1
  // is fully deprecated.
  var audioPolicy = envData.getAudioPolicy();
  if (audioPolicy === __WEBPACK_IMPORTED_MODULE_5__constants__["c" /* AUDIO_POLICY_ON_INTERACTION */]) {
    var globalAudioToggleEl = createGlobalAudioToggle(contentFrame);
    containerEl.appendChild(globalAudioToggleEl);
  }
};

var loadExternalHTML = function loadExternalHTML(url) {
  return new Promise(function (resolve, reject) {
    var xhr = new XMLHttpRequest();
    xhr.addEventListener("load", function () {
      resolve(xhr.responseText);
    });
    xhr.addEventListener("readystatechange", function () {
      var STATE_DONE = 4;
      if (xhr.readyState === STATE_DONE && xhr.status >= 400) {
        reject(new Error("Got " + xhr.status + " when loading " + url + "."));
      }
    });
    xhr.addEventListener("error", function () {
      reject(new Error("Failed to GET " + url));
    });
    xhr.open("GET", url);
    xhr.send();
  });
};

var getCompleteDOMSnapshot = function getCompleteDOMSnapshot(contentFrame) {
  return contentFrame.getDOMSnapshot().then(function (innerEnvHTML) {
    var outerEnvHTML = __WEBPACK_IMPORTED_MODULE_2__creative_utils__["c" /* getDOMSnapshot */]();
    var completeSnapshot = ["<!-- Start outer environment HTML -->", outerEnvHTML, "<!-- End outer environment HTML>", "<!-- Start inner environment HTML -->", innerEnvHTML, "<!-- End inner environment HTML -->"];
    return completeSnapshot.join("\n");
  });
};

var configureHTMLReturn = function configureHTMLReturn(envData, contentFrame) {
  if (!envData.getEnableHTMLReturn()) {
    return;
  }

  var htmlReturnDelay = envData.getHTMLReturnDelay();

  // NOTE(Austin): Since we start this before we've checked that the content
  // frame has loaded, the dom snapshot may or may not return a loaded content
  // frame. This is done intentionally to guarantee we get html returns even
  // when things fail.
  setTimeout(function () {
    getCompleteDOMSnapshot(contentFrame).then(function (completeDOMSnapshot) {
      __WEBPACK_IMPORTED_MODULE_2__creative_utils__["d" /* postHTMLReturn */](envData.getLoggingEndpoint(), completeDOMSnapshot);
    });
  }, htmlReturnDelay || 0);
};

var processNormalizedError = function processNormalizedError(errorObj) {
  try {
    var errorStr = errorObj.message || errorObj.toString();
    if (Object(__WEBPACK_IMPORTED_MODULE_1__error_handling__["e" /* shouldIgnoreError */])(errorObj)) {
      console.warn("Ignoring error: " + errorStr);
      return;
    }

    __WEBPACK_IMPORTED_MODULE_9__logger__["a" /* default */].recordError(errorObj);
  } catch (processingError) {
    // Avoid infinite loops.
    console.error("Error in processError: " + processingError.message);
  }
};

var configureErrorLogging = function configureErrorLogging(envData, contentFrame) {
  var processErrorEvent = function processErrorEvent(event) {
    if (event == null) {
      return;
    }

    // #if process.env.NODE_ENV === "test"
    //     if (isTestError(event.reason)) {
    //       return;
    //     }
    // #endif

    var normalizedError = Object(__WEBPACK_IMPORTED_MODULE_1__error_handling__["c" /* normalizeErrorEvent */])(event);
    if (normalizedError != null) {
      processNormalizedError(normalizedError);
    }
  };

  var processRejectionEvent = function processRejectionEvent(event) {
    if (event == null) {
      return;
    }

    // #if process.env.NODE_ENV === "test"
    //     if (isTestError(event.reason)) {
    //       return;
    //     }
    // #endif

    var normalizedError = Object(__WEBPACK_IMPORTED_MODULE_1__error_handling__["d" /* normalizePromiseRejectionEvent */])(event);
    if (normalizedError != null) {
      processNormalizedError(normalizedError);
    }
  };

  window.addEventListener("error", processErrorEvent);
  window.addEventListener("unhandledrejection", processRejectionEvent);
  contentFrame.onError(processNormalizedError);

  // #if process.env.NODE_ENV === "test"
  //   testResetFunctions.push(() => {
  //     window.removeEventListener("error", processErrorEvent);
  //     window.removeEventListener("unhandledrejection", processRejectionEvent);
  //   });
  // #endif
};

var configureLogging = function configureLogging(envData, contentFrame) {
  if (!envData.getEnableLogging()) {
    console.warn("Logging is not enabled.");
    return;
  }
  configureErrorLogging(envData, contentFrame);
  configureHTMLReturn(envData, contentFrame);
};

/**
 * NOTE(Casey): Celtra creatives determine their own destination URL, so we need
 * to open that rather than use our click configuration. Celtra notifies our
 * click endpoint (provided in a macro replaced in admarkup.core) server-side.
 * We use mraid/window.open directly to avoid discrepancies on Celtra's side due
 * to possible dysfunction of the click waterfall. (Celtra's creatives use
 * mraid.)
 */
var isCeltraClickthrough = function isCeltraClickthrough(interceptedDestinationURL) {
  try {
    var destURL = new URL(interceptedDestinationURL);
    return destURL.host.includes("celtra");
  } catch (_) {
    return false;
  }
};

var handleCreativeManagedClickthrough = function handleCreativeManagedClickthrough(interceptedDestinationURL) {
  if (window.mraid != null && window.mraid.open != null) {
    window.mraid.open(interceptedDestinationURL);
  } else {
    window.open(interceptedDestinationURL);
  }
};

// On iOS, touch events do not work inside iframes unless the outer window has
// at least one touch event listener. See
// https://stackoverflow.com/a/50483933/7926897.
var enableIframeTouchEvents = function enableIframeTouchEvents() {
  var handler = function handler() {
    return null;
  };
  window.addEventListener("touchstart", handler);
  // #if process.env.NODE_ENV === "test"
  //   testResetFunctions.push(() => {
  //     window.removeEventListener("touchstart", handler);
  //   });
  // #endif
};

// We're running some Bing, Revcontent & Taboola creatives for 3BlueMedia that
// handle click notifications and that redirect via a bing.com, revcontent.com
// or taboola.com URL.
// On the other hand we have customer DiDi Rider who wants to use DoubleClick
// Campaign Manager's impression tag for rendering and click tracking, and
// customer FanDuel wants to use FlashingTalk tag for same purpose. Their CSP
// creatives do the same as 3BlueMedia ones do by pinging our click tracking and
// mraid.open() the 3rd party tracking URLs to be redirected to dest app page.
// Bannerflow was added due to draftkings 3rd party dynamic ad creatives.
var isCreativeManagedClickthrough = function isCreativeManagedClickthrough(destURL) {
  var allowedPrefixRegExp = new RegExp("^https?://([^/]+\\.)*((bannerflow|bing|revcontent|taboola|flashtalking)\\.com|(doubleclick|bannerflow)\\.net)$", "i");
  try {
    var validatedUrl = new URL(destURL);
    return allowedPrefixRegExp.test(validatedUrl.origin);
  } catch (ex) {
    return false;
  }
};

var validateContentFrame = function validateContentFrame(contentFrame) {
  var errors = [];
  return new Promise(function (resolve) {
    contentFrame.containsIframe().then(function (hasIframe) {
      if (hasIframe) {
        errors.push("Contains iframe");
      }
      resolve({ errors: errors });
    });
  });
};

var validationResultPromise = void 0;
var validationListeners = [];
var vxInteractionListeners = [];

var LiftoffOuterEnv = function () {
  function LiftoffOuterEnv() {
    _classCallCheck(this, LiftoffOuterEnv);
  }

  _createClass(LiftoffOuterEnv, null, [{
    key: "init",

    // ScriptSrcURLs should be [polyfills, innerEnvScript]
    value: function init(_ref3) {
      var _this = this;

      var containerEl = _ref3.containerEl,
          _ref3$validationCheck = _ref3.validationCheck,
          validationCheck = _ref3$validationCheck === undefined ? false : _ref3$validationCheck,
          rawEnvData = _ref3.envData,
          _ref3$scriptSrcURLs = _ref3.scriptSrcURLs,
          scriptSrcURLs = _ref3$scriptSrcURLs === undefined ? [] : _ref3$scriptSrcURLs,
          rootURL = _ref3.rootURL,
          html = _ref3.html,
          externalHtmlURL = _ref3.externalHtmlURL,
          inProd = _ref3.inProd,
          _ref3$onViewableTrack = _ref3.onViewableTrackingTags,
          onViewableTrackingTags = _ref3$onViewableTrack === undefined ? [] : _ref3$onViewableTrack,
          useAutoendcardBehaviour = _ref3.useAutoendcardBehaviour;

      if (onViewableTrackingTags != null) {
        __WEBPACK_IMPORTED_MODULE_8__liftoff_mraid__["a" /* default */].onViewable(function () {
          var trackingTagHolder = document.getElementById("tracking-tag-holder");
          Object(__WEBPACK_IMPORTED_MODULE_12__frontendlib_dom_utils__["appendImpressionTags"])(trackingTagHolder, onViewableTrackingTags);
        });
      }

      var envData = new __WEBPACK_IMPORTED_MODULE_6__env_data__["a" /* default */](rawEnvData);
      if (envData.getIsInterstitial() &&
      // TODO(oscar): Remove after crserve-deadzone test is over.
      envData.hasABTestGroup("crserve-deadzone-v2-experiment")) {
        Object(__WEBPACK_IMPORTED_MODULE_14__addDeadzones__["a" /* addDeadzoneStyles */])();
        Object(__WEBPACK_IMPORTED_MODULE_14__addDeadzones__["b" /* default */])(true, containerEl);
      }

      Object(__WEBPACK_IMPORTED_MODULE_7__outer_mraid__["c" /* initOuterMraid */])();
      enableIframeTouchEvents();
      initContainerEl(containerEl, envData.getDevicePlatform());

      Object(__WEBPACK_IMPORTED_MODULE_11__common__["a" /* loadLogger */])(envData, Object(__WEBPACK_IMPORTED_MODULE_10__adexp__["e" /* getAdexpContextSnapshotFn */])(containerEl, function () {
        return __WEBPACK_IMPORTED_MODULE_8__liftoff_mraid__["a" /* default */].hasSupport("mraid");
      }));

      /** @type {Autoclick[]} */
      var autoclickBus = [];
      __WEBPACK_IMPORTED_MODULE_8__liftoff_mraid__["a" /* default */].on("clickMethodTried", function (_ref4) {
        var clickOpenMethod = _ref4.clickOpenMethod,
            isAutoclick = _ref4.isAutoclick;

        if (isAutoclick && clickOpenMethod === __WEBPACK_IMPORTED_MODULE_5__constants__["t" /* CLICK_OPEN_METHOD_MRAID */]) {
          __WEBPACK_IMPORTED_MODULE_9__logger__["a" /* default */].recordMetricV2("mraid_autoclick_fired_ms", Date.now() - LIFTOFF_START_TS);
        }
      });

      var env = envData._envData;
      var appStoreData = env.appStoreData;
      // Note(Gibin): Flag to prevent init of AutoEndcard in Tresensa creatives more than once.
      var isTresensaAutoEndcardInit = false;
      var lastChanceEndscreenAutoclick = void 0;
      var autoEndcard = void 0;

      if (appStoreData) {
        autoEndcard = new __WEBPACK_IMPORTED_MODULE_15__lib_last_chance_endscreen_last_chance_endscreen__["a" /* default */](appStoreData, containerEl, function (e) {
          _this.handleClickthrough({
            viewclick: viewclick,
            containerEl: containerEl,
            envData: envData,
            allInteractionData: e,
            interceptedDestinationURL: "",
            // Use ae custom parameter to indicate that click was triggered from
            // the auto-endcard.
            customerQueryParams: { ae: true },
            // TODO(oscar): Figure out if this is a Tresensa Creative.
            isTresensaCreative: null
          });
        }, env.exchange === "inmobi", env);
      }

      var viewclick = new __WEBPACK_IMPORTED_MODULE_13__autoclick_Autoclick__["a" /* default */](envData.getViewclickBehavior(), {
        clickthroughHandler: function clickthroughHandler(e) {
          _this.handleClickthrough({
            viewclick: viewclick,
            containerEl: containerEl,
            envData: envData,
            interceptedDestinationURL: "",
            allInteractionData: e,
            customerQueryParams: { mac: 1 },
            // TODO(oscar): Figure out if this is a Tresensa Creative.
            isTresensaCreative: null
          });
        }
      });
      autoclickBus.push(viewclick);

      useAutoendcardBehaviour = envData.getLastChanceAutoclickBehavior();
      // If exchange is mintegral then only display the auto endcard on delay if
      // platform is ios.
      if (useAutoendcardBehaviour && (env.exchange != "mintegral" || env.platform === "ios")) {
        // Autoclick when user doesn't interact and AutoEndcard is shown after 5 seconds
        lastChanceEndscreenAutoclick = new __WEBPACK_IMPORTED_MODULE_13__autoclick_Autoclick__["a" /* default */](useAutoendcardBehaviour, {
          clickthroughHandler: function clickthroughHandler() {
            if (autoEndcard) {
              autoEndcard.initAutoEndcard();
            }
          }
        });
        autoclickBus.push(lastChanceEndscreenAutoclick);
      }

      // Autoclick when user interacts and AutoEndcard is shown 7 seconds after the first interaction
      var lastChanceEndscreenInteractionAutoclick = new __WEBPACK_IMPORTED_MODULE_13__autoclick_Autoclick__["a" /* default */](envData.getLastChanceInteractionAutoclickBehavior(), {
        clickthroughHandler: function clickthroughHandler() {
          if (autoEndcard) {
            autoEndcard.initAutoEndcard();
          }
        }
      });
      autoclickBus.push(lastChanceEndscreenInteractionAutoclick);
      __WEBPACK_IMPORTED_MODULE_9__logger__["a" /* default */].recordMetricV2("initial_load_count", 1);
      __WEBPACK_IMPORTED_MODULE_8__liftoff_mraid__["a" /* default */].onViewable(function () {
        __WEBPACK_IMPORTED_MODULE_9__logger__["a" /* default */].recordMetricV2("first_viewable_ms", Date.now() - LIFTOFF_START_TS);
      });
      __WEBPACK_IMPORTED_MODULE_8__liftoff_mraid__["a" /* default */].onViewable(function (e) {
        autoclickBus.forEach(function (ac) {
          return ac.emitViewableEvent(e);
        });
      }, true);
      __WEBPACK_IMPORTED_MODULE_8__liftoff_mraid__["a" /* default */].onViewableChange(function (e) {
        autoclickBus.forEach(function (ac) {
          return ac.emitViewableChangeEvent(e);
        });
      });

      var htmlLoadedPromise = html != null ? Promise.resolve(decodeURIComponent(html)) : loadExternalHTML(externalHtmlURL);

      return htmlLoadedPromise.then(function (htmlToLoad) {
        var processedHTML = processHTML({
          envData: envData,
          rawHTML: htmlToLoad,
          rootURL: rootURL,
          scriptSrcURLs: scriptSrcURLs,
          inProd: inProd
        });
        var contentFrame = new __WEBPACK_IMPORTED_MODULE_4__content_frame__["a" /* default */]({
          envData: envData,
          containerEl: containerEl,
          processedHTML: processedHTML,
          name: "outer_env"
        });
        contentFrame.onTresensaInteraction(function () {
          // NOTE(Sangeeth): The onTreSensaInteraction handler is only called
          // for tresensa client wrapped playables. These playables run inside
          // an iframe so we can't detect interaction events for them through
          // the interaction monitor.
          vxInteractionListeners.forEach(function (cb) {
            return cb();
          });
          if (lastChanceEndscreenAutoclick) {
            lastChanceEndscreenAutoclick.disable();
          }
          // TODO(Luis): This is a temporary fix to handle the case where the
          // interaction event is triggered from a TreSensa wrapped 3p.
          // Eventually this needs to be deleted and updated so that a
          // tre_interaction event does trigger a global interaction that can be
          // detected by the AutoClick interaction behaviour.
          if (!isTresensaAutoEndcardInit && autoEndcard && lastChanceEndscreenInteractionAutoclick && lastChanceEndscreenInteractionAutoclick._behavior && lastChanceEndscreenInteractionAutoclick._behavior.delay) {
            isTresensaAutoEndcardInit = true;
            setTimeout(function () {
              autoEndcard.initAutoEndcard();
            }, lastChanceEndscreenInteractionAutoclick._behavior.delay);
          }
        });
        contentFrame.onInteractionChange(function (e) {
          if (lastChanceEndscreenAutoclick) {
            lastChanceEndscreenAutoclick.disable();
          }
          vxInteractionListeners.forEach(function (cb) {
            return cb(e);
          });
          autoclickBus.forEach(function (ac) {
            return ac.emitInteractionEvent(e);
          });
        });
        if (validationCheck) {
          validationResultPromise = new Promise(function (resolve, reject) {
            validateContentFrame(contentFrame).then(resolve);
            // #if process.env.NODE_ENV === "test"
            //             testResetFunctions.push(reject);
            // #endif
          });

          validationResultPromise.then(function (result) {
            validationListeners.forEach(function (cb) {
              return cb(result);
            });
          });
        }
        // #if process.env.NODE_ENV === "test"
        //         testResetFunctions.push(() => {
        //           contentFrame.reset();
        //           validationResultPromise = null;
        //           validationListeners.splice(0, validationListeners.length);
        //         });
        // #endif
        configureLogging(envData, contentFrame);
        return contentFrame.getInitCompletePromise();
      }).catch(function (e) {
        if (!envData.getIsStaffDevice()) {
          var canUnload = window.mraid != null && window.mraid.unload != null;

          if (canUnload) {
            // We know the creative is broken. To prevent bad UX, close the Ad
            // if this is on a non-staff device.
            window.mraid.unload();
          }
        }
        console.error(e);
      }).then(function (contentFrame) {
        var updateMraidProperties = function updateMraidProperties() {
          contentFrame.updateMraidProperties(Object(__WEBPACK_IMPORTED_MODULE_7__outer_mraid__["b" /* getMraidProperties */])());
        };

        contentFrame.onMraidCall(function (methodName, args) {
          Object(__WEBPACK_IMPORTED_MODULE_7__outer_mraid__["a" /* callMraidMethod */])(methodName, args, contentFrame.notifyOfMraidError.bind(contentFrame));
          updateMraidProperties();
        });

        // NOTE(oscar): The inner env uses synchronous MRAID calls to fetch data
        // that the outer env can only provide asynchronously. Therefore, the
        // inner env has a cache that the outer env needs to update preemptively
        // before any 3rd party code uses out-dated information.
        // Despite it not being a 100% solvable race condition as 3rd party code
        // can always run in the delay between updates, we can mitigate it
        // substantially by hijacking inner env's events so they don't fire
        // until after the updates.
        // E.g. MRAID properties are likely to change during resize, orientation
        // change, and viewable change events.
        // TODO(oscar): Consider hijacking more events.
        window.addEventListener("resize", function () {
          updateMraidProperties();
          contentFrame.notifyOfResize();
        }, { capture: true, passive: true });

        Object(__WEBPACK_IMPORTED_MODULE_7__outer_mraid__["d" /* onMraidStateChangeEvent */])(updateMraidProperties);
        updateMraidProperties();

        // NOTE(Casey): We're currently not relaying error events to the inner
        // env, because these might be caused by calls we make to mraid of which
        // the third-party developer is naive.
        Object(__WEBPACK_IMPORTED_MODULE_7__outer_mraid__["d" /* onMraidStateChangeEvent */])(contentFrame.notifyOfMraidEvent.bind(contentFrame));

        contentFrame.onClickthrough(function (interceptedDestinationURL, allInteractionData, customerQueryParams, isTresensaCreative) {
          _this.handleClickthrough({
            viewclick: viewclick,
            containerEl: containerEl,
            envData: envData,
            interceptedDestinationURL: interceptedDestinationURL,
            allInteractionData: allInteractionData,
            customerQueryParams: customerQueryParams,
            isTresensaCreative: isTresensaCreative
          });
        });

        applyLiftoffPolicy(envData, containerEl, contentFrame);
        contentFrame.notifyOfInitComplete();

        // TODO(Austin): Consider more useful places to log this.
        __WEBPACK_IMPORTED_MODULE_9__logger__["a" /* default */].recordMetricV2("load_time_ms", Date.now() - LIFTOFF_START_TS);
        autoclickBus.forEach(function (ac) {
          return ac.emitHtmlLoadedEvent();
        });
      });
    }

    // Called indirectly from interactions and navigation events.
    // interceptedDestinationURL may be null if the click was opened via
    // Liftoff.open.

  }, {
    key: "handleClickthrough",
    value: function handleClickthrough(_ref5) {
      var viewclick = _ref5.viewclick,
          containerEl = _ref5.containerEl,
          envData = _ref5.envData,
          interceptedDestinationURL = _ref5.interceptedDestinationURL,
          allInteractionData = _ref5.allInteractionData,
          customerQueryParams = _ref5.customerQueryParams,
          isTresensaCreative = _ref5.isTresensaCreative,
          _ref5$attachAppStoreM = _ref5.attachAppStoreModal,
          attachAppStoreModal = _ref5$attachAppStoreM === undefined ? null : _ref5$attachAppStoreM;

      // NOTE(oscar): We don't want to emit multiple MMP clicks. Product view clicks
      // do not emit MMP clicks.
      if (!customerQueryParams.pv) {
        viewclick.disable();
      }
      if (isCreativeManagedClickthrough(interceptedDestinationURL)) {
        handleCreativeManagedClickthrough(interceptedDestinationURL);
        return;
      }
      if (!customerQueryParams.dap && !customerQueryParams.dact && !isTresensaCreative && allInteractionData == null && !customerQueryParams.mac &&
      // NOTE(oscar): It's possible for allInteractionData to be null for ASOD
      // autoclicks.
      !customerQueryParams.pv) {
        // Ignore clickthroughs derived from no user interaction. Exchanges probably
        // block these types of clickthroughs anyways, but we want to avoid pinging
        // tracking urls.
        __WEBPACK_IMPORTED_MODULE_9__logger__["a" /* default */].recordMetricV2("click_rejection_reason", // should match adexp.go:normalizeMetricV2
        __WEBPACK_IMPORTED_MODULE_5__constants__["u" /* CLICK_REJECTION_REASON_NO_INTERACTIONS */]);
        return;
      }

      if (isCeltraClickthrough(interceptedDestinationURL)) {
        // TODO(Casey): Use ClickHandling.handleClick once the click waterfall is
        // cleaned up.
        handleCreativeManagedClickthrough(interceptedDestinationURL);
        return;
      }

      var clickTrackingParams = __WEBPACK_IMPORTED_MODULE_3__click_handling__["a" /* getClickTrackingQueryParams */](allInteractionData);

      var queryParams = Object.assign({}, clickTrackingParams, customerQueryParams);

      __WEBPACK_IMPORTED_MODULE_3__click_handling__["b" /* handleClick */]({
        clickConfig: envData.getClickConfig(),
        queryParams: queryParams,
        isReengagement: envData.getIsReengagement(),
        platform: envData.getDevicePlatform(),
        exchange: envData.getExchange(),
        abTests: envData.getABTests(),
        // NOTE(Josh): The below parameters are being used temporarily for the app
        // store preview experiment.
        modalContainerEl: containerEl,
        attachAppStoreModal: attachAppStoreModal
      });
    }

    // This function is used by the jsonp callback in the mustache file

  }, {
    key: "handleAppStorePreviewJSON",
    value: function handleAppStorePreviewJSON(json) {
      if (this.cdnURL != null) {
        this.appStoreModalContext = createAppStoreModalContext(json, this.cdnURL);
      }
    }
  }, {
    key: "addValidationListener",
    value: function addValidationListener(cb) {
      if (validationResultPromise != null) {
        validationResultPromise.then(cb);
      } else {
        validationListeners.push(cb);
      }
    }

    /**
     * Enables exclusive format creatives to listen for Madlib CSP interaction events.
     * Note: This method does not register interaction events for non CSP Madlibs.
     */

  }, {
    key: "addVXInteractionEventListener",
    value: function addVXInteractionEventListener(cb) {
      vxInteractionListeners.push(cb);
    }
  }]);

  return LiftoffOuterEnv;
}();

window.LiftoffOuterEnv = LiftoffOuterEnv;

// #if process.env.NODE_ENV === "test"
// export {
//   isCeltraClickthrough,
//   LiftoffOuterEnv,
//   processHTML,
//   htmlStringToDocumentElement,
//   makeScriptEl,
//   makeBaseEl,
//   prependToDocumentHeader,
//   resetForTests,
//   isCreativeManagedClickthrough,
// };
// #endif

/***/ }),

/***/ 256:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__messenger__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mraid_constants__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__messages__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






/*
 * Using document.write or srcdoc will cause document parsing to fail
 * midway if a script fails to load. This method uses DOMParser, which
 * builds a document with scripts that haven't loaded. Using DOMParser
 * and then reinserting all script tags allows us to get a consistent
 * DOM regardless of whether the scripts load or not (which can cause
 * flakes). See tests in content_frame.test.js that illustrate this
 * effect.
 */
// #if process.env.NODE_ENV === "test"
// const writeToIFrameThenLoadScripts = (iframeEl, html) => {
//   const parser = new DOMParser();
//   const parsedHTMLDocument = parser.parseFromString(html, "text/html");
// 
//   const iframeDocument = iframeEl.contentWindow.document;
//   const newDocFragment = iframeDocument.createDocumentFragment();
//   while (parsedHTMLDocument.childNodes.length > 0) {
//     newDocFragment.appendChild(parsedHTMLDocument.childNodes[0]);
//   }
// 
//   newDocFragment.querySelectorAll("script").forEach((brokenScript) => {
//     const fixedScript = iframeDocument.createElement("script");
//     if (brokenScript.src != null) {
//       fixedScript.src = brokenScript.src;
//     }
//     if (brokenScript.innerText != null) {
//       fixedScript.innerText = brokenScript.innerText;
//     }
//     fixedScript.type = brokenScript.type;
//     fixedScript.async = brokenScript.async;
//     brokenScript.parentNode.replaceChild(fixedScript, brokenScript);
//   });
// 
//   iframeDocument.replaceChild(newDocFragment);
// };
// #endif

var ContentFrame = function () {
  // #if process.env.NODE_ENV === "test"
  //   reset() {
  //     this._messenger.reset();
  //   }
  // #endif

  function ContentFrame(_ref) {
    var _this = this;

    var envData = _ref.envData,
        containerEl = _ref.containerEl,
        processedHTML = _ref.processedHTML,
        _ref$name = _ref.name,
        name = _ref$name === undefined ? "default" : _ref$name;

    _classCallCheck(this, ContentFrame);

    this._iframeEl = document.createElement("iframe");

    // NOTE(dan): In the iOS WKWebView, nested iframes with the same src as
    // an ancestor iframe's src are not rendered to prevent infinite recursion.
    // You can see an example of this in
    // $REPOS/liftoff/exp/dan/nested-iframe-test. Below, about:blank (as opposed
    // to an arbitrary domain) prevents an additional request from being made in
    // Chrome. The query string was randomly chosen because about:blank on its
    // own is treated as equivalent to a src of "".
    if (envData.getDevicePlatform() === __WEBPACK_IMPORTED_MODULE_3__constants__["K" /* PLATFORM_IOS */]) {
      this._iframeEl.src = "about:blank?ym7eqam2cvea2hjm";
    }

    // NOTE(Austin): Maybe also worth it to investigate
    // the sandbox attribute here.
    Object.assign(this._iframeEl.style, {
      width: "100%",
      height: "100%",
      border: 0
    });
    containerEl.appendChild(this._iframeEl);
    this._messenger = Object(__WEBPACK_IMPORTED_MODULE_0__messenger__["a" /* makeIframeMessenger */])(this._iframeEl, name);

    // We can construct promises here that don't involve callback arguments and
    // only are intended to be received once to avoid race conditions.
    this._initPromise = new Promise(function (resolve) {
      _this._messenger.once(__WEBPACK_IMPORTED_MODULE_2__messages__["e" /* MESSAGE_INNER_ENV_INIT_COMPLETE */], function () {
        resolve(_this);
      });
    });

    this._lastAllInteractionData = null;
    this.onInteractionChange(function (allInteractionData) {
      _this._lastAllInteractionData = allInteractionData;
    });

    this._isTresensaCreative = false;
    this.onTresensaInteraction(function () {
      _this._isTresensaCreative = true;
    });

    // document.write fails in some cases (e.g. if the entire creative is
    // within a sandboxed iframe), while srcdoc fails in other cases
    // (which we don't totally understand), so we try both if necessary.
    // (This was found in A/B tests to work better than using either
    // method alone.)
    try {
      // #if process.env.NODE_ENV === "test"
      //       writeToIFrameThenLoadScripts(this._iframeEl, processedHTML);
      // #endif
      // #if process.env.NODE_ENV !== "test"
      var iframeWindow = this._iframeEl.contentWindow;
      iframeWindow.document.open();
      iframeWindow.document.write(processedHTML);
      iframeWindow.document.close();
      // #endif
    } catch (_) {
      // NOTE(dan): This will overwrite the src attribute which is set above.
      this._iframeEl.srcdoc = processedHTML;
    }
  }

  _createClass(ContentFrame, [{
    key: "_processInteractionPosition",
    value: function _processInteractionPosition(interactionData) {
      var _iframeEl$getBounding = this._iframeEl.getBoundingClientRect(),
          iframeLeft = _iframeEl$getBounding.left,
          iframeTop = _iframeEl$getBounding.top;

      var x = interactionData.x,
          startX = interactionData.startX,
          y = interactionData.y,
          startY = interactionData.startY;

      var absoluteInteractionPosition = {
        x: x == null ? null : x + iframeLeft,
        y: y == null ? null : y + iframeTop,
        startX: startX == null ? null : startX + iframeLeft,
        startY: startY == null ? null : startY + iframeTop
      };
      return Object.assign({}, interactionData, absoluteInteractionPosition);
    }
  }, {
    key: "_processAllInteractionData",
    value: function _processAllInteractionData(allInteractionData) {
      // allInteractionData can be null when the inner_env's
      // interaction monitor did not receive any events but
      // the frame navigated away anyways.
      return allInteractionData && Object.assign({}, allInteractionData, {
        lastInteraction: this._processInteractionPosition(allInteractionData.lastInteraction)
      });
    }
  }, {
    key: "getInitCompletePromise",
    value: function getInitCompletePromise() {
      return this._initPromise;
    }
  }, {
    key: "onClickthrough",
    value: function onClickthrough(callback) {
      var _this2 = this;

      this._messenger.on(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* MESSAGE_CLICKTHROUGH */], function (interceptedDestinationURL, customerQueryParams) {
        callback(interceptedDestinationURL, _this2._lastAllInteractionData, customerQueryParams, _this2._isTresensaCreative);
      });

      this._messenger.on(__WEBPACK_IMPORTED_MODULE_2__messages__["o" /* MESSAGE_VUNGLE_CLICKTHROUGH */], function () {
        callback(null, _this2._lastAllInteractionData, {});
      });
    }
  }, {
    key: "onError",
    value: function onError(callback) {
      this._messenger.on(__WEBPACK_IMPORTED_MODULE_2__messages__["d" /* MESSAGE_INNER_ENV_ERROR */], function (normalizedError) {
        callback(normalizedError);
      });
    }
  }, {
    key: "onMraidCall",
    value: function onMraidCall(callback) {
      this._messenger.on(__WEBPACK_IMPORTED_MODULE_2__messages__["g" /* MESSAGE_MRAID_CALL */], callback);
    }
  }, {
    key: "updateMraidProperties",
    value: function updateMraidProperties(newMraidProperties) {
      this._messenger.post(__WEBPACK_IMPORTED_MODULE_2__messages__["n" /* MESSAGE_UPDATED_MRAID_PROPERTIES */], newMraidProperties);
    }
  }, {
    key: "notifyOfMraidEvent",
    value: function notifyOfMraidEvent(eventName) {
      for (var _len = arguments.length, callbackArgs = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        callbackArgs[_key - 1] = arguments[_key];
      }

      this._messenger.post(__WEBPACK_IMPORTED_MODULE_2__messages__["h" /* MESSAGE_MRAID_EVENT */], eventName, callbackArgs);
    }
  }, {
    key: "notifyOfMraidError",
    value: function notifyOfMraidError(errorMessage, methodName) {
      this.notifyOfMraidEvent(__WEBPACK_IMPORTED_MODULE_1__mraid_constants__["b" /* MRAID_EVENT_ERROR */], errorMessage, methodName);
    }
  }, {
    key: "notifyOfInitComplete",
    value: function notifyOfInitComplete() {
      this._messenger.post(__WEBPACK_IMPORTED_MODULE_2__messages__["i" /* MESSAGE_OUTER_ENV_INIT_COMPLETE */]);
    }
  }, {
    key: "notifyOfResize",
    value: function notifyOfResize() {
      this._messenger.post(__WEBPACK_IMPORTED_MODULE_2__messages__["k" /* MESSAGE_RESIZE */]);
    }
  }, {
    key: "onInteractionChange",
    value: function onInteractionChange(callback) {
      var _this3 = this;

      this._messenger.on(__WEBPACK_IMPORTED_MODULE_2__messages__["f" /* MESSAGE_INTERACTION_CHANGE */], function (allInteractionData) {
        callback(_this3._processAllInteractionData(allInteractionData));
      });
    }
  }, {
    key: "onTresensaInteraction",
    value: function onTresensaInteraction(callback) {
      this._messenger.on(__WEBPACK_IMPORTED_MODULE_2__messages__["m" /* MESSAGE_TRESENSA_INTERACTION */], callback);
    }
  }, {
    key: "onMadeSound",
    value: function onMadeSound(callback) {
      this._messenger.on(__WEBPACK_IMPORTED_MODULE_2__messages__["b" /* MESSAGE_CREATIVE_MADE_SOUND */], callback);
    }
  }, {
    key: "setMuted",
    value: function setMuted(shouldMute) {
      this._messenger.post(__WEBPACK_IMPORTED_MODULE_2__messages__["l" /* MESSAGE_TOGGLE_MUTED */], shouldMute);
    }
  }, {
    key: "getDOMSnapshot",
    value: function getDOMSnapshot() {
      var _this4 = this;

      return new Promise(function (resolve) {
        // Timeout after 1 second so we ensure the html return is posted.
        setTimeout(function () {
          resolve("<-- Timeout retrieving inner DOM snapshot -->");
        }, 1000);
        _this4._messenger.once(__WEBPACK_IMPORTED_MODULE_2__messages__["c" /* MESSAGE_DOM_SNAPSHOT */], resolve);
        _this4._messenger.post(__WEBPACK_IMPORTED_MODULE_2__messages__["j" /* MESSAGE_REQUEST_DOM_SNAPSHOT */]);
      });
    }
  }, {
    key: "containsIframe",
    value: function containsIframe() {
      var _this5 = this;

      return new Promise(function (resolve) {
        _this5._initPromise.then(function () {
          var frame = _this5._iframeEl;
          resolve(frame.contentWindow.document.querySelector("iframe") != null);
        });
      });
    }
  }]);

  return ContentFrame;
}();

/* harmony default export */ __webpack_exports__["a"] = (ContentFrame);

/***/ }),

/***/ 257:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return callMraidMethod; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return initOuterMraid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getMraidProperties; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return onMraidStateChangeEvent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__frontendlib_utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mraid_constants__ = __webpack_require__(55);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }




var lastMraid = window.mraid;
/**
 * Returns the mraid object. In some environments, it appears that the mraid
 * object gets removed as the ad is loading. See
 * https://docs.google.com/document/d/1TWLnTFlTGFc6ZJB_UXfR8QvmEa8x_d3k532fmX-13Fs
 * and https://docs.google.com/document/d/1iChTG_zLZvQzI5Opw-6kpHqRCXRYklTPpbNB7TPBFdQ.
 */
var getMraid = function getMraid() {
  lastMraid = window.mraid || lastMraid;
  return lastMraid;
};

/**
 * Returns true iff mraid is ready.
 */
var isMraidReady = function isMraidReady() {
  var mraid = getMraid();
  return mraid != null && mraid.getState != null && Object(__WEBPACK_IMPORTED_MODULE_0__frontendlib_utils__["isFunction"])(mraid.getState) && mraid.getState() !== __WEBPACK_IMPORTED_MODULE_1__mraid_constants__["j" /* MRAID_STATE_LOADING */];
};

// onError must receive (errorMessage, methodName).
var callMraidMethod = function callMraidMethod(methodName) {
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var onError = arguments[2];

  var mraid = getMraid();

  var handleError = function handleError(errorMessage) {
    // Suppress this warning in tests to avoid cluttering test output.
    // #if process.env.NODE_ENV !== "test"
    console.warn("Error calling MRAID method '" + methodName + "': " + errorMessage);
    // #endif
    if (onError == null) return;
    onError(errorMessage, methodName);
  };

  if (mraid == null) {
    handleError("MRAID is not available.");
    return null;
  }

  // According to the mraid spec, getState and addEventListener should be
  // available even before mraid is ready.
  if (methodName !== "getState" && methodName !== "addEventListener" && !isMraidReady()) {
    handleError("MRAID." + methodName + " is called before MRAID is ready.");
    return null;
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_0__frontendlib_utils__["isFunction"])(mraid[methodName])) {
    handleError("MRAID." + methodName + " is not supported in this environment.");
    return null;
  }

  try {
    return mraid[methodName].apply(mraid, _toConsumableArray(args));
  } catch (e) {
    var errorMessage = e instanceof Error ? e.message : "" + e;
    handleError(errorMessage);
    return null;
  }
};

var addEventListener = function addEventListener(eventName, cb) {
  if (eventName === __WEBPACK_IMPORTED_MODULE_1__mraid_constants__["c" /* MRAID_EVENT_EXPOSURE_CHANGE */] && getVersion() < 3) {
    return;
  }

  callMraidMethod("addEventListener", [eventName, cb]);
};

/**
 * Synchronously runs callback cb if mraid is ready; otherwise runs cb when
 * mraid is ready.
 */
var onMraidReady = function onMraidReady(cb) {
  if (isMraidReady()) {
    cb();
    return;
  }

  addEventListener("ready", cb);
};

var doesMraidSupport = function doesMraidSupport(feature) {
  return callMraidMethod("supports", [feature]);
};

var querySupports = function querySupports() {
  var isSupportedByProperty = ["sms", "tel", "calendar", "storePicture", "inlineVideo", "vpaid", "location"].reduce(function (isSupportedByFeature, property) {
    isSupportedByFeature[property] = doesMraidSupport(property);
    return isSupportedByFeature;
  }, {});

  return isSupportedByProperty;
};

/**
 * Returns mraid version as a Number, or 0 if the mraid version is
 * unavailable or cannot be parsed.
 */
var getVersion = function getVersion() {
  var version = parseFloat(callMraidMethod("getVersion"));
  return Number.isNaN(version) ? 0 : version;
};

var getOrientationProperties = function getOrientationProperties() {
  return callMraidMethod("getOrientationProperties");
};

var getCurrentAppOrientation = function getCurrentAppOrientation() {
  return getVersion() < 3 ? null : callMraidMethod("getCurrentAppOrientation");
};

var getCurrentPosition = function getCurrentPosition() {
  return callMraidMethod("getCurrentPosition");
};

var getDefaultPosition = function getDefaultPosition() {
  return callMraidMethod("getDefaultPosition");
};

var getExpandProperties = function getExpandProperties() {
  return callMraidMethod("getExpandProperties");
};

var getMaxSize = function getMaxSize() {
  return callMraidMethod("getMaxSize");
};

var getScreenSize = function getScreenSize() {
  return callMraidMethod("getScreenSize");
};

var getResizeProperties = function getResizeProperties() {
  return callMraidMethod("getResizeProperties");
};

var getLocation = function getLocation() {
  return getVersion() < 3 || !doesMraidSupport("location") ? { lat: -1, lon: -1 } : callMraidMethod("getLocation");
};

var getIsViewable = function getIsViewable() {
  return callMraidMethod("isViewable");
};

var getState = function getState() {
  return callMraidMethod("getState");
};

var currentExposure = null;
var updateCurrentExposure = function updateCurrentExposure(exposedPercentage, visibleRectangle, occlusionRectangles) {
  currentExposure = {
    exposedPercentage: exposedPercentage,
    visibleRectangle: visibleRectangle,
    occlusionRectangles: occlusionRectangles
  };
};

var initOuterMraid = function initOuterMraid() {
  onMraidReady(function () {
    addEventListener(__WEBPACK_IMPORTED_MODULE_1__mraid_constants__["c" /* MRAID_EVENT_EXPOSURE_CHANGE */], updateCurrentExposure);
  });
};

var getMraidProperties = function getMraidProperties() {
  var mraidState = getState();

  return {
    isViewable: getIsViewable(),
    supports: querySupports(),
    orientationProperties: getOrientationProperties(),
    currentAppOrientation: getCurrentAppOrientation(),
    currentPosition: getCurrentPosition(),
    defaultPosition: getDefaultPosition(),
    expandProperties: getExpandProperties(),
    maxSize: getMaxSize(),
    screenSize: getScreenSize(),
    resizeProperties: getResizeProperties(),
    location: getLocation(),
    state: mraidState,
    isAvailable: mraidState != null,
    currentExposure: currentExposure
  };
};

var onMraidStateChangeEvent = function onMraidStateChangeEvent(callback) {
  __WEBPACK_IMPORTED_MODULE_1__mraid_constants__["h" /* MRAID_STATE_CHANGE_EVENTS */].forEach(function (eventName) {
    var eventCallback = function eventCallback() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      callback.apply(undefined, [eventName].concat(args));
    };
    addEventListener(eventName, eventCallback);
  });
};

// #if process.env.NODE_ENV === "test"
// export {
//   addEventListener,
//   getExpandProperties,
//   getLocation,
//   getMraid,
//   getVersion,
//   isMraidReady,
//   onMraidReady,
// };
// #endif

/***/ }),

/***/ 28:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__frontendlib_dom_utils__ = __webpack_require__(1);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var AudioToggleIcon = function () {
  function AudioToggleIcon() {
    _classCallCheck(this, AudioToggleIcon);

    this.el = Object(__WEBPACK_IMPORTED_MODULE_0__frontendlib_dom_utils__["strToElement"])("\n      <div class=\"audio-toggle-icon\"\n          style=\"margin:10px;border-radius:25px;background-color:black;line-height:10px\">\n        <svg fill=\"#FFFFFF\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"\n          width=\"30\" height=\"30\" viewBox=\"0 0 16 16\"\n        >\n          <g class=\"audio-toggle-unmute\" transform=\"translate(8 8) scale(0.69 0.69) translate(-8 -8)\">\n            <polygon points=\"\n              14.293,14.293 1.707,1.707 1,2.414 4.586,6 4,6 4,10 7,10 11,14 11,12.414 13.586,15\n            \"></polygon>\n            <polygon points=\"11,2 7.207,5.793 11,9.586\"></polygon>\n          </g>\n          <g class=\"audio-toggle-mute\" transform=\"translate(8 8) scale(0.69 0.69) translate(-8 -8)\">\n            <polygon points=\"7,6 4,6 4,10 7,10 11,14 11,2\"></polygon>\n          </g>\n        </svg>\n      </div>\n    ");

    this.setMuted(true);
  }

  _createClass(AudioToggleIcon, [{
    key: "getElement",
    value: function getElement() {
      return this.el;
    }
  }, {
    key: "setMuted",
    value: function setMuted(muted) {
      this.el.querySelector(".audio-toggle-unmute").style.display = muted ? "" : "none";
      this.el.querySelector(".audio-toggle-mute").style.display = muted ? "none" : "";
    }
  }]);

  return AudioToggleIcon;
}();

/* harmony default export */ __webpack_exports__["a"] = (AudioToggleIcon);

/***/ }),

/***/ 29:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__monkey_patch__ = __webpack_require__(20);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



/**
 * Returns true iff `el` is a media (audio or video) element;
 */
var isMediaElement = function isMediaElement(el) {
  return el.tagName === "VIDEO" || el.tagName === "AUDIO";
};

/**
 * Assuming `el` is a playing video, returns `true` iff it has audio data.
 */
var doesVideoHaveAudio = function doesVideoHaveAudio(el) {
  return el.audioTracks != null && el.audioTracks.length > 0 || el.webkitAudioDecodedByteCount != null && el.webkitAudioDecodedByteCount > 0;
};

// Minimum bin size of a web audio analyzer node frequency spectrum. See:
// https://developer.mozilla.org/en-US/docs/Web/API/AnalyserNode/fftSize#Value.
var MIN_FFT_SIZE = 32;

/**
 * Global controller for web audio. This works by monkey-patching the
 * `AudioContext` constructor and redefining `AudioContext.destination`
 * (normally an `AudioDestinationNode` that routes sound to the speakers)
 * to a node that allows the global controller to intercept and control all
 * output. This is used by `GlobalAudioController`--it's not intended to be
 * used directly. `cb` is a function that will be called the first time any
 * `AudioContext` produces a sound.
 */

var GlobalWebAudioController = function () {
  function GlobalWebAudioController() {
    _classCallCheck(this, GlobalWebAudioController);
  }

  _createClass(GlobalWebAudioController, null, [{
    key: "reset",

    // if process.env.NODE_ENV === "test"
    /**
     * Resets all state back to it's uninitialized state.
     * Used for testing purposes.
     */
    value: function reset() {
      GlobalWebAudioController._firstSoundMade = false;
      GlobalWebAudioController._muted = null;
    }
    // #endif

  }, {
    key: "init",
    value: function init(cb) {
      GlobalWebAudioController._muted = null;
      GlobalWebAudioController._cb = cb;
      GlobalWebAudioController._firstSoundMade = false;
      GlobalWebAudioController._gainNodes = [];

      try {
        var originalAudioContext = window.AudioContext || window.webkitAudioContext;

        /**
         * An alternative to monkey-patching the `AudioContext` constructor would
         * be to monkey-patch the `AudioContext.prototype.destination` getter,
         * but this doesn't work on old (pre-getter) browsers.
         */
        window.AudioContext = window.webkitAudioContext = function AudioContext() {
          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          var audioCtx = new (Function.prototype.bind.apply(originalAudioContext, [null].concat(args)))();
          var gainNode = audioCtx.createGain();
          var analyserNode = audioCtx.createAnalyser();
          // We just want to know if the `AudioContext` is producing _any_ sound
          // and don't care about the frequency spectrum per se. We therefore used
          // the smallest allowed FFT size.
          analyserNode.fftSize = MIN_FFT_SIZE;
          var freqData = new Uint8Array(analyserNode.frequencyBinCount);
          var soundPollInterval = setInterval(function () {
            analyserNode.getByteFrequencyData(freqData);
            var i = 0;
            for (; i < freqData.length; i++) {
              if (freqData[i] !== 0) break;
            }
            if (i === freqData.length) return;
            clearInterval(soundPollInterval);
            GlobalWebAudioController._handleFirstSound();
          }, 10);
          /**
           * The resulting node structure is:
           *   input -> analyser -> gain -> destination
           * We use the analyser node to detect when the AudioContext is producing
           * sound and the gain node to globally control output.
           */
          var originalDestination = audioCtx.destination;
          analyserNode.connect(gainNode);
          gainNode.connect(originalDestination);
          gainNode.gain.value = GlobalWebAudioController._muted ? 0 : 1;
          GlobalWebAudioController._gainNodes.push(gainNode);

          Object.defineProperty(audioCtx, "destination", {
            value: analyserNode,
            // Ensure that our destination node is the only destination node.
            writable: false,
            configurable: false
          });

          return audioCtx;
        };
      } catch (_) {
        console.error("Unable to monkey-patch AudioContext");
      }
    }
  }, {
    key: "_handleFirstSound",
    value: function _handleFirstSound() {
      if (GlobalWebAudioController._firstSoundMade) return;
      GlobalWebAudioController._cb();
      GlobalWebAudioController._firstSoundMade = true;
    }

    /**
     * Mutes all `AudioContext`s when `shouldMute === true` and restores all
     * `AudioContext`s to the state set by the user when `shouldMute === false`.
     */

  }, {
    key: "setMuted",
    value: function setMuted(shouldMute) {
      if (GlobalWebAudioController._muted === shouldMute) {
        return;
      }
      GlobalWebAudioController._muted = shouldMute;
      GlobalWebAudioController._gainNodes.forEach(function (gainNode) {
        gainNode.gain.value = shouldMute ? 0 : 1;
      });
    }
  }]);

  return GlobalWebAudioController;
}();

/**
 * Utility for tracking media elements. Media elements can come into existence
 * in several different ways, which requies multiple different tricks for
 * becoming aware of their existence:
 *   1) They may exist in the DOM on page load (i.e. be embedded directly in
 *      the HTML document) - these can be detected by querying the dom for video
 *      and audio elements
 *   2) They can be produced from an HTML string (e.g. `someEl.innerHTML =
 *      "<audio ... />"`) and appended to the DOM. They must fire a "loadstart"
 *      event after being appended to the DOM, or the `load` or `play` methods
 *      may be called directly on the element. These can be detected by
 *      listening for "loadstart" events and by monkey-patching the `load` and
 *      `play` methods. This is true regardless of whether or not autoplay is
 *      true.
 *   3) `document.createElement` - these are detected by monkey-patching
 *      `Document.prototype.createElement`. These won't be caught by the
 *      approaches in 2 if the "autoplay" attribute is set to `true` (since they
 *      can make sound without ever being explicitly loaded, played, or append
 *      to the DOM).
 *   4) The `Audio` constructor - these are detected by monkey-patching the
 *      `Audio` constructor.
 */


var MediaElementWatcher = function () {
  function MediaElementWatcher() {
    _classCallCheck(this, MediaElementWatcher);

    throw new Error("Cannot construct instances of MediaElementWatcher.");
  }

  /**
   * Initializes the class, and immediately calls function `cb` once for each
   * media element that already exists. Subsequently calls `cb` whenever a new
   * media element is created. This should only be called once.
   */


  _createClass(MediaElementWatcher, null, [{
    key: "init",
    value: function init(cb) {
      MediaElementWatcher._cb = cb;
      MediaElementWatcher._seenElements = new WeakSet();

      var originalCreateElement = Document.prototype.createElement;
      __WEBPACK_IMPORTED_MODULE_0__monkey_patch__["a" /* default */].patchFunction(Document.prototype, "createElement", function () {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        var el = originalCreateElement.apply(this, args);
        MediaElementWatcher._handleNewElement(el);
        return el;
      });

      var originalAudio = window.Audio;
      window.Audio = function Audio() {
        for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          args[_key3] = arguments[_key3];
        }

        var a = new (Function.prototype.bind.apply(originalAudio, [null].concat(args)))();
        MediaElementWatcher._handleNewElement(a);
        return a;
      };
      window.Audio.prototype = originalAudio.prototype;

      ["play", "load"].forEach(function (methodName) {
        var originalMethod = HTMLMediaElement.prototype[methodName];
        __WEBPACK_IMPORTED_MODULE_0__monkey_patch__["a" /* default */].patchFunction(HTMLMediaElement.prototype, methodName, function () {
          MediaElementWatcher._handleNewElement(this);

          for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
            args[_key4] = arguments[_key4];
          }

          return originalMethod.apply(this, args);
        });
      });

      window.addEventListener("loadstart", function (e) {
        MediaElementWatcher._handleNewElement(e.target);
      }, true);

      document.querySelectorAll("video, audio").forEach(function (el) {
        MediaElementWatcher._cb(el);
      });
    }
  }, {
    key: "_handleNewElement",
    value: function _handleNewElement(el) {
      if (!isMediaElement(el) || MediaElementWatcher._seenElements.has(el)) {
        return;
      }
      MediaElementWatcher._seenElements.add(el);
      MediaElementWatcher._cb(el);
    }
  }]);

  return MediaElementWatcher;
}();

/**
 * Global controller for media (audio and video) elements. Used by
 * `GlobalAudioController` and not intended to be used directly. `cb` is a
 * function that will be called the first time any media element can
 * produce a sound (were global control not applied).
 */


var GlobalMediaElementAudioController = function () {
  // #if process.env.NODE_ENV === "test"
  //   /**
  //    * Resets all state back to it's uninitialized state.
  //    * Used for testing purposes.
  //    */
  //   static reset() {
  //     GlobalMediaElementAudioController._firstSoundMade = false;
  //     GlobalMediaElementAudioController._globallyMuted = null;
  //   }
  // #endif

  function GlobalMediaElementAudioController() {
    _classCallCheck(this, GlobalMediaElementAudioController);

    throw new Error("Cannot construct instances of GlobalMediaElementAudioController.");
  }

  _createClass(GlobalMediaElementAudioController, null, [{
    key: "init",
    value: function init(cb) {
      GlobalMediaElementAudioController._globallyMuted = null;
      /**
       * We keep track of the values for el.muted set by the user for each media
       * el. When we globally unmute, we restore the set state (so calling
       * `GlobalMediaElementAudioController.unmute()` does not unmute
       * elements that the user has set to be muted).
       */
      GlobalMediaElementAudioController._elToSetState = new WeakMap();
      GlobalMediaElementAudioController._allMediaEls = [];
      GlobalMediaElementAudioController._firstSoundMade = false;
      GlobalMediaElementAudioController._cb = cb;

      try {
        GlobalMediaElementAudioController._originalMutedSetter = Object.getOwnPropertyDescriptor(HTMLMediaElement.prototype, "muted").set;
        var originalMutedGetter = Object.getOwnPropertyDescriptor(HTMLMediaElement.prototype, "muted").get;

        __WEBPACK_IMPORTED_MODULE_0__monkey_patch__["a" /* default */].patchSetter(HTMLMediaElement.prototype, "muted", function (val) {
          GlobalMediaElementAudioController._elToSetState.set(this, val);
          if (GlobalMediaElementAudioController._canMakeSound(this)) {
            GlobalMediaElementAudioController._handleFirstSound();
          }

          var systemMutedState = originalMutedGetter.call(this);
          if (GlobalMediaElementAudioController._globallyMuted && (systemMutedState || !val)) {
            return;
          }
          GlobalMediaElementAudioController._originalMutedSetter.call(this, val);
        });

        // Patch the "muted" getter so that it returns the value set by the user,
        // rather than the underlying "system" value.
        __WEBPACK_IMPORTED_MODULE_0__monkey_patch__["a" /* default */].patchGetter(HTMLMediaElement.prototype, "muted", function () {
          var recordedSetState = GlobalMediaElementAudioController._elToSetState.get(this);
          return recordedSetState == null ? originalMutedGetter.call(this) : recordedSetState;
        });
        // #if process.env.NODE_ENV === "test"
        //       // Expose the underlying system muted setting to tests.
        //       Object.defineProperty(HTMLMediaElement.prototype, "systemMutedState", {
        //         get: originalMutedGetter,
        //       });
        // #endif
      } catch (_) {
        /**
         * Monkey-patching will fail on old (pre-setter) browsers. In this case,
         * we have no way of keeping track of the set state.
         * (Listening for "volumechange" events doesn't work, because if we force
         * the state to `true` due to globally muting, then the event will not
         * fire if the user subsequently sets the `muted` to `true`.) In this
         * case, we just keep the page globally muted.
         */
        GlobalMediaElementAudioController._originalMutedSetter = function (mute) {
          this.muted = mute;
        };
        console.error("Unable to monkey-patch HTMLMediaElement.muted");
      }

      MediaElementWatcher.init(function (el) {
        if (!GlobalMediaElementAudioController._allMediaEls.includes(el)) {
          GlobalMediaElementAudioController._allMediaEls.push(el);
        }
        GlobalMediaElementAudioController._watchForSound(el);
        GlobalMediaElementAudioController._toggleElementMuted(el, GlobalMediaElementAudioController._globallyMuted);
      });
    }

    /**
     * Returns `true` iff `el` would be able to make a sound were it not being
     * controlled by this global controller. We consider an element able to make
     * a sound if it is either an audio element or is a video with audio tracks.
     * Assumes that `el` is in the playing state (whether or not a video has
     * audio cannot be determined for all browsers for media that are not
     * playing).
     */

  }, {
    key: "_canMakeSound",
    value: function _canMakeSound(el) {
      var isMuted = GlobalMediaElementAudioController._elToSetState.get(el);
      return !isMuted && (el.tagName === "AUDIO" || doesVideoHaveAudio(el));
    }
  }, {
    key: "_watchForSound",
    value: function _watchForSound(el) {
      if (!el.paused && GlobalMediaElementAudioController._canMakeSound(el)) {
        GlobalMediaElementAudioController._handleFirstSound();
        return;
      }

      el.addEventListener("playing", function () {
        if (!GlobalMediaElementAudioController._canMakeSound(el)) return;
        GlobalMediaElementAudioController._handleFirstSound();
      });
    }

    /**
     * Forces `el.muted` to `muted` (a boolean). Assumes that if `muted === true`,
     * the value of `el.muted` is the state set by the user.
     * (i.e. This is not idempotent.)
     */

  }, {
    key: "_toggleElementMuted",
    value: function _toggleElementMuted(el, muted) {
      if (muted) {
        GlobalMediaElementAudioController._elToSetState.set(el, el.muted);
        GlobalMediaElementAudioController._originalMutedSetter.call(el, true);
        return;
      }

      GlobalMediaElementAudioController._originalMutedSetter.call(el, GlobalMediaElementAudioController._elToSetState.get(el));
    }
  }, {
    key: "_toggleMediaMuted",
    value: function _toggleMediaMuted(muted) {
      GlobalMediaElementAudioController._allMediaEls.forEach(function (el) {
        GlobalMediaElementAudioController._toggleElementMuted(el, muted);
      });
    }
  }, {
    key: "_handleFirstSound",
    value: function _handleFirstSound() {
      if (GlobalMediaElementAudioController._firstSoundMade) return;
      GlobalMediaElementAudioController._cb();
      GlobalMediaElementAudioController._firstSoundMade = true;
    }

    /**
     * Mutes all HTML media elements when `shouldMute === true` and restores the
     * set state of all HTML media elements when `shouldMute === false`.
     */

  }, {
    key: "setMuted",
    value: function setMuted(shouldMute) {
      if (GlobalMediaElementAudioController._globallyMuted === shouldMute) {
        return;
      }
      GlobalMediaElementAudioController._toggleMediaMuted(shouldMute);
      GlobalMediaElementAudioController._globallyMuted = shouldMute;
    }
  }]);

  return GlobalMediaElementAudioController;
}();

/**
 * Global controller for all possible sources of audio in a web page, except
 * for `iframe`s. The public interface consists of only two methods:
 *   - `GlobalAudioController.setMuted` - takes a boolean indicating whether
 *      audio from all sound sources (HTML media elements and web audio) should
 *      be muted (true) or not (false);
 *   - `GlobalAudioController.onFirstSound` - receives one argument, a function
 *      that will be called immediately if the page is already making sound or
 *      otherwise will be called once when the page first makes a sound
 *      (possibly never).
 */


var GlobalAudioController = function () {
  // #if process.env.NODE_ENV === "test"
  //   /**
  //    * Just to facilitate testing of `onFirstSound` by allowing the registered
  //    * callback to be run multiple times when new sources of sound are added to
  //    * the testing environment page.
  //    */
  //   static reset() {
  //     GlobalAudioController._firstSoundMade = false;
  //     GlobalAudioController._onFirstSoundCallbacks = [];
  // 
  //     GlobalMediaElementAudioController.reset();
  //     GlobalWebAudioController.reset();
  //   }
  // #endif

  function GlobalAudioController() {
    _classCallCheck(this, GlobalAudioController);

    throw new Error("Cannot construct instances of GlobalAudioController.");
  }

  /**
   * This class is invasive insofar as implements a series of monkey patches on
   * browser API objects. We thus only initialize it when it's actually used.
   */


  _createClass(GlobalAudioController, null, [{
    key: "_init",
    value: function _init() {
      if (GlobalAudioController._initialized) {
        return;
      }
      GlobalAudioController._initialized = true;
      GlobalAudioController._firstSoundMade = false;
      GlobalAudioController._onFirstSoundCallbacks = [];

      var handleFirstSound = function handleFirstSound() {
        if (GlobalAudioController._firstSoundMade) {
          return;
        }
        GlobalAudioController._firstSoundMade = true;
        GlobalAudioController._onFirstSoundCallbacks.forEach(function (cb) {
          return cb();
        });
      };
      GlobalMediaElementAudioController.init(handleFirstSound);
      GlobalWebAudioController.init(handleFirstSound);
    }
  }, {
    key: "setMuted",
    value: function setMuted(shouldMute) {
      GlobalAudioController._init();
      GlobalMediaElementAudioController.setMuted(shouldMute);
      GlobalWebAudioController.setMuted(shouldMute);
    }
  }, {
    key: "runAfterFirstSound",
    value: function runAfterFirstSound(cb) {
      GlobalAudioController._init();
      if (GlobalAudioController._firstSoundMade) {
        cb();
        return;
      }

      GlobalAudioController._onFirstSoundCallbacks.push(cb);
    }
  }]);

  return GlobalAudioController;
}();

GlobalAudioController._initialized = false;

/* harmony default export */ __webpack_exports__["a"] = (GlobalAudioController);

/***/ }),

/***/ 36:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return applyLiftoffPolicy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return postHTMLReturn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getDOMSnapshot; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return configureHTMLReturn; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_audio_toggle_icon__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_global_audio_controller__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__madlib_liftoff_mraid__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__frontendlib_utils__ = __webpack_require__(0);






var CLOSE_Z = 99;
var WATERMARKS_Z = 98;

/**
 * Returns a close element with a countdown timer that starts at `delay` seconds.
 */
var createCloseEl = function createCloseEl(delay) {
  var closeEl = document.createElement("div");
  closeEl.id = "liftoff-close";
  Object.assign(closeEl.style, {
    display: "block",
    position: "absolute",
    top: "10px",
    right: "10px",
    width: "32px",
    height: "32px",
    zIndex: CLOSE_Z
  });
  var buttonStyles = {
    width: "100%",
    height: "100%",
    display: "block",
    position: "absolute",
    top: "0",
    left: "0",
    fontSize: "16px",
    lineHeight: "28px",
    textAlign: "center",
    border: "2px solid #FFF",
    borderRadius: "50%",
    boxSizing: "border-box",
    pointerEvents: "all"
  };
  var closeTargetEl = document.createElement("div");
  closeTargetEl.classList.add("liftoff-close-target");
  Object.assign(closeTargetEl.style, buttonStyles, {
    color: "#EEE",
    backgroundColor: "#000"
  });
  // This is a nice close X.
  closeTargetEl.innerHTML = "&#10005";
  closeTargetEl.addEventListener("click", function (e) {
    __WEBPACK_IMPORTED_MODULE_2__madlib_liftoff_mraid__["a" /* default */].close();
    e.stopPropagation();
  });
  closeEl.appendChild(closeTargetEl);
  if (delay > 0) {
    var closeDelayEl = document.createElement("div");
    closeDelayEl.classList.add("liftoff-close-delay");
    Object.assign(closeDelayEl.style, buttonStyles, {
      color: "#555",
      backgroundColor: "#BBB"
    });
    var countdown = delay;
    closeDelayEl.textContent = countdown;
    closeDelayEl.style.display = "block";
    var closeDelayInterval = setInterval(function () {
      countdown -= 1;
      if (countdown > 0) {
        closeDelayEl.textContent = countdown;
        return;
      }
      closeDelayEl.style.display = "none";
      clearInterval(closeDelayInterval);
    }, 1000);
    closeEl.appendChild(closeDelayEl);
  }
  return closeEl;
};

/**
 * Calls `callback` on the user's first interaction.
 */
var onFirstInteraction = function onFirstInteraction(callback) {
  var hasUserInteracted = false;
  var handleFirstInteraction = function handleFirstInteraction(e) {
    window.removeEventListener("mousedown", handleFirstInteraction, true);
    window.removeEventListener("touchstart", handleFirstInteraction, true);
    if (hasUserInteracted) return;
    hasUserInteracted = true;
    callback(e);
  };
  window.addEventListener("mousedown", handleFirstInteraction, true);
  window.addEventListener("touchstart", handleFirstInteraction, true);
};

/**
 * Creates an icon in the lower-right corner that allows the user to globally toggle the creative's audio on
 * and off. The toggle only appears on creatives that have autoplay audio (i.e. audio that plays prior to user
 * interaction). For creatives that have autoplay audio, the creative is globally muted by default but will
 * become globally unmuted when the user interacts with the creative.
 */
var createGlobalAudioToggle = function createGlobalAudioToggle() {
  var el = document.createElement("div");
  el.classList.add("liftoff-global-audio-toggle");
  Object.assign(el.style, {
    opacity: "0.5",
    display: "none",
    pointerEvents: "all",
    right: "0",
    bottom: "0",
    position: "absolute"
  });
  var icon = new __WEBPACK_IMPORTED_MODULE_0__lib_audio_toggle_icon__["a" /* default */]();
  var iconEl = icon.getElement();
  el.appendChild(iconEl);

  var isCurrentlyMuted = false;
  var setMuted = function setMuted(shouldMute) {
    if (shouldMute === isCurrentlyMuted) return;
    isCurrentlyMuted = shouldMute;
    __WEBPACK_IMPORTED_MODULE_1__lib_global_audio_controller__["a" /* default */].setMuted(shouldMute);
    icon.setMuted(shouldMute);
  };

  var hasUserInteracted = false;
  onFirstInteraction(function (e) {
    hasUserInteracted = true;
    // Interactions with the global audio toggle icon are handled by the click listener below.
    if (el.contains(e.target)) return;
    setMuted(false);
  });

  iconEl.addEventListener("click", function () {
    setMuted(!isCurrentlyMuted);
  });

  __WEBPACK_IMPORTED_MODULE_1__lib_global_audio_controller__["a" /* default */].runAfterFirstSound(function () {
    if (hasUserInteracted) return;
    el.style.display = "inline-block";
  });

  setMuted(true);
  return el;
};

var globallyMuteAllAudio = function globallyMuteAllAudio() {
  __WEBPACK_IMPORTED_MODULE_1__lib_global_audio_controller__["a" /* default */].setMuted(true);
};

/**
 * Performs various operations required to conform to exchange- and/or country-specific creative policies.
 * This is used by both madlib HTML and CSP (third-party) creatives.
 * Requires:
 *   - creativePolicy - An object with keys:
 *       addBorder (boolean)
 *       showAdChoices (boolean)
 *       showChineseWatermark (boolean)
 *       russianAgeRating (number)
 *   - bidContext - An object with keys: { creativeID, platform, exchange, sourceAppName, sourceAppID }
 */
var applyLiftoffPolicy = function applyLiftoffPolicy(snippetEl, _ref, _ref2) {
  var addBorder = _ref.addBorder,
      showAdChoices = _ref.showAdChoices,
      russianAgeRating = _ref.russianAgeRating,
      showChineseWatermark = _ref.showChineseWatermark,
      useCustomClose = _ref.useCustomClose,
      closeDelay = _ref.closeDelay,
      audioPolicy = _ref.audioPolicy;
  var creativeID = _ref2.creativeID,
      platform = _ref2.platform,
      exchange = _ref2.exchange,
      sourceAppName = _ref2.sourceAppName,
      sourceAppID = _ref2.sourceAppID,
      cdnURL = _ref2.cdnURL;

  var watermarksEl = document.createElement("div");
  watermarksEl.classList.add("liftoff-watermarks");
  Object.assign(watermarksEl.style, {
    position: "absolute",
    bottom: "0",
    left: "0",
    zIndex: "" + WATERMARKS_Z,
    height: "18px",
    pointerEvents: "none"
  });

  /**
   * Creates an element to apply a border around the whole creative (required for banners on certain
   * exchanges). We do this rather than adding a border directly to `#liftoff-snippet`, because the latter
   * changes the size of the snippet content by 2 * border-width, resulting in slightly inconsistent
   * rendering depending on whether the border is there or not.
   */
  if (addBorder) {
    var el = document.createElement("div");
    el.id = "liftoff-border";
    Object.assign(el.style, {
      width: "100%",
      height: "100%",
      position: "absolute",
      border: "1px solid #AAA",
      boxSizing: "border-box",
      zIndex: "10",
      pointerEvents: "none"
    });
    document.body.appendChild(el);
  }

  if (showAdChoices) {
    // NOTE(Austin): We append these parameters for Google Analytics and more
    // granular cloudfront logs.
    var queryParams = {
      creative_id: creativeID,
      platform: platform,
      exchange: exchange,
      source_app_name: sourceAppName,
      source_app_id: sourceAppID
    };

    var a = document.createElement("a");
    a.classList.add("ad-choices-icon");
    var optoutPageURL = __WEBPACK_IMPORTED_MODULE_4__frontendlib_utils__["appendParamObjectToURL"](cdnURL + "/optout.html", queryParams);

    if (exchange === __WEBPACK_IMPORTED_MODULE_3__constants__["y" /* EXCHANGE_DOUBLECLICK */]) {
      // NOTE (Austin): Letting the click from the anchor tag intentionally take
      // the user out of the ad provides a better experience, as the in-app
      // browser is broken on some inventory (e.g., DoubleClick). Some
      // exchanges, such as Unity, open the in-app browser regardless, leading to
      // a poor user experience. Additionally, certain exchanges ignore our
      // mraid.open or window.open parameters, opening the clickthrough URL in a
      // new browser anyway.
      // TODO(Austin): Test making this the default.
      a.setAttribute("target", "_blank");
      a.setAttribute("href", optoutPageURL);
    } else {
      // NOTE(oscar): Chartboost recommends we open the ad choices link using
      // MRAID.
      a.addEventListener("click", function (e) {
        e.preventDefault();
        __WEBPACK_IMPORTED_MODULE_2__madlib_liftoff_mraid__["a" /* default */].open(optoutPageURL, { exchange: exchange, platform: platform });
      });
    }

    Object.assign(a.style, {
      width: "20px",
      height: "100%",
      display: "inline-block",
      backgroundColor: "rgba(204, 204, 204, 0.6)",
      backgroundImage: "url(" + cdnURL + "/adchoices.png)",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      backgroundSize: "12px 12px",
      pointerEvents: "all"
    });
    watermarksEl.appendChild(a);
  }

  if (russianAgeRating != null) {
    var ageTag = document.createElement("div");
    ageTag.textContent = russianAgeRating + "+";
    ageTag.classList.add("age-rating");
    Object.assign(ageTag.style, {
      color: "blue",
      fontSize: "10px",
      fontWeight: "500",
      background: "whitesmoke",
      borderRadius: "0 5px 0 0",
      padding: "0 3px",
      opacity: "0.75",
      display: "inline",
      verticalAlign: "bottom",
      pointerEvents: "none",
      lineHeight: "20px"
    });
    watermarksEl.appendChild(ageTag);
  }

  if (showChineseWatermark) {
    var _el = document.createElement("div");
    _el.classList.add("chinese-watermark");
    Object.assign(_el.style, {
      display: "inline-block",
      height: "100%",
      width: "42px",
      pointerEvents: "none",
      backgroundColor: "rgba(204, 204, 204, 0.6)",
      backgroundImage: "url(" + cdnURL + "/chinese_watermark.png)",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      backgroundSize: "contain"
    });
    watermarksEl.appendChild(_el);
  }

  if (audioPolicy === __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* AUDIO_POLICY_ALWAYS_MUTE */]) {
    globallyMuteAllAudio();
  } else if (audioPolicy === __WEBPACK_IMPORTED_MODULE_3__constants__["c" /* AUDIO_POLICY_ON_INTERACTION */]) {
    var globalAudioToggleEl = createGlobalAudioToggle();
    snippetEl.appendChild(globalAudioToggleEl);
  }

  __WEBPACK_IMPORTED_MODULE_2__madlib_liftoff_mraid__["a" /* default */].useCustomClose(useCustomClose).then(function (isUsingCustomClose) {
    if (!isUsingCustomClose) return;
    var closeEl = createCloseEl(closeDelay);
    snippetEl.appendChild(closeEl);
  });

  snippetEl.appendChild(watermarksEl);
  return snippetEl;
};

var postHTMLReturn = function postHTMLReturn(adexpEndpoint, html) {
  return __WEBPACK_IMPORTED_MODULE_4__frontendlib_utils__["request"]("POST", adexpEndpoint + "/html_return", {
    // Don't set the content type to "application/json" because that requires
    // a preflight OPTIONS request (because this is a cross-domain request).
    "Content-Type": "text/plain"
  }, html);
};

var getDOMSnapshot = function getDOMSnapshot() {
  return document.documentElement.outerHTML;
};

/**
 * Given `adexpEndpoint` (the AdExp host as a `String`), this sends an HTML
 * return after `htmlReturnDelay` ms. Returns a `Promise` that resolves when
 * the HTML return HTTP request is complete.
 */
var configureHTMLReturn = function configureHTMLReturn(adexpEndpoint, htmlReturnDelay) {
  var postHTML = function postHTML() {
    console.info("Returning HTML");
    return postHTMLReturn(adexpEndpoint, getDOMSnapshot());
  };

  if (htmlReturnDelay == null || htmlReturnDelay === 0) {
    // NOTE(oscar): A delay of 0 ideally should return the DOM before any JS
    // manipulation, so we capture the state of the DOM immediately.
    return postHTML();
  }

  return new Promise(function (resolve, reject) {
    setTimeout(function () {
      return postHTML().then(resolve, reject);
    }, htmlReturnDelay);
  });
};

/***/ }),

/***/ 37:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export throttle */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return intentionalInteractionCounterFn; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cta__ = __webpack_require__(21);


var throttle = function throttle(f, ms) {
  var ignore = false;

  return function () {
    if (ignore) return;
    f.apply(undefined, arguments);
    ignore = true;
    setTimeout(function () {
      ignore = false;
    }, ms);
  };
};

var intentionalInteractionCounterFn = function intentionalInteractionCounterFn(minimumInteractions) {
  /**
   * InteractionMonitor has somewhat imperfect de-duplication logic for what
   * counts as a full interaction. It also doesn't account for intentional
   * interactions. Also note that onInteractionChange() triggers for every
   * start, drag, and end event.
   *
   * For our purposes, we'll use both InteractionMonitor's count and a custom
   * counter.
   */
  var intentionalInteractionsFromMonitor = new Set();
  var intentionalInteractionCountFromThrottle = 0;

  var countIntentionalInteractionThrottle = throttle(function () {
    intentionalInteractionCountFromThrottle += 1;
  },
  /** Count interactions only once every 0.4 seconds. */
  400);

  var getCurrentCount = function getCurrentCount() {
    return Math.min(intentionalInteractionCountFromThrottle, intentionalInteractionsFromMonitor.size);
  };

  var countIntentionalInteractions = function countIntentionalInteractions(e) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__cta__["b" /* isDeadzoneCoord */])({
      x: e.lastInteraction.startX,
      y: e.lastInteraction.startY
    })) {
      return;
    }
    /**
     * NOTE(oscar): e.cumulativeStats.interactionCount is only incremented for
     * full interactions (or at least in theory). It also counts deadzone
     * interactions. Here we use interactionCount to identify which counts are
     * intentional.
     */
    if (e.cumulativeStats.interactionCount > 0 && intentionalInteractionsFromMonitor.size <= minimumInteractions) {
      intentionalInteractionsFromMonitor.add(e.cumulativeStats.interactionCount);
    }
    countIntentionalInteractionThrottle();
  };
  return function (e) {
    countIntentionalInteractions(e);
    return getCurrentCount();
  };
};

/***/ }),

/***/ 39:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addDeadzoneStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__frontendlib_dom_utils__ = __webpack_require__(1);


/** TODO(oscar): This is a temporary solution to add deadzones to CSPs. */
var addDeadzoneStyles = function addDeadzoneStyles() {
  var el = Object(__WEBPACK_IMPORTED_MODULE_0__frontendlib_dom_utils__["strToElement"])("\n  <style>\n    .liftoff-deadzone.deadzone-experiment {\n      position: absolute;\n      width: max(50px, min(85px, 11vw));\n      height: max(50px, min(85px, 11vw));\n      z-index: 96;\n    }\n    .liftoff-deadzone.top-left {\n      top: 0;\n      left: 0;\n    }\n    .liftoff-deadzone.top-right {\n      top: 0;\n      right: 0;\n    }\n  </style>\n  ");
  document.head.appendChild(el);
};

var addDeadzones = function addDeadzones(useExpandedZones) {
  var rootEl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.body;

  var deadzoneEls = [Object(__WEBPACK_IMPORTED_MODULE_0__frontendlib_dom_utils__["strToElement"])("<div class=\"liftoff-deadzone top-left\"></div>"), Object(__WEBPACK_IMPORTED_MODULE_0__frontendlib_dom_utils__["strToElement"])("<div class=\"liftoff-deadzone top-right\"></div>")];
  deadzoneEls.forEach(function (el) {
    if (useExpandedZones) {
      el.classList.add("deadzone-experiment");
    }
    rootEl.appendChild(el);
  });
};

/* harmony default export */ __webpack_exports__["b"] = (addDeadzones);

/***/ }),

/***/ 5:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adexp__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__error_handling__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__frontendlib_utils__ = __webpack_require__(0);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





/**
 * Sends log to Adexp.
 */
var postJSON = function postJSON(url, data) {
  /**
   * TODO(oscar): Investigate if we could improve empty payloads.
   * @see https://github.com/liftoffio/liftoff/pull/25293
   */
  if (data == null) {
    console.error("No data to post for logging.");
    return Promise.resolve();
  }
  var payload = JSON.stringify(data);

  if (payload.length < 2) {
    console.error("Data could not be stringified for logging.");
    return Promise.resolve();
  }

  return Object(__WEBPACK_IMPORTED_MODULE_2__frontendlib_utils__["request"])("POST", url, {
    // Don't set the content type to "application/json" because that requires
    // a preflight OPTIONS request (because this is a cross-domain request).
    "Content-Type": "text/plain"
  }, payload).catch(function () {
    console.error("Failed to post JSON for logging.");
  });
};

var postMetricV2 = function postMetricV2(_ref, name, value) {
  var adexpContextSnapshotFn = _ref.adexpContextSnapshotFn,
      endpoint = _ref.endpoint,
      eventTrackingParam = _ref.eventTrackingParam;

  var adexpContext = adexpContextSnapshotFn();
  var payload = new __WEBPACK_IMPORTED_MODULE_0__adexp__["c" /* AdexpMessage */]({
    context: adexpContext,
    metric: new __WEBPACK_IMPORTED_MODULE_0__adexp__["d" /* AdexpMetricV2 */](name, value)
  });

  return postJSON(endpoint + "/adexp_metrics/" + eventTrackingParam, payload);
};

var Logger = function () {
  function Logger() {
    _classCallCheck(this, Logger);
  }

  _createClass(Logger, null, [{
    key: "init",

    // #if process.env.NODE_ENV === "test"
    //   static resetForTests() {
    //     delete this.enabled;
    //     delete this.loggedErrors;
    //     delete this.endpoint;
    //     delete this.eventTrackingParam;
    //     delete this.adexpContextSnapshotFn;
    //   }
    // #endif

    value: function init() {
      this.enabled = false;
      this.loggedErrors = [];
    }
  }, {
    key: "enable",
    value: function enable() {
      this.enabled = true;
    }

    /**
     * Pass the logger required context
     * @param {string} endpoint - The endpoint to which the creative will post
     * AdExp logs or metrics.
     * @param {string} eventTrackingParam - The tracking parameter string which
     * includes encoded bid context information.
     * @param {function} adexpContextSnapshotFn - A function to call that will
     * take a snapshot of the current environment and return an `AdexpContext`
     * object.
     */

  }, {
    key: "passContext",
    value: function passContext(endpoint, eventTrackingParam, adexpContextSnapshotFn) {
      this.endpoint = endpoint;
      this.eventTrackingParam = eventTrackingParam;
      this.adexpContextSnapshotFn = adexpContextSnapshotFn;
    }

    /**
     * Listens for errors that are caught by the window and reports them to adexp.
     * Don't call this if you use your own custom error handlers.
     */

  }, {
    key: "addErrorListeners",
    value: function addErrorListeners() {
      var _this = this;

      window.addEventListener("error", function (errorEvent) {
        var normalizedError = Object(__WEBPACK_IMPORTED_MODULE_1__error_handling__["c" /* normalizeErrorEvent */])(errorEvent);
        _this.recordError(normalizedError);
      });
    }

    /**
     * recordError takes an object like:
     * { message, line, column, sourceURL ... }
     * and logs the error to adexp.
     */

  }, {
    key: "recordError",
    value: function recordError(e) {
      this.recordLabeledError("error", e);
    }
  }, {
    key: "recordLabeledError",
    value: function recordLabeledError(tag, e) {
      // #if process.env.NODE_ENV !== "test"
      console.error(e);
      // #endif
      this._processError(tag, e);
    }
  }, {
    key: "_processError",
    value: function _processError(tag, errorObj) {
      if (Object(__WEBPACK_IMPORTED_MODULE_1__error_handling__["e" /* shouldIgnoreError */])(errorObj)) {
        return;
      }

      var normalizedErr = Object(__WEBPACK_IMPORTED_MODULE_1__error_handling__["b" /* normalizeError */])(errorObj);

      // Only log one error per (sourceURL, line #, message) combination. This
      // prevents noise from certain errors that are logged many times
      // from a single impression.
      var errorIdentifier = [normalizedErr.sourceURL, normalizedErr.line, normalizedErr.message].join("-");

      if (this.loggedErrors.includes(errorIdentifier)) {
        return;
      }

      this.loggedErrors.push(errorIdentifier);
      this.recordLog(tag, normalizedErr.message, new __WEBPACK_IMPORTED_MODULE_0__adexp__["a" /* AdexpJavaScriptError */](normalizedErr));
    }
  }, {
    key: "recordLog",
    value: function recordLog(tag, message, data) {
      if (!this.enabled) {
        return;
      }

      var adexpContext = this.adexpContextSnapshotFn();
      var payload = new __WEBPACK_IMPORTED_MODULE_0__adexp__["c" /* AdexpMessage */]({
        context: adexpContext,
        log: new __WEBPACK_IMPORTED_MODULE_0__adexp__["b" /* AdexpLog */](tag, message, data)
      });

      return postJSON(this.endpoint + "/adexp_log/" + this.eventTrackingParam, payload);
    }
  }, {
    key: "recordMetricV2",
    value: function recordMetricV2(name, value) {
      if (!this.enabled) {
        return Promise.resolve();
      }
      return postMetricV2({
        endpoint: this.endpoint,
        eventTrackingParam: this.eventTrackingParam,
        adexpContextSnapshotFn: this.adexpContextSnapshotFn
      }, name, value);
    }
  }, {
    key: "recordVXOnlyAdexpMetric",
    value: function recordVXOnlyAdexpMetric(name, value) {
      if (!Number.isInteger(value)) {
        console.debug("Expected an integer value for VXOnlyAdexpMetric: " + name);
        return;
      }

      return this.alwaysRecordMetricV2("custom_event", {
        name: name,
        value: value
      });
    }
  }, {
    key: "alwaysRecordMetricV2",
    value: function alwaysRecordMetricV2(name, value) {
      return postMetricV2({
        endpoint: this.endpoint,
        eventTrackingParam: this.eventTrackingParam,
        adexpContextSnapshotFn: this.adexpContextSnapshotFn
      }, name, value);
    }
  }]);

  return Logger;
}();

// TODO(oscar): Create a global Logger.


Logger.init();

/* harmony default export */ __webpack_exports__["a"] = (Logger);

/***/ }),

/***/ 55:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MRAID_EVENT_READY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MRAID_EVENT_ERROR; });
/* unused harmony export MRAID_EVENT_STATE_CHANGE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MRAID_EVENT_EXPOSURE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return MRAID_EVENT_VIEWABLE_CHANGE; });
/* unused harmony export MRAID_EVENT_SIZE_CHANGE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return MRAID_STATE_CHANGE_EVENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ALL_MRAID_EVENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return PLACEMENT_TYPE_INTERSTITIAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return PLACEMENT_TYPE_INLINE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return MRAID_ORIENTATION_PORTRAIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return MRAID_ORIENTATION_LANDSCAPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return MRAID_STATE_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return MRAID_STATE_DEFAULT; });
// See section 5.2 of the MRAID 3.0 spec at
// https://www.iab.com/wp-content/uploads/2017/07/MRAID_3.0_FINAL.pdf.
var MRAID_EVENT_READY = "ready";
var MRAID_EVENT_ERROR = "error";
var MRAID_EVENT_STATE_CHANGE = "stateChange";
var MRAID_EVENT_EXPOSURE_CHANGE = "exposureChange";
var MRAID_EVENT_VIEWABLE_CHANGE = "viewableChange";
var MRAID_EVENT_SIZE_CHANGE = "sizeChange";
var MRAID_STATE_CHANGE_EVENTS = [MRAID_EVENT_READY, MRAID_EVENT_STATE_CHANGE, MRAID_EVENT_EXPOSURE_CHANGE, MRAID_EVENT_VIEWABLE_CHANGE, MRAID_EVENT_SIZE_CHANGE];
var ALL_MRAID_EVENTS = [].concat(MRAID_STATE_CHANGE_EVENTS, [MRAID_EVENT_ERROR]);

// See section 6.2;
var PLACEMENT_TYPE_INTERSTITIAL = "interstitial";
var PLACEMENT_TYPE_INLINE = "inline";

// See section 6.4;
var MRAID_ORIENTATION_PORTRAIT = "portrait";
var MRAID_ORIENTATION_LANDSCAPE = "landscape";

var MRAID_STATE_LOADING = "loading";
var MRAID_STATE_DEFAULT = "default";

/***/ }),

/***/ 56:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getClickTrackingQueryParams; });
/* unused harmony export constructLiftoffClickURL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return handleClick; });
/* unused harmony export _forUnitTestingOnly */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__madlib_liftoff_mraid__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__madlib_logger__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__frontendlib_utils__ = __webpack_require__(0);





var getLiftoffContainerRect = function getLiftoffContainerRect() {
  // NOTE(Casey): 'liftoff-snippet' might not exist if the creative is not
  // fully initialized.
  var containerEl = document.getElementById("liftoff-snippet") || document.body;
  return containerEl.getBoundingClientRect();
};

var getClickTrackingQueryParams = function getClickTrackingQueryParams(allInteractionData) {
  var _ref = allInteractionData || {},
      lastInteraction = _ref.lastInteraction,
      cumulativeStats = _ref.cumulativeStats;

  var containerRect = getLiftoffContainerRect();

  var params = {
    // Unix timestamp of when the click is sent.
    ct: Date.now(),
    // Width of #liftoff-snippet in px.
    aw: containerRect.width.toFixed(),
    // Height of #liftoff-snippet in px.
    ah: containerRect.height.toFixed(),
    // Whether or not MRAID is supported for this impression, determined
    // empirically based on the presence/absence of the mraid object.
    m: __WEBPACK_IMPORTED_MODULE_0__madlib_liftoff_mraid__["a" /* default */].hasSupport("mraid") ? 1 : 0,
    // Total duration, in ms, that the creative was viewable prior to the
    // click. This depends on the mraid "viewableChange" event, so its
    // accuracy depends on the exchange's implementation.
    tv: __WEBPACK_IMPORTED_MODULE_0__madlib_liftoff_mraid__["a" /* default */].getViewableDurationMS()
  };

  if (lastInteraction == null) {
    return params;
  }

  // NOTE(Casey): We see some rare events that do not have x/y coordinates.
  if (lastInteraction.startX != null) {
    // The horizontal position of the click in pixels, relative to the
    // upper-left corner of #liftoff-snippet.
    params.cx = (lastInteraction.startX - containerRect.left).toFixed();
  }

  if (lastInteraction.startY != null) {
    // The vertical position of the click in pixels, relative to the
    // upper-left corner of #liftoff-snippet.
    params.cy = (lastInteraction.startY - containerRect.top).toFixed();
  }

  if (lastInteraction.durationMS != null) {
    // Duration in milliseconds of the click, as measured by the difference
    // between timestamps on the start and end events (e.g. touchstart and
    // touchend).
    params.dur = lastInteraction.durationMS.toFixed();
  }

  Object.assign(params, {
    // The value of Event.isTrusted (see
    // https://developer.mozilla.org/en-US/docs/Web/API/Event/isTrusted).
    it: lastInteraction.isTrusted ? 1 : 0,
    // Maximum force of the interaction on a 0-100 scale. derived from
    // Touch.force (for TouchEvents), MouseEvent.webkitForce, or
    // PointerEvent.pressure.  This may be 0 or have some arbitrary value if
    // the pointer device/surface doesn't support force/pressure measurement.
    frc: Math.round(lastInteraction.maxForce * 100),
    // Maximum area of the screen with which the user interacted in px^2  (e.g.
    // the area of the screen covered by a finger during a click). May be 0 or
    // have some arbitrary value if the pointer device/surface doesn't support
    // area measurement.
    ar: lastInteraction.maxArea.toFixed(),
    // Path length traversed from the beginning to the end of the click, in px.
    d: lastInteraction.distance.toFixed(),
    // An enum describing the type of pointing device--Mouse, Touch, or other
    // (e.g. pen/stylus). See the constants defined in `InteractionMonitor`
    // and the corresponding definitions in rtb.proto.
    pt: lastInteraction.pointerType,
    // Total number of distinct interactions detected prior to and including the
    // click. "Distinct interactions" are bounded by start/end events or by
    // the pointing device leaving the creative.
    ic: cumulativeStats.interactionCount,
    // Total path length of all interactions.
    tid: cumulativeStats.totalDistance.toFixed()
  });

  return params;
};

/**
 * Given a baseClickURL (a string), attaches the caller's query
 * parameters provided as an object, and returns a string.
 */
var constructLiftoffClickURL = function constructLiftoffClickURL(baseClickURL, queryParams) {
  return __WEBPACK_IMPORTED_MODULE_3__frontendlib_utils__["appendParamObjectToURL"](baseClickURL, queryParams);
};

/**
 * Returns a Promise that resolves when the tracking pixel at url is loaded.
 */
var pingTrackingURLWithImage = function pingTrackingURLWithImage(url) {
  return new Promise(function (resolve) {
    // NOTE(Austin): Image is a the best method here as far as we know because
    // it's a foolproof way to get a no-cors request and avoid any strange
    // behavior with XMLHttpRequest. One downside is that Image only tells us
    // when it's fully loaded, and technically we don't need to wait that long.
    // We technically only need to wait for the request to send (we don't need
    // to wait for the response).

    // NOTE(Casey): In some cases (e.g. SKAdNetwork impressions on some
    // exchanges), we "force" a direct clickthrough with a click-tracking URL
    // that redirects to the MMP and app store. We still use an image tag to
    // ping Usher and the MMP, but it will generate an error. We still want
    // to click through in this case.

    // TODO(Casey): Consider alternatives to this (e.g. using an iframe).

    var img = new Image();
    img.onload = function () {
      return resolve(url);
    };

    // TODO(Austin): Investigate if there are errors here that should be
    // rejected.
    img.onerror = function () {
      return resolve(url);
    };
    img.src = url;
  }).catch(function (e) {
    __WEBPACK_IMPORTED_MODULE_1__madlib_logger__["a" /* default */].recordLabeledError("clicktracking_img_error", e || {});
  });
};

/**
 * pingTrackingURLWithBeacon sends a ping using the beacon API,
 * which guarantees that the url will be reached before the page is disposed.
 * See: https://developer.mozilla.org/en-US/docs/Web/API/Beacon_API
 */
var pingTrackingURLWithBeacon = function pingTrackingURLWithBeacon(url) {
  return new Promise(function (resolve, reject) {
    if (navigator.sendBeacon(url)) {
      resolve();
    } else {
      reject();
    }
  });
};

/**
 * NOTE(Casey): When the return_js=true query param is attached to an Usher URL,
 * Usher will return a JavaScript file containing
 * '_loOpen("{{HTTP_REDIRECT_URL}}")'. For unknown reasons, this
 * method for fetching the redirect URL works better than fetching it via XHR,
 * possibly due to CORS restrictions. See
 * https://docs.google.com/document/d/1nzlGVs9HNSY_Wd29UzoZSx1luZIwufl6yiQ8AXol7cU/
 */
var clickthroughWithScriptTag = function clickthroughWithScriptTag(_ref2) {
  var clickthroughURL = _ref2.clickthroughURL,
      platform = _ref2.platform,
      exchange = _ref2.exchange,
      _ref2$abTests = _ref2.abTests,
      abTests = _ref2$abTests === undefined ? [] : _ref2$abTests,
      _ref2$onlyMraid = _ref2.onlyMraid,
      onlyMraid = _ref2$onlyMraid === undefined ? false : _ref2$onlyMraid;

  window._loOpen = function (clickURL) {
    return (
      // We assume the url returned is never a liftoff url.
      __WEBPACK_IMPORTED_MODULE_0__madlib_liftoff_mraid__["a" /* default */].open(clickURL, {
        platform: platform,
        exchange: exchange,
        abTests: abTests,
        isLiftoffURL: false,
        onlyMraid: onlyMraid
      })
    );
  };
  return new Promise(function (resolve) {
    var script = document.createElement("script");
    script.onload = resolve;
    script.onerror = function (e) {
      __WEBPACK_IMPORTED_MODULE_1__madlib_logger__["a" /* default */].recordLabeledError("click_script_error", e || {});
    };
    script.src = __WEBPACK_IMPORTED_MODULE_3__frontendlib_utils__["appendParamObjectToURL"](clickthroughURL, {
      return_js: true
    });
    document.body.appendChild(script);
  }).catch(function (e) {
    __WEBPACK_IMPORTED_MODULE_1__madlib_logger__["a" /* default */].recordLabeledError("clickthrough_error", e || {});
  });
};

/**
 * Returns true if clickTrackingURL (an object like { url, type }) is a Liftoff
 * click tracking URL.
 */
var isLiftoffClickTrackingURL = function isLiftoffClickTrackingURL(clickTrackingURL) {
  return clickTrackingURL.type === __WEBPACK_IMPORTED_MODULE_2__constants__["v" /* CLICK_TRACKING_URL_TYPE_LIFTOFF_ENDPOINT */];
};

/**
 * Prepares and pings a clickTrackingURL (an object like { url, type }); common
 * Liftoff query parameters and the caller's queryParams are attached only to
 * Liftoff clickTrackingURLs.
 */
var pingClickTrackingURL = function pingClickTrackingURL(clickTrackingURL, queryParams) {
  var abTests = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  var getClickTrackingURLString = function getClickTrackingURLString(trackingMethod) {
    // NOTE(Austin): Right now we should only have "liftoff" click tracking
    // URLs (i.e. http://click.liftoff.io/v1/campaign_click/... ).
    return isLiftoffClickTrackingURL(clickTrackingURL) ? constructLiftoffClickURL(clickTrackingURL.url, Object.assign({}, queryParams, {
      tracking_method: trackingMethod
    })) : clickTrackingURL.url;
  };

  // The waterfall of click tracking methods to try (in priority order).
  // Each object in the array should contain a map with the following
  // keys:
  // - method: The tracking method integer, as described in rtb.proto
  //           TrackingMethod.
  // - canUse: Whether the method should be tried.
  // - pingFn: The function to ping that takes a URL string and returns a
  //           promise.
  var clickTrackingWaterfall = [{
    method: __WEBPACK_IMPORTED_MODULE_2__constants__["L" /* TRACKING_METHOD_BEACON */],
    canUse: abTests != null && abTests.includes("madlib-beacon-ping-experiment") && isLiftoffClickTrackingURL(clickTrackingURL) && navigator.sendBeacon != null,
    pingFn: pingTrackingURLWithBeacon
  }, {
    method: __WEBPACK_IMPORTED_MODULE_2__constants__["M" /* TRACKING_METHOD_IMAGE */],
    canUse: true,
    pingFn: pingTrackingURLWithImage
  }];

  // Chain all promises to try each click tracking method. If the
  // method at the previous index returns a rejected promise,
  // we try the next; otherwise we return. If we reach the end without
  // any methods succeeding, this method returns a rejected promise.
  return clickTrackingWaterfall.filter(function (_ref3) {
    var canUse = _ref3.canUse;
    return canUse;
  }).reduce(function (prevPromiseFn, nextWaterfallOption) {
    return function () {
      var method = nextWaterfallOption.method,
          pingFn = nextWaterfallOption.pingFn;

      var urlString = getClickTrackingURLString(method);
      return prevPromiseFn().catch(function () {
        return pingFn(urlString);
      });
    };
  }, function () {
    return Promise.reject();
  })();
};

var handleClickTracking = function handleClickTracking(clickTrackingURLs, queryParams) {
  var abTests = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  return new Promise(function (resolve) {
    var pingCompletePromises = clickTrackingURLs.map(function (clickTrackingURL) {
      return pingClickTrackingURL(clickTrackingURL, queryParams, abTests);
    });

    Promise.all(pingCompletePromises).then(resolve);
  }).catch(function (e) {
    __WEBPACK_IMPORTED_MODULE_1__madlib_logger__["a" /* default */].recordLabeledError("clicktracking_error", e || {});
  });
};

var isLiftoffClickthroughURL = function isLiftoffClickthroughURL(clickthroughURL) {
  return clickthroughURL.type === __WEBPACK_IMPORTED_MODULE_2__constants__["k" /* CLICKTHROUGH_URL_TYPE_LIFTOFF_ENDPOINT */];
};

/**
 * Opens a clickthrough URL (object like { url, type }) using the best method
 * for the given context (platform, isReengagement).
 */
var handleClickthrough = function handleClickthrough(_ref4) {
  var clickthroughURL = _ref4.clickthroughURL,
      queryParams = _ref4.queryParams,
      exchange = _ref4.exchange,
      platform = _ref4.platform,
      isReengagement = _ref4.isReengagement,
      _ref4$abTests = _ref4.abTests,
      abTests = _ref4$abTests === undefined ? [] : _ref4$abTests;

  /**
   * NOTE(oscar): As of it 2022-10-31, we only want to use MRAID for iOS POD.
   * The main reason for this is because we want to guarantee that:
   *
   * 1. SKStoreProductViewController (i.e. App Store overlay) is used. This
   * assumes mraid is needed for this.
   * 2. The click waterfall does not also open the App Store. This is an issue
   * we've seen with AppLovin, but it may affect other exchanges.
   */
  var isAutoclick = !!queryParams.pv;

  return new Promise(function (resolve) {
    var isLiftoffURL = isLiftoffClickthroughURL(clickthroughURL);
    var urlStr = isLiftoffURL ? constructLiftoffClickURL(clickthroughURL.url, queryParams) : clickthroughURL.url;

    if (queryParams.mac || queryParams.dap) {
      // The method name here is pingClickTrackingURL we do ping clickthrough
      // URL here as this is a background click.
      pingClickTrackingURL(clickthroughURL, queryParams, abTests);
    } else {
      /**
       * NOTE(Casey): On Android, script tag clicks perform better than redirect
       * clicks, while on iOS the opposite is true. However, for reengagement on
       * iOS, trackers may use "universal links", which are special web pages that
       * deeplink to an app or redirect to the app store. These links historically
       * have not worked with redirects, so we fetch the link and send the user
       * directly.
       * NOTE(Polly): We append a suffix to certain fyber clickthrough urls when
       * the native browser should be opened upon a click. We should not use the
       * script tag when the "FYBER_OPEN_BROWSER" suffix is present in the url.
       * TODO(Casey): Test if we can now redirect to universal links on iOS
       * (we have been told that this may have been fixed).
       */
      if (isLiftoffURL && (platform === __WEBPACK_IMPORTED_MODULE_2__constants__["J" /* PLATFORM_ANDROID */] || isReengagement) && !urlStr.includes("FYBER_OPEN_BROWSER")) {
        return clickthroughWithScriptTag({
          clickthroughURL: urlStr,
          platform: platform,
          exchange: exchange,
          abTests: abTests
        });
      }

      __WEBPACK_IMPORTED_MODULE_0__madlib_liftoff_mraid__["a" /* default */].open(urlStr, {
        exchange: exchange,
        platform: platform,
        abTests: abTests,
        isLiftoffURL: isLiftoffURL,
        isAutoclick: isAutoclick
      });
    }

    resolve();
  }).catch(function (e) {
    __WEBPACK_IMPORTED_MODULE_1__madlib_logger__["a" /* default */].recordLabeledError("clickthrough_error", e || {});
  });
};

/**
 * Given clickConfig, an object like:
 *
 *   {
 *     clickthroughURL: { url, type },
 *     clickTrackingURLs: [{ url, type }, { url, type }, ...],
 *   }
 *
 * prepares all URLs as appropriate based on type, pings tracking URLs, and
 * opens the click URL using the optimal method for a given context
 * (isReengagement, platform).
 */
var handleClick = function handleClick(_ref5) {
  var clickConfig = _ref5.clickConfig,
      queryParams = _ref5.queryParams,
      isReengagement = _ref5.isReengagement,
      platform = _ref5.platform,
      exchange = _ref5.exchange,
      _ref5$abTests = _ref5.abTests,
      abTests = _ref5$abTests === undefined ? null : _ref5$abTests;

  // NOTE(oscar): Some exchanges wrap our URLs in order to track their
  // metrics. We perform an asynchronous ping to this link while redirecting
  // users to our actual link to reduce latency.

  // TODO(Casey): Determine if we can move the exchange ping URL into
  // clickTrackingURLs and handle along with our own tracking URLs.
  var exchangePingElem = document.getElementById("exchange-ping-url");

  if (exchangePingElem != null && exchangePingElem.href != null) {
    __WEBPACK_IMPORTED_MODULE_3__frontendlib_utils__["ping"](exchangePingElem.href);
  }

  var clickthroughURL = clickConfig.clickthroughURL,
      clickTrackingURLs = clickConfig.clickTrackingURLs;


  var clickthroughParams = {
    clickthroughURL: clickthroughURL,
    queryParams: queryParams,
    platform: platform,
    isReengagement: isReengagement,
    exchange: exchange,
    abTests: abTests
  };
  /**
   * Handles both clicktracking and clickthrough.
   *
   * NOTE(Austin): We are testing waiting for the exchange ping to see if there
   * is some race condition.
   *
   * TODO(Austin): Consolidate rejected promises and log errors here.
   */
  var doFullClick = function doFullClick() {
    /** Product View clicks are not tracked. */
    var promise = Promise.resolve();
    if (!queryParams.pv) {
      promise = handleClickTracking(clickTrackingURLs, queryParams, abTests);
    }

    return promise.then(function () {
      return handleClickthrough(clickthroughParams);
    });
  };

  return doFullClick();
};

var _forUnitTestingOnly = {
  pingTrackingURLWithImage: pingTrackingURLWithImage,
  isLiftoffClickTrackingURL: isLiftoffClickTrackingURL,
  pingClickTrackingURL: pingClickTrackingURL,
  handleClickTracking: handleClickTracking,
  isLiftoffClickthroughURL: isLiftoffClickthroughURL,
  clickthroughWithScriptTag: clickthroughWithScriptTag,
  handleClickthrough: handleClickthrough,
  // We re-export LiftoffMRAID for unit testing to ensure that tests and the
  // functions in this file refer to the identical LiftoffMRAID object.
  LiftoffMRAID: __WEBPACK_IMPORTED_MODULE_0__madlib_liftoff_mraid__["a" /* default */]
};

/***/ }),

/***/ 58:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__behaviors_AutoclickBehaviorCompletedDelay__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__behaviors_AutoclickBehaviorInteractionCount__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__behaviors_AutoclickBehaviorLastInteraction__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__behaviors_AutoclickBehaviorLastInteractionAndCount__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__behaviors_AutoclickBehaviorLoadDelay__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__behaviors_AutoclickBehaviorViewableDelay__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__behaviors_AutoclickBehaviorViewableDelayWithReset__ = __webpack_require__(65);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _behaviorClasses;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }










var behaviorClasses = (_behaviorClasses = {}, _defineProperty(_behaviorClasses, __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* AUTOCLICK_TYPE_COMPLETED_DELAY */], __WEBPACK_IMPORTED_MODULE_1__behaviors_AutoclickBehaviorCompletedDelay__["a" /* default */]), _defineProperty(_behaviorClasses, __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* AUTOCLICK_TYPE_INTERACTION_COUNT */], __WEBPACK_IMPORTED_MODULE_2__behaviors_AutoclickBehaviorInteractionCount__["a" /* default */]), _defineProperty(_behaviorClasses, __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* AUTOCLICK_TYPE_LAST_INTERACTION */], __WEBPACK_IMPORTED_MODULE_3__behaviors_AutoclickBehaviorLastInteraction__["a" /* default */]), _defineProperty(_behaviorClasses, __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* AUTOCLICK_TYPE_LAST_INTERACTION_AND_INTERACTION_COUNT */], __WEBPACK_IMPORTED_MODULE_4__behaviors_AutoclickBehaviorLastInteractionAndCount__["a" /* default */]), _defineProperty(_behaviorClasses, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* AUTOCLICK_TYPE_LOAD_DELAY */], __WEBPACK_IMPORTED_MODULE_5__behaviors_AutoclickBehaviorLoadDelay__["a" /* default */]), _defineProperty(_behaviorClasses, __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* AUTOCLICK_TYPE_VIEWABLE_DELAY */], __WEBPACK_IMPORTED_MODULE_6__behaviors_AutoclickBehaviorViewableDelay__["a" /* default */]), _defineProperty(_behaviorClasses, __WEBPACK_IMPORTED_MODULE_0__constants__["j" /* AUTOCLICK_TYPE_VIEWABLE_DELAY_WITH_RESET */], __WEBPACK_IMPORTED_MODULE_7__behaviors_AutoclickBehaviorViewableDelayWithReset__["a" /* default */]), _behaviorClasses);

var MONITORED_EVENTS = {
  INTERACTION_EVENT: "interactionEvent",
  COMPLETED: "completed",
  ENGAGEMENT: "engagement",
  HTML_LOADED: "htmlLoaded",
  VIEWABLE: "viewable",
  VIEWABLE_CHANGE: "viewableChange"
};

var AUTOCLICK_EVENT_COUNT_CHANGE = "countChanged";

/**
 * @callback ClickthroughHandler
 * @param  {object} lastEvent - The last Interaction event.
 */

/**
 * @typedef AutoclickBehaviorConfig
 * @property {string} type - autoclick variant type.
 * @property {number} delay - In ms. Time to wait until opening App Store from
 * autoclick click.
 * @property {number} count - Max occurrences of events as determined by type.
 */

/**
 * Controls App Store On Interaction, aka. autoclick, behavior.
 * @see https://docs.google.com/document/d/1QYHzXt1oxmGIx2F63XErz7dF4SD6pxSi-1mkxxnHsUU/edit#heading=h.bypyxke51ec
 */

var Autoclick = function () {
  /**
   *
   * @param {AutoclickBehaviorConfig} behavior - Describes the autoclick behavior.
   * @param {Object} ctx
   * @param {ClickthroughHandler} ctx.clickthroughHandler
   * @returns
   */
  function Autoclick(behavior, _ref) {
    var _eventListeners;

    var clickthroughHandler = _ref.clickthroughHandler;

    _classCallCheck(this, Autoclick);

    if (behavior == null) {
      this.disable();
      return;
    }
    this._clickthroughHandler = clickthroughHandler;
    this._lastCount = 0;
    this._lastInteraction = null;

    this._behavior = behavior;
    var behaviorType = behavior == null ? null : behavior.type;
    if (behaviorClasses[behaviorType] == null) {
      console.error("Behavior class not found: " + behaviorType);
      this.disable();
      return;
    }
    /** @type {AutoclickBehaviorInteractionCount|AutoclickBehaviorCompletedDelay|AutoclickBehaviorLastInteraction|AutoclickBehaviorLastInteractionAndCount} */
    this.behaviorClass = new behaviorClasses[behaviorType]({
      autoclick: this,
      behavior: behavior,
      delayClickthroughHandler: this._handleDelayClickthrough.bind(this)
    });

    this._handleDelayClickthrough = this._handleDelayClickthrough.bind(this);

    this.eventListeners = (_eventListeners = {}, _defineProperty(_eventListeners, MONITORED_EVENTS.ENGAGEMENT, [this.behaviorClass.onEngagement.bind(this.behaviorClass)]), _defineProperty(_eventListeners, MONITORED_EVENTS.HTML_LOADED, [this.behaviorClass.onHtmlLoaded.bind(this.behaviorClass)]), _defineProperty(_eventListeners, MONITORED_EVENTS.VIEWABLE, [this.behaviorClass.onViewable.bind(this.behaviorClass)]), _defineProperty(_eventListeners, MONITORED_EVENTS.VIEWABLE_CHANGE, [this.behaviorClass.onViewableChange.bind(this.behaviorClass)]), _defineProperty(_eventListeners, MONITORED_EVENTS.COMPLETED, [this.behaviorClass.onCompleted.bind(this.behaviorClass)]), _defineProperty(_eventListeners, MONITORED_EVENTS.INTERACTION_EVENT,
    // Order matters.
    [this._recordLastInteraction.bind(this), this.behaviorClass.onInteraction.bind(this.behaviorClass)]), _defineProperty(_eventListeners, AUTOCLICK_EVENT_COUNT_CHANGE, []), _eventListeners);
  }

  _createClass(Autoclick, [{
    key: "disable",
    value: function disable() {
      this.autoclickDisabled = true;
    }
  }, {
    key: "emitInteractionEvent",
    value: function emitInteractionEvent() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      this.emit.apply(this, [MONITORED_EVENTS.INTERACTION_EVENT].concat(args));
    }
  }, {
    key: "emitInteractionPromptReachedEvent",
    value: function emitInteractionPromptReachedEvent() {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      this.emit.apply(this, [MONITORED_EVENTS.COMPLETED].concat(args));
    }
  }, {
    key: "emitHtmlLoadedEvent",
    value: function emitHtmlLoadedEvent() {
      for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      this.emit.apply(this, [MONITORED_EVENTS.HTML_LOADED].concat(args));
    }
  }, {
    key: "emitViewableEvent",
    value: function emitViewableEvent() {
      for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      this.emit.apply(this, [MONITORED_EVENTS.VIEWABLE].concat(args));
    }
  }, {
    key: "emitViewableChangeEvent",
    value: function emitViewableChangeEvent() {
      for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      this.emit.apply(this, [MONITORED_EVENTS.VIEWABLE_CHANGE].concat(args));
    }
  }, {
    key: "_recordLastInteraction",
    value: function _recordLastInteraction(e) {
      this._lastInteraction = e;
    }
  }, {
    key: "_handleDelayClickthrough",
    value: function _handleDelayClickthrough(delay) {
      var _this = this;

      clearTimeout(this._delayTimer);
      if (this.autoclickDisabled) return;

      this._delayTimer = setTimeout(function () {
        _this._clickthrough();
      }, delay || 0);
    }
  }, {
    key: "_clickthrough",
    value: function _clickthrough() {
      if (this.autoclickDisabled) return;
      this._clickthroughHandler(this._lastInteraction);
      this.disable();
    }
  }, {
    key: "emit",
    value: function emit(eventName) {
      for (var _len6 = arguments.length, args = Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
        args[_key6 - 1] = arguments[_key6];
      }

      if (this.autoclickDisabled) return;
      if (!(eventName in this.eventListeners)) {
        throw new Error("Event " + eventName + " not found!");
      }
      this.eventListeners[eventName].forEach(function (f) {
        f.apply(undefined, args);
      });
    }
  }]);

  return Autoclick;
}();

/* harmony default export */ __webpack_exports__["a"] = (Autoclick);

/***/ }),

/***/ 59:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AutoclickBehaviorAbstract__ = __webpack_require__(8);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var AutoclickBehaviorCompletedDelay = function (_AutoclickBehaviorAbs) {
  _inherits(AutoclickBehaviorCompletedDelay, _AutoclickBehaviorAbs);

  function AutoclickBehaviorCompletedDelay() {
    _classCallCheck(this, AutoclickBehaviorCompletedDelay);

    return _possibleConstructorReturn(this, (AutoclickBehaviorCompletedDelay.__proto__ || Object.getPrototypeOf(AutoclickBehaviorCompletedDelay)).apply(this, arguments));
  }

  _createClass(AutoclickBehaviorCompletedDelay, [{
    key: "onCompleted",
    value: function onCompleted() {
      this.delayClickthrough(this.getBehaviorDelay());
    }
  }]);

  return AutoclickBehaviorCompletedDelay;
}(__WEBPACK_IMPORTED_MODULE_0__AutoclickBehaviorAbstract__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (AutoclickBehaviorCompletedDelay);

/***/ }),

/***/ 60:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AutoclickBehaviorAbstract__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__autoclick_utils__ = __webpack_require__(37);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var AutoclickBehaviorInteractionCount = function (_AutoclickBehaviorAbs) {
  _inherits(AutoclickBehaviorInteractionCount, _AutoclickBehaviorAbs);

  function AutoclickBehaviorInteractionCount() {
    _classCallCheck(this, AutoclickBehaviorInteractionCount);

    return _possibleConstructorReturn(this, (AutoclickBehaviorInteractionCount.__proto__ || Object.getPrototypeOf(AutoclickBehaviorInteractionCount)).apply(this, arguments));
  }

  _createClass(AutoclickBehaviorInteractionCount, [{
    key: "init",
    value: function init() {
      this._counter = Object(__WEBPACK_IMPORTED_MODULE_1__autoclick_utils__["a" /* intentionalInteractionCounterFn */])(this.getBehaviorCount());
      this.triggered = false;
    }
  }, {
    key: "onInteraction",
    value: function onInteraction(e) {
      this.setCurrentCount(this._counter(e));

      if (!this.isCountReached() || this.triggered) return;
      this.triggered = true;

      this.delayClickthrough(this.getBehaviorDelay());
    }
  }]);

  return AutoclickBehaviorInteractionCount;
}(__WEBPACK_IMPORTED_MODULE_0__AutoclickBehaviorAbstract__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (AutoclickBehaviorInteractionCount);

/***/ }),

/***/ 61:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AutoclickBehaviorAbstract__ = __webpack_require__(8);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var AutoclickBehaviorLastInteraction = function (_AutoclickBehaviorAbs) {
  _inherits(AutoclickBehaviorLastInteraction, _AutoclickBehaviorAbs);

  function AutoclickBehaviorLastInteraction() {
    _classCallCheck(this, AutoclickBehaviorLastInteraction);

    return _possibleConstructorReturn(this, (AutoclickBehaviorLastInteraction.__proto__ || Object.getPrototypeOf(AutoclickBehaviorLastInteraction)).apply(this, arguments));
  }

  _createClass(AutoclickBehaviorLastInteraction, [{
    key: "onInteraction",
    value: function onInteraction() {
      this.delayClickthrough(this.getBehaviorDelay());
    }
  }]);

  return AutoclickBehaviorLastInteraction;
}(__WEBPACK_IMPORTED_MODULE_0__AutoclickBehaviorAbstract__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (AutoclickBehaviorLastInteraction);

/***/ }),

/***/ 62:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AutoclickBehaviorAbstract__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__autoclick_utils__ = __webpack_require__(37);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var AutoclickBehaviorLastInteractionAndCount = function (_AutoclickBehaviorAbs) {
  _inherits(AutoclickBehaviorLastInteractionAndCount, _AutoclickBehaviorAbs);

  function AutoclickBehaviorLastInteractionAndCount() {
    _classCallCheck(this, AutoclickBehaviorLastInteractionAndCount);

    return _possibleConstructorReturn(this, (AutoclickBehaviorLastInteractionAndCount.__proto__ || Object.getPrototypeOf(AutoclickBehaviorLastInteractionAndCount)).apply(this, arguments));
  }

  _createClass(AutoclickBehaviorLastInteractionAndCount, [{
    key: "init",
    value: function init() {
      this._counter = Object(__WEBPACK_IMPORTED_MODULE_1__autoclick_utils__["a" /* intentionalInteractionCounterFn */])(this.getBehaviorCount());
    }
  }, {
    key: "onInteraction",
    value: function onInteraction(e) {
      this.setCurrentCount(this._counter(e));

      this.delayClickthrough(this.getBehaviorDelay());
    }
  }]);

  return AutoclickBehaviorLastInteractionAndCount;
}(__WEBPACK_IMPORTED_MODULE_0__AutoclickBehaviorAbstract__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (AutoclickBehaviorLastInteractionAndCount);

/***/ }),

/***/ 63:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AutoclickBehaviorAbstract__ = __webpack_require__(8);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var AutoclickBehaviorLoadDelay = function (_AutoclickBehaviorAbs) {
  _inherits(AutoclickBehaviorLoadDelay, _AutoclickBehaviorAbs);

  function AutoclickBehaviorLoadDelay() {
    _classCallCheck(this, AutoclickBehaviorLoadDelay);

    return _possibleConstructorReturn(this, (AutoclickBehaviorLoadDelay.__proto__ || Object.getPrototypeOf(AutoclickBehaviorLoadDelay)).apply(this, arguments));
  }

  _createClass(AutoclickBehaviorLoadDelay, [{
    key: "onHtmlLoaded",
    value: function onHtmlLoaded() {
      this.delayClickthrough(this.getBehaviorDelay());
    }
  }]);

  return AutoclickBehaviorLoadDelay;
}(__WEBPACK_IMPORTED_MODULE_0__AutoclickBehaviorAbstract__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (AutoclickBehaviorLoadDelay);

/***/ }),

/***/ 64:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AutoclickBehaviorAbstract__ = __webpack_require__(8);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var AutoclickBehaviorViewableDelay = function (_AutoclickBehaviorAbs) {
  _inherits(AutoclickBehaviorViewableDelay, _AutoclickBehaviorAbs);

  function AutoclickBehaviorViewableDelay() {
    _classCallCheck(this, AutoclickBehaviorViewableDelay);

    return _possibleConstructorReturn(this, (AutoclickBehaviorViewableDelay.__proto__ || Object.getPrototypeOf(AutoclickBehaviorViewableDelay)).apply(this, arguments));
  }

  _createClass(AutoclickBehaviorViewableDelay, [{
    key: "onViewable",
    value: function onViewable() {
      this.delayClickthrough(this.getBehaviorDelay());
    }
  }]);

  return AutoclickBehaviorViewableDelay;
}(__WEBPACK_IMPORTED_MODULE_0__AutoclickBehaviorAbstract__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (AutoclickBehaviorViewableDelay);

/***/ }),

/***/ 65:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AutoclickBehaviorAbstract__ = __webpack_require__(8);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var AutoclickBehaviorViewableDelay = function (_AutoclickBehaviorAbs) {
  _inherits(AutoclickBehaviorViewableDelay, _AutoclickBehaviorAbs);

  function AutoclickBehaviorViewableDelay() {
    _classCallCheck(this, AutoclickBehaviorViewableDelay);

    return _possibleConstructorReturn(this, (AutoclickBehaviorViewableDelay.__proto__ || Object.getPrototypeOf(AutoclickBehaviorViewableDelay)).apply(this, arguments));
  }

  _createClass(AutoclickBehaviorViewableDelay, [{
    key: "onViewable",
    value: function onViewable() {
      this.delayClickthrough(this.getBehaviorDelay());
    }
  }, {
    key: "onViewableChange",
    value: function onViewableChange(isViewable) {
      if (!isViewable) {
        clearTimeout(this._autoclick._delayTimer);
      }
    }
  }]);

  return AutoclickBehaviorViewableDelay;
}(__WEBPACK_IMPORTED_MODULE_0__AutoclickBehaviorAbstract__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (AutoclickBehaviorViewableDelay);

/***/ }),

/***/ 68:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__frontendlib_dom_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__frontendlib_utils__ = __webpack_require__(0);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var TEMPLATE = "<div class=\"last-chance-endscreen\">\n  <svg class=\"back-cta-icon hidden\" width=\"24px\" height=\"24px\" fill=\"white\">\n    <path d=\"M12 17.414 3.293 8.707l1.414-1.414L12 14.586l7.293-7.293 1.414 1.414L12 17.414z\"/>\n  </svg>\n  <div class=\"last-chance-endscreen-container\">\n    <div class=\"inner-container hidden\">\n      <img class=\"last-chance-logo\" />\n      <div class=\"icon-container\"></div>\n      <div class=\"caption\"></div>\n      <a class=\"liftoff-link liftoff-cta\">\n        <img />\n        <div class=\"common-cta\"></div>\n      </a>\n    </div>\n  </div>\n</div>";

/**
 * @typedef AppStoreData
 * @property {string} icon - application icon.
 * @property {string} name - application name.
 * @property {string} company - application company/developer.
 * @property {number} rating - application rating on Google Play store.
 * @property {number} rating_count - number of times the app has been rated on
 * the Google Play store.
 * @property {string | number} download_count - number of times the app has been
 * downloaded from the Google Play store.
 * @property {string} content_rating - app content rating on the Google Play
 * store.
 * @property {string} screenshots - screenshots available for the app.
 * @property {string} description - app description.
 */

/**
 * Creates a Liftoff Last Chance Endscreen component which is displayed to the
 * user as an overlay HTML endscreen.
 *
 * @see https://docs.google.com/presentation/d/15EUBJUVXP2DpFbkA3hB0yE8z-iEy6C1I5tlZ-1h-jBw/edit?usp=sharing
 */

var LastChanceEndscreen = function () {
  /**
   *
   * @param {AppStoreData} appStoreData
   * @param {Object} parentEl
   * @param {function} handleClick
   * @param {boolean} validateUserClick - if true then CTA is only triggered if
   * click is invoked by the user and not programmatically.
   * @param {Object} env
   */
  function LastChanceEndscreen(appStoreData, parentEl, handleClick) {
    var validateUserClick = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var env = arguments[4];

    _classCallCheck(this, LastChanceEndscreen);

    this.appStoreData = appStoreData;
    this.parentEl = parentEl;
    this.el = __WEBPACK_IMPORTED_MODULE_0__frontendlib_dom_utils__["strToElement"](TEMPLATE);
    this.handleClick = handleClick;
    this.validateUserClick = validateUserClick;
    this.env = env;
    this.ctaText = env.cta_text || "INSTALL";
    this.autoEndCardCallCount = 0;
    this.timeout = null;

    if (this.parentEl == null) {
      console.error("Last chance endscreen was created without a parent container");
    }
    // Load app icon when the Liftoff Last Chance Endscreen instance is created.
    this.images = this.loadImages([this.appStoreData.icon]);
  }

  _createClass(LastChanceEndscreen, [{
    key: "loadImages",
    value: function loadImages(imagePaths) {
      return __WEBPACK_IMPORTED_MODULE_1__frontendlib_utils__["loadImages"](imagePaths);
    }
  }, {
    key: "prepareAutoEndcard",
    value: function prepareAutoEndcard() {
      var _this = this;

      this.el.querySelector(".caption").innerHTML = this.appStoreData.name;
      this.el.querySelector(".common-cta").innerHTML = this.ctaText.toUpperCase();
      // Show all elements in the LO last chance endscreen after app icon is
      // loaded on the browser.
      this.images.then(function (values) {
        values.forEach(function (img) {
          img.classList.add("icon");
          _this.el.querySelector(".icon-container").appendChild(img);
        });
      }).catch(function (error) {
        console.error("Error while rendering app icon: " + error.message);
      }).finally(function () {
        // This will run on success or error.
        _this.el.querySelector(".inner-container").classList.remove("hidden");
      });

      this.parentEl.appendChild(this.el);
    }
  }, {
    key: "showAutoEndcard",
    value: function showAutoEndcard() {
      if (this.env.has_html_endscreen) {
        if (this.env.platform) {
          // For adding iOS/Android specific styles on the AutoEndcard
          this.el.closest("#liftoff-snippet").classList.add(this.env.platform);
        }

        this.el.querySelector(".back-cta-icon").classList.remove("hidden");
        this.el.classList.add("rolling-up-animation");
      }
    }
  }, {
    key: "initAutoEndcard",
    value: function initAutoEndcard() {
      if (this.wasShown) return;
      this.wasShown = true;
      this.prepareAutoEndcard();
      this.showAutoEndcard();
      this.initializeEvents();
    }
  }, {
    key: "initializeEvents",
    value: function initializeEvents() {
      var _this2 = this;

      var touchstart = 0;

      // Fire CTA if user clicks anywhere on the screen.
      this.el.addEventListener("click", function (e) {
        if (!e.target.closest(".back-cta-icon")) {
          var triggerCTA = _this2.validateUserClick ? e.isTrusted : true;
          if (triggerCTA) {
            _this2.handleClick(!_this2.useInteractionMonitor ? e : _this2._lastInteraction);
          }
        }
      });

      this.el.querySelector(".back-cta-icon").addEventListener("click", function () {
        _this2.el.classList.add("rolling-down-animation");
      });

      this.el.addEventListener("touchstart", function (e) {
        touchstart = e.changedTouches[0].screenY;
      });

      this.el.addEventListener("touchend", function (e) {
        // Adding 70px buffer to avoid accidental taps on screen
        if (e.changedTouches[0].screenY > touchstart + 70) {
          _this2.el.classList.add("rolling-down-animation");
        }
      });
    }
  }]);

  return LastChanceEndscreen;
}();

/* harmony default export */ __webpack_exports__["a"] = (LastChanceEndscreen);

/***/ }),

/***/ 8:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AutoclickBehaviorAbstract = function () {
  function AutoclickBehaviorAbstract(_ref) {
    var autoclick = _ref.autoclick,
        behavior = _ref.behavior,
        delayClickthroughHandler = _ref.delayClickthroughHandler;

    _classCallCheck(this, AutoclickBehaviorAbstract);

    this._autoclick = autoclick;
    this._behavior = behavior;
    this.internalCount = 0;
    this.delayClickthroughHandler = delayClickthroughHandler;
    this.init();
  }

  /** Runs when the class is instantiated. */


  _createClass(AutoclickBehaviorAbstract, [{
    key: "init",
    value: function init() {}

    /**
     * Only relevant for types that count something like interactions.
     * @returns {number} - Minimum amount until enabling delayed clickthrough.
     */

  }, {
    key: "getBehaviorCount",
    value: function getBehaviorCount() {
      return this._behavior == null ? null : this._behavior.count;
    }
  }, {
    key: "getBehaviorType",
    value: function getBehaviorType() {
      return this._behavior == null ? null : this._behavior.type;
    }

    /**
     * How long to delay clickthrough by.
     * @returns {number} - Delay value in milliseconds.
     */

  }, {
    key: "getBehaviorDelay",
    value: function getBehaviorDelay() {
      return this._behavior == null ? null : this._behavior.delay;
    }
  }, {
    key: "isCountReached",
    value: function isCountReached() {
      return this.getCurrentCount() >= this.getBehaviorCount();
    }
  }, {
    key: "getCurrentCount",
    value: function getCurrentCount() {
      return this.internalCount;
    }
  }, {
    key: "setCurrentCount",
    value: function setCurrentCount(n) {
      if (typeof n !== "number") {
        throw new Error("n must be a number, got: " + n);
      }
      this.internalCount = n;
    }

    /** Triggers a delayed clickthrough event. */

  }, {
    key: "delayClickthrough",
    value: function delayClickthrough() {
      var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getBehaviorDelay();

      if (!this.isCountReached()) return;

      this.delayClickthroughHandler(delay);
    }

    /**
     * Triggered by the InteractionMonitor class.
     */

  }, {
    key: "onInteraction",
    value: function onInteraction(_) {}

    /**
     * Should trigger when the creative is "finished". Typically this is the moment
     * an endscreen will appear.
     */

  }, {
    key: "onCompleted",
    value: function onCompleted() {}

    /**
     * Triggers when an "engagement" event occurs. Engagement must be fired by the
     * creative or a subcomponent thereof.
     */

  }, {
    key: "onEngagement",
    value: function onEngagement() {}
  }, {
    key: "onHtmlLoaded",
    value: function onHtmlLoaded() {}
  }, {
    key: "onViewable",
    value: function onViewable() {}
  }, {
    key: "onViewableChange",
    value: function onViewableChange(_) {}
  }]);

  return AutoclickBehaviorAbstract;
}();

/* harmony default export */ __webpack_exports__["a"] = (AutoclickBehaviorAbstract);

/***/ }),

/***/ 89:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return postLiftoffMessage; });
/* unused harmony export Messenger */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return makeIframeMessenger; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return makeParentMessenger; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__messages__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logger__ = __webpack_require__(5);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




// Set this to `true` in development to log all messages passing through
// Messenger.
var ENABLE_DEV_LOGGING = false;

var makeLiftoffMessage = function makeLiftoffMessage(tag) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  return {
    isLiftoffMessage: true,
    tag: tag,
    data: data
  };
};

var postLiftoffMessage = function postLiftoffMessage(targetWindow, tag) {
  var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  var message = makeLiftoffMessage(tag, data);
  targetWindow.postMessage(message, "*");
};

var getMessageTag = function getMessageTag(message) {
  return message.tag;
};

var getMessageData = function getMessageData(message) {
  return message.data;
};

var isLiftoffMessage = function isLiftoffMessage(message) {
  return (typeof message === "undefined" ? "undefined" : _typeof(message)) === "object" && message.isLiftoffMessage === true;
};

var vungleMessages = new Set([__WEBPACK_IMPORTED_MODULE_0__messages__["o" /* MESSAGE_VUNGLE_CLICKTHROUGH */]]);
var isVungleMessage = function isVungleMessage(message) {
  return typeof message === "string" && vungleMessages.has(message);
};

var isMessageSafe = function isMessageSafe(message, targetWindow) {
  // NOTE(Austin): We don't check the origin because our messages
  // can potentially be cross-origin.
  return message.source === targetWindow || message.data && _typeof(message.data) === "object" && message.data.type === "logCustomLiftoffAnalytic";
};

var warn = function warn(name, message) {
  console.warn("[" + name + "] " + message);
};

var log = function log(name, message) {
  if (!ENABLE_DEV_LOGGING) return;
  console.log("[" + name + "] " + message);
};

var Messenger = function () {
  // #if process.env.NODE_ENV === "test"
  //   /**
  //    * Removes all mutations made by the messenger. Used for testing purposes.
  //    */
  //   reset() {
  //     window.removeEventListener("message", this.handleMessage);
  //   }
  // #endif

  /**
   * Constructs a messenger for listening and sending messages across different
   * windows (cross-origin). Arguments:
   * - targetWindow: The window you want to send to and receive from.
   * - name (optional): A name for this messenger for logging/debugging purposes.
   */
  function Messenger(targetWindow) {
    var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "default";

    _classCallCheck(this, Messenger);

    this.name = name;
    this._callbacksByTag = {};
    this._targetWindow = targetWindow;

    this.handleMessage = this.handleMessage.bind(this);
    window.addEventListener("message", this.handleMessage);
  }

  _createClass(Messenger, [{
    key: "handleMessage",
    value: function handleMessage(rawMessage) {
      var messageData = rawMessage.data;

      if (!isMessageSafe(rawMessage, this._targetWindow)) {
        warn(this.name, "Received untrusted message: " + JSON.stringify(messageData));
        return;
      }

      if (isLiftoffMessage(messageData)) {
        this.handleLiftoffMessage(messageData);
        return;
      }

      if (isVungleMessage(messageData)) {
        this.handleVungleMessage(messageData);
        return;
      }

      // Log custom event from a C.Studio custom playable.
      if (messageData.type === "logCustomLiftoffAnalytic") {
        __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].recordVXOnlyAdexpMetric(messageData.analyticsType, 1);
        return;
      }

      warn(this.name, "Received unrecognized message: " + JSON.stringify(messageData));
    }
  }, {
    key: "handleVungleMessage",
    value: function handleVungleMessage(message) {
      var messageTag = message;
      log(this.name, "Received Vungle message " + messageTag);
      var callbacks = this._callbacksByTag[messageTag] || [];
      callbacks.forEach(function (cb) {
        cb();
      });
    }
  }, {
    key: "handleLiftoffMessage",
    value: function handleLiftoffMessage(message) {
      var messageTag = getMessageTag(message);
      var callbacks = this._callbacksByTag[messageTag] || [];
      var messageData = getMessageData(message);
      log(this.name, "Received " + messageTag + ": " + JSON.stringify(messageData));
      if (!Array.isArray(messageData)) {
        warn(this.name, "Received liftoff message data that is not in an array.");
      }
      callbacks.forEach(function (cb) {
        cb.apply(undefined, _toConsumableArray(messageData));
      });
    }
  }, {
    key: "post",
    value: function post(tag) {
      for (var _len = arguments.length, data = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        data[_key - 1] = arguments[_key];
      }

      log(this.name, "Posting " + tag + ": " + JSON.stringify(data));
      postLiftoffMessage(this._targetWindow, tag, data);
    }
  }, {
    key: "on",
    value: function on(tag, callback) {
      if (this._callbacksByTag[tag] == null) {
        this._callbacksByTag[tag] = [];
      }

      this._callbacksByTag[tag].push(callback);
    }
  }, {
    key: "off",
    value: function off(tag, callback) {
      if (this._callbacksByTag[tag] == null) {
        return;
      }
      this._callbacksByTag[tag] = this._callbacksByTag[tag].filter(function (cb) {
        return cb !== callback;
      });
    }
  }, {
    key: "once",
    value: function once(tag, callback) {
      var _this = this;

      var singleCallback = function singleCallback() {
        // Important to pass the self-reference here and not `callback`.
        _this.off(tag, singleCallback);
        callback.apply(undefined, arguments);
      };
      this.on(tag, singleCallback);
    }
  }]);

  return Messenger;
}();

var makeIframeMessenger = function makeIframeMessenger(iframeEl) {
  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "default";

  var targetWindow = iframeEl.contentWindow;
  if (targetWindow == null) {
    throw new Error(["Cannot construct iframe messenger:", "the iframe's content window is not initialized"].join(" "));
  }

  return new Messenger(targetWindow, name);
};

var makeParentMessenger = function makeParentMessenger() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "default";

  var parentWindow = window.parent;
  if (parentWindow == null) {
    throw new Error("Cannot initialize a parent messenger in a context without a parent");
  }

  return new Messenger(parentWindow, name);
};

/***/ }),

/***/ 90:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__frontendlib_utils__ = __webpack_require__(0);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// TODO: Include defaults (possibly configurable) for the dev environment



var EnvData = function () {
  function EnvData(envData) {
    _classCallCheck(this, EnvData);

    this._envData = envData;
  }

  _createClass(EnvData, [{
    key: "asObject",
    value: function asObject() {
      return this._envData;
    }
  }, {
    key: "asJSON",
    value: function asJSON() {
      return JSON.stringify(this._envData);
    }
  }, {
    key: "getClickConfig",
    value: function getClickConfig() {
      return this._envData.clickConfig;
    }
  }, {
    key: "getClickthroughURL",
    value: function getClickthroughURL() {
      return this.getClickConfig().clickthroughURL.url;
    }
  }, {
    key: "getClickTrackingURLs",
    value: function getClickTrackingURLs() {
      return this.getClickConfig().clickTrackingURLs;
    }
  }, {
    key: "getExchange",
    value: function getExchange() {
      return this._envData.exchange;
    }
  }, {
    key: "getABTests",
    value: function getABTests() {
      return this._envData.abTests;
    }
  }, {
    key: "hasABTestGroup",
    value: function hasABTestGroup(abTestGroup) {
      return this._envData.abTests.includes(abTestGroup);
    }
  }, {
    key: "getAuctionID",
    value: function getAuctionID() {
      return this._envData.impression.auctionID;
    }
  }, {
    key: "getIsReengagement",
    value: function getIsReengagement() {
      return this._envData.isReengagement;
    }
  }, {
    key: "getCostModel",
    value: function getCostModel() {
      return this._envData.costModel;
    }
  }, {
    key: "getTrackingToken",
    value: function getTrackingToken() {
      return this._envData.trackingToken;
    }

    // Geo data

  }, {
    key: "getLatitude",
    value: function getLatitude() {
      return this._envData.geo.latitude;
    }
  }, {
    key: "getLongitude",
    value: function getLongitude() {
      return this._envData.geo.longitude;
    }

    // Device info

  }, {
    key: "getDeviceIDs",
    value: function getDeviceIDs() {
      // Exclude IDFA
      return Object(__WEBPACK_IMPORTED_MODULE_0__frontendlib_utils__["selectKeys"])(this._envData.device, ["idfaSHA1", "idfaMD5", "androidID", "androidIDSHA1", "androidIDMD5", "googleAID", "googleAIDSHA1"]);
    }

    /**
     * Returns an integer of the connection type as defined
     * in rtb.proto
     */

  }, {
    key: "getDeviceConnectionType",
    value: function getDeviceConnectionType() {
      return this._envData.device.connectionType;
    }

    /**
     * Returns a string of the OS version. Example "14.6.2"
     */

  }, {
    key: "getDeviceOSVersion",
    value: function getDeviceOSVersion() {
      return this._envData.device.osVersion;
    }
  }, {
    key: "getGoogleAID",
    value: function getGoogleAID() {
      return this.getDeviceIDs().googleAID;
    }
  }, {
    key: "getDeviceLanguage",
    value: function getDeviceLanguage() {
      return this._envData.device.normalizedLanguage;
    }
  }, {
    key: "getDevicePlatform",
    value: function getDevicePlatform() {
      return this._envData.device.platform;
    }
  }, {
    key: "getAppStoreData",
    value: function getAppStoreData() {
      return this._envData.appStoreData;
    }
  }, {
    key: "getDeviceIP",
    value: function getDeviceIP() {
      return this._envData.device.ip;
    }
  }, {
    key: "getDeviceModel",
    value: function getDeviceModel() {
      return this._envData.device.model;
    }

    // Campaign info

  }, {
    key: "getCampaignID",
    value: function getCampaignID() {
      return this._envData.campaign.id;
    }
  }, {
    key: "getCampaignName",
    value: function getCampaignName() {
      return this._envData.campaign.name;
    }
  }, {
    key: "getCampaignTrackingParams",
    value: function getCampaignTrackingParams() {
      return this._envData.campaign.params;
    }

    // Creative info

  }, {
    key: "getCreativeID",
    value: function getCreativeID() {
      return this._envData.creative.id;
    }
  }, {
    key: "getCreativeWidth",
    value: function getCreativeWidth() {
      return this._envData.creative.width;
    }
  }, {
    key: "getCreativeHeight",
    value: function getCreativeHeight() {
      return this._envData.creative.height;
    }
  }, {
    key: "getCreativeName",
    value: function getCreativeName() {
      return this._envData.creative.name;
    }
  }, {
    key: "getCreativeTrackingParams",
    value: function getCreativeTrackingParams() {
      return this._envData.creative.params;
    }
  }, {
    key: "getIsRewarded",
    value: function getIsRewarded() {
      return this._envData.impression.isRewarded;
    }

    // Source app info

  }, {
    key: "getSourceAppID",
    value: function getSourceAppID() {
      return this._envData.app.id;
    }
  }, {
    key: "getSourceAppName",
    value: function getSourceAppName() {
      return this._envData.app.name;
    }

    // Logging configuration

  }, {
    key: "getEnableHTMLReturn",
    value: function getEnableHTMLReturn() {
      return this._envData.loggingConfig.enableHTMLReturn;
    }
  }, {
    key: "getHTMLReturnDelay",
    value: function getHTMLReturnDelay() {
      return this._envData.loggingConfig.htmlReturnDelay;
    }
  }, {
    key: "getEnableLogging",
    value: function getEnableLogging() {
      return this._envData.loggingConfig.enableLogging;
    }
  }, {
    key: "getLoggingEndpoint",
    value: function getLoggingEndpoint() {
      return this._envData.loggingConfig.loggingEndpoint;
    }
  }, {
    key: "getEventTrackingParam",
    value: function getEventTrackingParam() {
      return this._envData.loggingConfig.eventTrackingParam;
    }

    // Creative policy

  }, {
    key: "getAudioPolicy",
    value: function getAudioPolicy() {
      return this._envData.creativePolicy.audioPolicy;
    }
  }, {
    key: "getAddBorder",
    value: function getAddBorder() {
      return this._envData.creativePolicy.addBorder;
    }
  }, {
    key: "getRussianAgeRating",
    value: function getRussianAgeRating() {
      return this._envData.creativePolicy.russianAgeRating;
    }
  }, {
    key: "getAnimationDurationLimit",
    value: function getAnimationDurationLimit() {
      return this._envData.creativePolicy.animationDurationLimit;
    }
  }, {
    key: "getBlockStrobing",
    value: function getBlockStrobing() {
      return this._envData.creativePolicy.blockStrobing;
    }
  }, {
    key: "getBlockNotifications",
    value: function getBlockNotifications() {
      return this._envData.creativePolicy.blockNotifications;
    }
  }, {
    key: "getShowChineseWatermark",
    value: function getShowChineseWatermark() {
      return this._envData.creativePolicy.showChineseWatermark;
    }
  }, {
    key: "getUseCustomClose",
    value: function getUseCustomClose() {
      return this._envData.creativePolicy.useCustomClose;
    }
  }, {
    key: "getCloseDelay",
    value: function getCloseDelay() {
      return this._envData.creativePolicy.closeDelay;
    }
  }, {
    key: "getShowAdChoices",
    value: function getShowAdChoices() {
      return this._envData.creativePolicy.showAdChoices;
    }
  }, {
    key: "getRemoveAdWrapper",
    value: function getRemoveAdWrapper() {
      return this._envData.creativePolicy.removeAdWrapper;
    }
  }, {
    key: "getIsStaffDevice",
    value: function getIsStaffDevice() {
      return this._envData.isStaffDevice;
    }
  }, {
    key: "getCDNUrl",
    value: function getCDNUrl() {
      return this._envData.cdnURL;
    }
  }, {
    key: "getIsInterstitial",
    value: function getIsInterstitial() {
      return this._envData.isInterstitial;
    }
  }, {
    key: "getPlatform",
    value: function getPlatform() {
      return this._envData.platform;
    }

    /**
     * Product View autoclick behavior. Typically, this sends the user to the app
     * store.
     */

  }, {
    key: "getPvAutoclickBehavior",
    value: function getPvAutoclickBehavior() {
      return this._envData.pvAutoclickBehavior;
    }

    /**
     * Auto viewclick behavior. A viewclick is when we send a click to the MMP
     * without also opening the app store.
     */

  }, {
    key: "getViewclickBehavior",
    value: function getViewclickBehavior() {
      return this._envData.viewclickBehavior;
    }
  }, {
    key: "getLastChanceAutoclickBehavior",
    value: function getLastChanceAutoclickBehavior() {
      return this._envData.lastChanceAutoclickBehavior;
    }
  }, {
    key: "getLastChanceInteractionAutoclickBehavior",
    value: function getLastChanceInteractionAutoclickBehavior() {
      return this._envData.lastChanceInteractionAutoclickBehavior;
    }

    /**
     * Liftoff Product View (LOPV) autoclick behavior. A LOPV is a "fake" product
     * view rendered by the creative itself.
     */

  }, {
    key: "getLopvAutoclickBehavior",
    value: function getLopvAutoclickBehavior() {
      return this._envData.lopvAutoclickBehavior;
    }
  }]);

  return EnvData;
}();

/* harmony default export */ __webpack_exports__["a"] = (EnvData);

/***/ }),

/***/ 91:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return loadLogger; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logger__ = __webpack_require__(5);
// Functions that are useful in both the outer and inner env.


// TODO(Austin): Remove this eslint ignore when we have more than one
// function exported.
// eslint-disable-next-line
var loadLogger = function loadLogger(envData, adexpContextSnapshotFn) {
  __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].passContext(envData.getLoggingEndpoint(), envData.getEventTrackingParam(), adexpContextSnapshotFn);

  if (envData.getEnableLogging()) {
    __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].enable();
  }
};

/***/ })

/******/ });


// WEBPACK FOOTER //
// outer_env-dcc57902369b8badbf21.js